import _regeneratorRuntime from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectSpread from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["reset"],
    _excluded2 = ["as", "className"],
    _excluded3 = ["as", "children", "currentlySelected", "onClick"],
    _excluded4 = ["as", "children", "currentlySelected", "onClick"];
import { lightTheme } from "./chunk-3UWCCYJY.js"; // src/components/ConnectButton/ConnectButton.tsx

import React35 from "react"; // src/css/sprinkles.css.ts

import { createMapValueFn as _51c72 } from "@vanilla-extract/sprinkles/createUtils";
import { createSprinkles as _ad221 } from "@vanilla-extract/sprinkles/createRuntimeSprinkles";

var mapResponsiveValue = _51c72({
  conditions: {
    defaultCondition: "smallScreen",
    conditionNames: ["smallScreen", "largeScreen"],
    responsiveArray: void 0
  }
});

var sprinkles = _ad221({
  conditions: {
    defaultCondition: "base",
    conditionNames: ["base", "hover", "active"],
    responsiveArray: void 0
  },
  styles: {
    background: {
      values: {
        accentColor: {
          conditions: {
            base: "sprinkles_background_accentColor_base__ju367v8o",
            hover: "sprinkles_background_accentColor_hover__ju367v8p",
            active: "sprinkles_background_accentColor_active__ju367v8q"
          },
          defaultClass: "sprinkles_background_accentColor_base__ju367v8o"
        },
        actionButtonBorder: {
          conditions: {
            base: "sprinkles_background_actionButtonBorder_base__ju367v8r",
            hover: "sprinkles_background_actionButtonBorder_hover__ju367v8s",
            active: "sprinkles_background_actionButtonBorder_active__ju367v8t"
          },
          defaultClass: "sprinkles_background_actionButtonBorder_base__ju367v8r"
        },
        actionButtonBorderMobile: {
          conditions: {
            base: "sprinkles_background_actionButtonBorderMobile_base__ju367v8u",
            hover: "sprinkles_background_actionButtonBorderMobile_hover__ju367v8v",
            active: "sprinkles_background_actionButtonBorderMobile_active__ju367v8w"
          },
          defaultClass: "sprinkles_background_actionButtonBorderMobile_base__ju367v8u"
        },
        actionButtonSecondaryBackground: {
          conditions: {
            base: "sprinkles_background_actionButtonSecondaryBackground_base__ju367v8x",
            hover: "sprinkles_background_actionButtonSecondaryBackground_hover__ju367v8y",
            active: "sprinkles_background_actionButtonSecondaryBackground_active__ju367v8z"
          },
          defaultClass: "sprinkles_background_actionButtonSecondaryBackground_base__ju367v8x"
        },
        actionButtonText: {
          conditions: {
            base: "sprinkles_background_actionButtonText_base__ju367v90",
            hover: "sprinkles_background_actionButtonText_hover__ju367v91",
            active: "sprinkles_background_actionButtonText_active__ju367v92"
          },
          defaultClass: "sprinkles_background_actionButtonText_base__ju367v90"
        },
        closeButton: {
          conditions: {
            base: "sprinkles_background_closeButton_base__ju367v93",
            hover: "sprinkles_background_closeButton_hover__ju367v94",
            active: "sprinkles_background_closeButton_active__ju367v95"
          },
          defaultClass: "sprinkles_background_closeButton_base__ju367v93"
        },
        closeButtonBackground: {
          conditions: {
            base: "sprinkles_background_closeButtonBackground_base__ju367v96",
            hover: "sprinkles_background_closeButtonBackground_hover__ju367v97",
            active: "sprinkles_background_closeButtonBackground_active__ju367v98"
          },
          defaultClass: "sprinkles_background_closeButtonBackground_base__ju367v96"
        },
        connectButtonBackground: {
          conditions: {
            base: "sprinkles_background_connectButtonBackground_base__ju367v99",
            hover: "sprinkles_background_connectButtonBackground_hover__ju367v9a",
            active: "sprinkles_background_connectButtonBackground_active__ju367v9b"
          },
          defaultClass: "sprinkles_background_connectButtonBackground_base__ju367v99"
        },
        connectButtonBackgroundError: {
          conditions: {
            base: "sprinkles_background_connectButtonBackgroundError_base__ju367v9c",
            hover: "sprinkles_background_connectButtonBackgroundError_hover__ju367v9d",
            active: "sprinkles_background_connectButtonBackgroundError_active__ju367v9e"
          },
          defaultClass: "sprinkles_background_connectButtonBackgroundError_base__ju367v9c"
        },
        connectButtonInnerBackground: {
          conditions: {
            base: "sprinkles_background_connectButtonInnerBackground_base__ju367v9f",
            hover: "sprinkles_background_connectButtonInnerBackground_hover__ju367v9g",
            active: "sprinkles_background_connectButtonInnerBackground_active__ju367v9h"
          },
          defaultClass: "sprinkles_background_connectButtonInnerBackground_base__ju367v9f"
        },
        connectButtonText: {
          conditions: {
            base: "sprinkles_background_connectButtonText_base__ju367v9i",
            hover: "sprinkles_background_connectButtonText_hover__ju367v9j",
            active: "sprinkles_background_connectButtonText_active__ju367v9k"
          },
          defaultClass: "sprinkles_background_connectButtonText_base__ju367v9i"
        },
        connectButtonTextError: {
          conditions: {
            base: "sprinkles_background_connectButtonTextError_base__ju367v9l",
            hover: "sprinkles_background_connectButtonTextError_hover__ju367v9m",
            active: "sprinkles_background_connectButtonTextError_active__ju367v9n"
          },
          defaultClass: "sprinkles_background_connectButtonTextError_base__ju367v9l"
        },
        connectionIndicator: {
          conditions: {
            base: "sprinkles_background_connectionIndicator_base__ju367v9o",
            hover: "sprinkles_background_connectionIndicator_hover__ju367v9p",
            active: "sprinkles_background_connectionIndicator_active__ju367v9q"
          },
          defaultClass: "sprinkles_background_connectionIndicator_base__ju367v9o"
        },
        error: {
          conditions: {
            base: "sprinkles_background_error_base__ju367v9r",
            hover: "sprinkles_background_error_hover__ju367v9s",
            active: "sprinkles_background_error_active__ju367v9t"
          },
          defaultClass: "sprinkles_background_error_base__ju367v9r"
        },
        generalBorder: {
          conditions: {
            base: "sprinkles_background_generalBorder_base__ju367v9u",
            hover: "sprinkles_background_generalBorder_hover__ju367v9v",
            active: "sprinkles_background_generalBorder_active__ju367v9w"
          },
          defaultClass: "sprinkles_background_generalBorder_base__ju367v9u"
        },
        generalBorderDim: {
          conditions: {
            base: "sprinkles_background_generalBorderDim_base__ju367v9x",
            hover: "sprinkles_background_generalBorderDim_hover__ju367v9y",
            active: "sprinkles_background_generalBorderDim_active__ju367v9z"
          },
          defaultClass: "sprinkles_background_generalBorderDim_base__ju367v9x"
        },
        menuItemBackground: {
          conditions: {
            base: "sprinkles_background_menuItemBackground_base__ju367va0",
            hover: "sprinkles_background_menuItemBackground_hover__ju367va1",
            active: "sprinkles_background_menuItemBackground_active__ju367va2"
          },
          defaultClass: "sprinkles_background_menuItemBackground_base__ju367va0"
        },
        modalBackdrop: {
          conditions: {
            base: "sprinkles_background_modalBackdrop_base__ju367va3",
            hover: "sprinkles_background_modalBackdrop_hover__ju367va4",
            active: "sprinkles_background_modalBackdrop_active__ju367va5"
          },
          defaultClass: "sprinkles_background_modalBackdrop_base__ju367va3"
        },
        modalBackground: {
          conditions: {
            base: "sprinkles_background_modalBackground_base__ju367va6",
            hover: "sprinkles_background_modalBackground_hover__ju367va7",
            active: "sprinkles_background_modalBackground_active__ju367va8"
          },
          defaultClass: "sprinkles_background_modalBackground_base__ju367va6"
        },
        modalBorder: {
          conditions: {
            base: "sprinkles_background_modalBorder_base__ju367va9",
            hover: "sprinkles_background_modalBorder_hover__ju367vaa",
            active: "sprinkles_background_modalBorder_active__ju367vab"
          },
          defaultClass: "sprinkles_background_modalBorder_base__ju367va9"
        },
        modalText: {
          conditions: {
            base: "sprinkles_background_modalText_base__ju367vac",
            hover: "sprinkles_background_modalText_hover__ju367vad",
            active: "sprinkles_background_modalText_active__ju367vae"
          },
          defaultClass: "sprinkles_background_modalText_base__ju367vac"
        },
        modalTextDim: {
          conditions: {
            base: "sprinkles_background_modalTextDim_base__ju367vaf",
            hover: "sprinkles_background_modalTextDim_hover__ju367vag",
            active: "sprinkles_background_modalTextDim_active__ju367vah"
          },
          defaultClass: "sprinkles_background_modalTextDim_base__ju367vaf"
        },
        modalTextSecondary: {
          conditions: {
            base: "sprinkles_background_modalTextSecondary_base__ju367vai",
            hover: "sprinkles_background_modalTextSecondary_hover__ju367vaj",
            active: "sprinkles_background_modalTextSecondary_active__ju367vak"
          },
          defaultClass: "sprinkles_background_modalTextSecondary_base__ju367vai"
        },
        profileAction: {
          conditions: {
            base: "sprinkles_background_profileAction_base__ju367val",
            hover: "sprinkles_background_profileAction_hover__ju367vam",
            active: "sprinkles_background_profileAction_active__ju367van"
          },
          defaultClass: "sprinkles_background_profileAction_base__ju367val"
        },
        profileActionHover: {
          conditions: {
            base: "sprinkles_background_profileActionHover_base__ju367vao",
            hover: "sprinkles_background_profileActionHover_hover__ju367vap",
            active: "sprinkles_background_profileActionHover_active__ju367vaq"
          },
          defaultClass: "sprinkles_background_profileActionHover_base__ju367vao"
        },
        profileForeground: {
          conditions: {
            base: "sprinkles_background_profileForeground_base__ju367var",
            hover: "sprinkles_background_profileForeground_hover__ju367vas",
            active: "sprinkles_background_profileForeground_active__ju367vat"
          },
          defaultClass: "sprinkles_background_profileForeground_base__ju367var"
        },
        selectedOptionBorder: {
          conditions: {
            base: "sprinkles_background_selectedOptionBorder_base__ju367vau",
            hover: "sprinkles_background_selectedOptionBorder_hover__ju367vav",
            active: "sprinkles_background_selectedOptionBorder_active__ju367vaw"
          },
          defaultClass: "sprinkles_background_selectedOptionBorder_base__ju367vau"
        },
        standby: {
          conditions: {
            base: "sprinkles_background_standby_base__ju367vax",
            hover: "sprinkles_background_standby_hover__ju367vay",
            active: "sprinkles_background_standby_active__ju367vaz"
          },
          defaultClass: "sprinkles_background_standby_base__ju367vax"
        }
      }
    },
    borderColor: {
      values: {
        accentColor: {
          conditions: {
            base: "sprinkles_borderColor_accentColor_base__ju367vb0",
            hover: "sprinkles_borderColor_accentColor_hover__ju367vb1",
            active: "sprinkles_borderColor_accentColor_active__ju367vb2"
          },
          defaultClass: "sprinkles_borderColor_accentColor_base__ju367vb0"
        },
        actionButtonBorder: {
          conditions: {
            base: "sprinkles_borderColor_actionButtonBorder_base__ju367vb3",
            hover: "sprinkles_borderColor_actionButtonBorder_hover__ju367vb4",
            active: "sprinkles_borderColor_actionButtonBorder_active__ju367vb5"
          },
          defaultClass: "sprinkles_borderColor_actionButtonBorder_base__ju367vb3"
        },
        actionButtonBorderMobile: {
          conditions: {
            base: "sprinkles_borderColor_actionButtonBorderMobile_base__ju367vb6",
            hover: "sprinkles_borderColor_actionButtonBorderMobile_hover__ju367vb7",
            active: "sprinkles_borderColor_actionButtonBorderMobile_active__ju367vb8"
          },
          defaultClass: "sprinkles_borderColor_actionButtonBorderMobile_base__ju367vb6"
        },
        actionButtonSecondaryBackground: {
          conditions: {
            base: "sprinkles_borderColor_actionButtonSecondaryBackground_base__ju367vb9",
            hover: "sprinkles_borderColor_actionButtonSecondaryBackground_hover__ju367vba",
            active: "sprinkles_borderColor_actionButtonSecondaryBackground_active__ju367vbb"
          },
          defaultClass: "sprinkles_borderColor_actionButtonSecondaryBackground_base__ju367vb9"
        },
        actionButtonText: {
          conditions: {
            base: "sprinkles_borderColor_actionButtonText_base__ju367vbc",
            hover: "sprinkles_borderColor_actionButtonText_hover__ju367vbd",
            active: "sprinkles_borderColor_actionButtonText_active__ju367vbe"
          },
          defaultClass: "sprinkles_borderColor_actionButtonText_base__ju367vbc"
        },
        closeButton: {
          conditions: {
            base: "sprinkles_borderColor_closeButton_base__ju367vbf",
            hover: "sprinkles_borderColor_closeButton_hover__ju367vbg",
            active: "sprinkles_borderColor_closeButton_active__ju367vbh"
          },
          defaultClass: "sprinkles_borderColor_closeButton_base__ju367vbf"
        },
        closeButtonBackground: {
          conditions: {
            base: "sprinkles_borderColor_closeButtonBackground_base__ju367vbi",
            hover: "sprinkles_borderColor_closeButtonBackground_hover__ju367vbj",
            active: "sprinkles_borderColor_closeButtonBackground_active__ju367vbk"
          },
          defaultClass: "sprinkles_borderColor_closeButtonBackground_base__ju367vbi"
        },
        connectButtonBackground: {
          conditions: {
            base: "sprinkles_borderColor_connectButtonBackground_base__ju367vbl",
            hover: "sprinkles_borderColor_connectButtonBackground_hover__ju367vbm",
            active: "sprinkles_borderColor_connectButtonBackground_active__ju367vbn"
          },
          defaultClass: "sprinkles_borderColor_connectButtonBackground_base__ju367vbl"
        },
        connectButtonBackgroundError: {
          conditions: {
            base: "sprinkles_borderColor_connectButtonBackgroundError_base__ju367vbo",
            hover: "sprinkles_borderColor_connectButtonBackgroundError_hover__ju367vbp",
            active: "sprinkles_borderColor_connectButtonBackgroundError_active__ju367vbq"
          },
          defaultClass: "sprinkles_borderColor_connectButtonBackgroundError_base__ju367vbo"
        },
        connectButtonInnerBackground: {
          conditions: {
            base: "sprinkles_borderColor_connectButtonInnerBackground_base__ju367vbr",
            hover: "sprinkles_borderColor_connectButtonInnerBackground_hover__ju367vbs",
            active: "sprinkles_borderColor_connectButtonInnerBackground_active__ju367vbt"
          },
          defaultClass: "sprinkles_borderColor_connectButtonInnerBackground_base__ju367vbr"
        },
        connectButtonText: {
          conditions: {
            base: "sprinkles_borderColor_connectButtonText_base__ju367vbu",
            hover: "sprinkles_borderColor_connectButtonText_hover__ju367vbv",
            active: "sprinkles_borderColor_connectButtonText_active__ju367vbw"
          },
          defaultClass: "sprinkles_borderColor_connectButtonText_base__ju367vbu"
        },
        connectButtonTextError: {
          conditions: {
            base: "sprinkles_borderColor_connectButtonTextError_base__ju367vbx",
            hover: "sprinkles_borderColor_connectButtonTextError_hover__ju367vby",
            active: "sprinkles_borderColor_connectButtonTextError_active__ju367vbz"
          },
          defaultClass: "sprinkles_borderColor_connectButtonTextError_base__ju367vbx"
        },
        connectionIndicator: {
          conditions: {
            base: "sprinkles_borderColor_connectionIndicator_base__ju367vc0",
            hover: "sprinkles_borderColor_connectionIndicator_hover__ju367vc1",
            active: "sprinkles_borderColor_connectionIndicator_active__ju367vc2"
          },
          defaultClass: "sprinkles_borderColor_connectionIndicator_base__ju367vc0"
        },
        error: {
          conditions: {
            base: "sprinkles_borderColor_error_base__ju367vc3",
            hover: "sprinkles_borderColor_error_hover__ju367vc4",
            active: "sprinkles_borderColor_error_active__ju367vc5"
          },
          defaultClass: "sprinkles_borderColor_error_base__ju367vc3"
        },
        generalBorder: {
          conditions: {
            base: "sprinkles_borderColor_generalBorder_base__ju367vc6",
            hover: "sprinkles_borderColor_generalBorder_hover__ju367vc7",
            active: "sprinkles_borderColor_generalBorder_active__ju367vc8"
          },
          defaultClass: "sprinkles_borderColor_generalBorder_base__ju367vc6"
        },
        generalBorderDim: {
          conditions: {
            base: "sprinkles_borderColor_generalBorderDim_base__ju367vc9",
            hover: "sprinkles_borderColor_generalBorderDim_hover__ju367vca",
            active: "sprinkles_borderColor_generalBorderDim_active__ju367vcb"
          },
          defaultClass: "sprinkles_borderColor_generalBorderDim_base__ju367vc9"
        },
        menuItemBackground: {
          conditions: {
            base: "sprinkles_borderColor_menuItemBackground_base__ju367vcc",
            hover: "sprinkles_borderColor_menuItemBackground_hover__ju367vcd",
            active: "sprinkles_borderColor_menuItemBackground_active__ju367vce"
          },
          defaultClass: "sprinkles_borderColor_menuItemBackground_base__ju367vcc"
        },
        modalBackdrop: {
          conditions: {
            base: "sprinkles_borderColor_modalBackdrop_base__ju367vcf",
            hover: "sprinkles_borderColor_modalBackdrop_hover__ju367vcg",
            active: "sprinkles_borderColor_modalBackdrop_active__ju367vch"
          },
          defaultClass: "sprinkles_borderColor_modalBackdrop_base__ju367vcf"
        },
        modalBackground: {
          conditions: {
            base: "sprinkles_borderColor_modalBackground_base__ju367vci",
            hover: "sprinkles_borderColor_modalBackground_hover__ju367vcj",
            active: "sprinkles_borderColor_modalBackground_active__ju367vck"
          },
          defaultClass: "sprinkles_borderColor_modalBackground_base__ju367vci"
        },
        modalBorder: {
          conditions: {
            base: "sprinkles_borderColor_modalBorder_base__ju367vcl",
            hover: "sprinkles_borderColor_modalBorder_hover__ju367vcm",
            active: "sprinkles_borderColor_modalBorder_active__ju367vcn"
          },
          defaultClass: "sprinkles_borderColor_modalBorder_base__ju367vcl"
        },
        modalText: {
          conditions: {
            base: "sprinkles_borderColor_modalText_base__ju367vco",
            hover: "sprinkles_borderColor_modalText_hover__ju367vcp",
            active: "sprinkles_borderColor_modalText_active__ju367vcq"
          },
          defaultClass: "sprinkles_borderColor_modalText_base__ju367vco"
        },
        modalTextDim: {
          conditions: {
            base: "sprinkles_borderColor_modalTextDim_base__ju367vcr",
            hover: "sprinkles_borderColor_modalTextDim_hover__ju367vcs",
            active: "sprinkles_borderColor_modalTextDim_active__ju367vct"
          },
          defaultClass: "sprinkles_borderColor_modalTextDim_base__ju367vcr"
        },
        modalTextSecondary: {
          conditions: {
            base: "sprinkles_borderColor_modalTextSecondary_base__ju367vcu",
            hover: "sprinkles_borderColor_modalTextSecondary_hover__ju367vcv",
            active: "sprinkles_borderColor_modalTextSecondary_active__ju367vcw"
          },
          defaultClass: "sprinkles_borderColor_modalTextSecondary_base__ju367vcu"
        },
        profileAction: {
          conditions: {
            base: "sprinkles_borderColor_profileAction_base__ju367vcx",
            hover: "sprinkles_borderColor_profileAction_hover__ju367vcy",
            active: "sprinkles_borderColor_profileAction_active__ju367vcz"
          },
          defaultClass: "sprinkles_borderColor_profileAction_base__ju367vcx"
        },
        profileActionHover: {
          conditions: {
            base: "sprinkles_borderColor_profileActionHover_base__ju367vd0",
            hover: "sprinkles_borderColor_profileActionHover_hover__ju367vd1",
            active: "sprinkles_borderColor_profileActionHover_active__ju367vd2"
          },
          defaultClass: "sprinkles_borderColor_profileActionHover_base__ju367vd0"
        },
        profileForeground: {
          conditions: {
            base: "sprinkles_borderColor_profileForeground_base__ju367vd3",
            hover: "sprinkles_borderColor_profileForeground_hover__ju367vd4",
            active: "sprinkles_borderColor_profileForeground_active__ju367vd5"
          },
          defaultClass: "sprinkles_borderColor_profileForeground_base__ju367vd3"
        },
        selectedOptionBorder: {
          conditions: {
            base: "sprinkles_borderColor_selectedOptionBorder_base__ju367vd6",
            hover: "sprinkles_borderColor_selectedOptionBorder_hover__ju367vd7",
            active: "sprinkles_borderColor_selectedOptionBorder_active__ju367vd8"
          },
          defaultClass: "sprinkles_borderColor_selectedOptionBorder_base__ju367vd6"
        },
        standby: {
          conditions: {
            base: "sprinkles_borderColor_standby_base__ju367vd9",
            hover: "sprinkles_borderColor_standby_hover__ju367vda",
            active: "sprinkles_borderColor_standby_active__ju367vdb"
          },
          defaultClass: "sprinkles_borderColor_standby_base__ju367vd9"
        }
      }
    },
    boxShadow: {
      values: {
        connectButton: {
          conditions: {
            base: "sprinkles_boxShadow_connectButton_base__ju367vdc",
            hover: "sprinkles_boxShadow_connectButton_hover__ju367vdd",
            active: "sprinkles_boxShadow_connectButton_active__ju367vde"
          },
          defaultClass: "sprinkles_boxShadow_connectButton_base__ju367vdc"
        },
        dialog: {
          conditions: {
            base: "sprinkles_boxShadow_dialog_base__ju367vdf",
            hover: "sprinkles_boxShadow_dialog_hover__ju367vdg",
            active: "sprinkles_boxShadow_dialog_active__ju367vdh"
          },
          defaultClass: "sprinkles_boxShadow_dialog_base__ju367vdf"
        },
        profileDetailsAction: {
          conditions: {
            base: "sprinkles_boxShadow_profileDetailsAction_base__ju367vdi",
            hover: "sprinkles_boxShadow_profileDetailsAction_hover__ju367vdj",
            active: "sprinkles_boxShadow_profileDetailsAction_active__ju367vdk"
          },
          defaultClass: "sprinkles_boxShadow_profileDetailsAction_base__ju367vdi"
        },
        selectedOption: {
          conditions: {
            base: "sprinkles_boxShadow_selectedOption_base__ju367vdl",
            hover: "sprinkles_boxShadow_selectedOption_hover__ju367vdm",
            active: "sprinkles_boxShadow_selectedOption_active__ju367vdn"
          },
          defaultClass: "sprinkles_boxShadow_selectedOption_base__ju367vdl"
        },
        selectedWallet: {
          conditions: {
            base: "sprinkles_boxShadow_selectedWallet_base__ju367vdo",
            hover: "sprinkles_boxShadow_selectedWallet_hover__ju367vdp",
            active: "sprinkles_boxShadow_selectedWallet_active__ju367vdq"
          },
          defaultClass: "sprinkles_boxShadow_selectedWallet_base__ju367vdo"
        }
      }
    },
    color: {
      values: {
        accentColor: {
          conditions: {
            base: "sprinkles_color_accentColor_base__ju367vdr",
            hover: "sprinkles_color_accentColor_hover__ju367vds",
            active: "sprinkles_color_accentColor_active__ju367vdt"
          },
          defaultClass: "sprinkles_color_accentColor_base__ju367vdr"
        },
        actionButtonBorder: {
          conditions: {
            base: "sprinkles_color_actionButtonBorder_base__ju367vdu",
            hover: "sprinkles_color_actionButtonBorder_hover__ju367vdv",
            active: "sprinkles_color_actionButtonBorder_active__ju367vdw"
          },
          defaultClass: "sprinkles_color_actionButtonBorder_base__ju367vdu"
        },
        actionButtonBorderMobile: {
          conditions: {
            base: "sprinkles_color_actionButtonBorderMobile_base__ju367vdx",
            hover: "sprinkles_color_actionButtonBorderMobile_hover__ju367vdy",
            active: "sprinkles_color_actionButtonBorderMobile_active__ju367vdz"
          },
          defaultClass: "sprinkles_color_actionButtonBorderMobile_base__ju367vdx"
        },
        actionButtonSecondaryBackground: {
          conditions: {
            base: "sprinkles_color_actionButtonSecondaryBackground_base__ju367ve0",
            hover: "sprinkles_color_actionButtonSecondaryBackground_hover__ju367ve1",
            active: "sprinkles_color_actionButtonSecondaryBackground_active__ju367ve2"
          },
          defaultClass: "sprinkles_color_actionButtonSecondaryBackground_base__ju367ve0"
        },
        actionButtonText: {
          conditions: {
            base: "sprinkles_color_actionButtonText_base__ju367ve3",
            hover: "sprinkles_color_actionButtonText_hover__ju367ve4",
            active: "sprinkles_color_actionButtonText_active__ju367ve5"
          },
          defaultClass: "sprinkles_color_actionButtonText_base__ju367ve3"
        },
        closeButton: {
          conditions: {
            base: "sprinkles_color_closeButton_base__ju367ve6",
            hover: "sprinkles_color_closeButton_hover__ju367ve7",
            active: "sprinkles_color_closeButton_active__ju367ve8"
          },
          defaultClass: "sprinkles_color_closeButton_base__ju367ve6"
        },
        closeButtonBackground: {
          conditions: {
            base: "sprinkles_color_closeButtonBackground_base__ju367ve9",
            hover: "sprinkles_color_closeButtonBackground_hover__ju367vea",
            active: "sprinkles_color_closeButtonBackground_active__ju367veb"
          },
          defaultClass: "sprinkles_color_closeButtonBackground_base__ju367ve9"
        },
        connectButtonBackground: {
          conditions: {
            base: "sprinkles_color_connectButtonBackground_base__ju367vec",
            hover: "sprinkles_color_connectButtonBackground_hover__ju367ved",
            active: "sprinkles_color_connectButtonBackground_active__ju367vee"
          },
          defaultClass: "sprinkles_color_connectButtonBackground_base__ju367vec"
        },
        connectButtonBackgroundError: {
          conditions: {
            base: "sprinkles_color_connectButtonBackgroundError_base__ju367vef",
            hover: "sprinkles_color_connectButtonBackgroundError_hover__ju367veg",
            active: "sprinkles_color_connectButtonBackgroundError_active__ju367veh"
          },
          defaultClass: "sprinkles_color_connectButtonBackgroundError_base__ju367vef"
        },
        connectButtonInnerBackground: {
          conditions: {
            base: "sprinkles_color_connectButtonInnerBackground_base__ju367vei",
            hover: "sprinkles_color_connectButtonInnerBackground_hover__ju367vej",
            active: "sprinkles_color_connectButtonInnerBackground_active__ju367vek"
          },
          defaultClass: "sprinkles_color_connectButtonInnerBackground_base__ju367vei"
        },
        connectButtonText: {
          conditions: {
            base: "sprinkles_color_connectButtonText_base__ju367vel",
            hover: "sprinkles_color_connectButtonText_hover__ju367vem",
            active: "sprinkles_color_connectButtonText_active__ju367ven"
          },
          defaultClass: "sprinkles_color_connectButtonText_base__ju367vel"
        },
        connectButtonTextError: {
          conditions: {
            base: "sprinkles_color_connectButtonTextError_base__ju367veo",
            hover: "sprinkles_color_connectButtonTextError_hover__ju367vep",
            active: "sprinkles_color_connectButtonTextError_active__ju367veq"
          },
          defaultClass: "sprinkles_color_connectButtonTextError_base__ju367veo"
        },
        connectionIndicator: {
          conditions: {
            base: "sprinkles_color_connectionIndicator_base__ju367ver",
            hover: "sprinkles_color_connectionIndicator_hover__ju367ves",
            active: "sprinkles_color_connectionIndicator_active__ju367vet"
          },
          defaultClass: "sprinkles_color_connectionIndicator_base__ju367ver"
        },
        error: {
          conditions: {
            base: "sprinkles_color_error_base__ju367veu",
            hover: "sprinkles_color_error_hover__ju367vev",
            active: "sprinkles_color_error_active__ju367vew"
          },
          defaultClass: "sprinkles_color_error_base__ju367veu"
        },
        generalBorder: {
          conditions: {
            base: "sprinkles_color_generalBorder_base__ju367vex",
            hover: "sprinkles_color_generalBorder_hover__ju367vey",
            active: "sprinkles_color_generalBorder_active__ju367vez"
          },
          defaultClass: "sprinkles_color_generalBorder_base__ju367vex"
        },
        generalBorderDim: {
          conditions: {
            base: "sprinkles_color_generalBorderDim_base__ju367vf0",
            hover: "sprinkles_color_generalBorderDim_hover__ju367vf1",
            active: "sprinkles_color_generalBorderDim_active__ju367vf2"
          },
          defaultClass: "sprinkles_color_generalBorderDim_base__ju367vf0"
        },
        menuItemBackground: {
          conditions: {
            base: "sprinkles_color_menuItemBackground_base__ju367vf3",
            hover: "sprinkles_color_menuItemBackground_hover__ju367vf4",
            active: "sprinkles_color_menuItemBackground_active__ju367vf5"
          },
          defaultClass: "sprinkles_color_menuItemBackground_base__ju367vf3"
        },
        modalBackdrop: {
          conditions: {
            base: "sprinkles_color_modalBackdrop_base__ju367vf6",
            hover: "sprinkles_color_modalBackdrop_hover__ju367vf7",
            active: "sprinkles_color_modalBackdrop_active__ju367vf8"
          },
          defaultClass: "sprinkles_color_modalBackdrop_base__ju367vf6"
        },
        modalBackground: {
          conditions: {
            base: "sprinkles_color_modalBackground_base__ju367vf9",
            hover: "sprinkles_color_modalBackground_hover__ju367vfa",
            active: "sprinkles_color_modalBackground_active__ju367vfb"
          },
          defaultClass: "sprinkles_color_modalBackground_base__ju367vf9"
        },
        modalBorder: {
          conditions: {
            base: "sprinkles_color_modalBorder_base__ju367vfc",
            hover: "sprinkles_color_modalBorder_hover__ju367vfd",
            active: "sprinkles_color_modalBorder_active__ju367vfe"
          },
          defaultClass: "sprinkles_color_modalBorder_base__ju367vfc"
        },
        modalText: {
          conditions: {
            base: "sprinkles_color_modalText_base__ju367vff",
            hover: "sprinkles_color_modalText_hover__ju367vfg",
            active: "sprinkles_color_modalText_active__ju367vfh"
          },
          defaultClass: "sprinkles_color_modalText_base__ju367vff"
        },
        modalTextDim: {
          conditions: {
            base: "sprinkles_color_modalTextDim_base__ju367vfi",
            hover: "sprinkles_color_modalTextDim_hover__ju367vfj",
            active: "sprinkles_color_modalTextDim_active__ju367vfk"
          },
          defaultClass: "sprinkles_color_modalTextDim_base__ju367vfi"
        },
        modalTextSecondary: {
          conditions: {
            base: "sprinkles_color_modalTextSecondary_base__ju367vfl",
            hover: "sprinkles_color_modalTextSecondary_hover__ju367vfm",
            active: "sprinkles_color_modalTextSecondary_active__ju367vfn"
          },
          defaultClass: "sprinkles_color_modalTextSecondary_base__ju367vfl"
        },
        profileAction: {
          conditions: {
            base: "sprinkles_color_profileAction_base__ju367vfo",
            hover: "sprinkles_color_profileAction_hover__ju367vfp",
            active: "sprinkles_color_profileAction_active__ju367vfq"
          },
          defaultClass: "sprinkles_color_profileAction_base__ju367vfo"
        },
        profileActionHover: {
          conditions: {
            base: "sprinkles_color_profileActionHover_base__ju367vfr",
            hover: "sprinkles_color_profileActionHover_hover__ju367vfs",
            active: "sprinkles_color_profileActionHover_active__ju367vft"
          },
          defaultClass: "sprinkles_color_profileActionHover_base__ju367vfr"
        },
        profileForeground: {
          conditions: {
            base: "sprinkles_color_profileForeground_base__ju367vfu",
            hover: "sprinkles_color_profileForeground_hover__ju367vfv",
            active: "sprinkles_color_profileForeground_active__ju367vfw"
          },
          defaultClass: "sprinkles_color_profileForeground_base__ju367vfu"
        },
        selectedOptionBorder: {
          conditions: {
            base: "sprinkles_color_selectedOptionBorder_base__ju367vfx",
            hover: "sprinkles_color_selectedOptionBorder_hover__ju367vfy",
            active: "sprinkles_color_selectedOptionBorder_active__ju367vfz"
          },
          defaultClass: "sprinkles_color_selectedOptionBorder_base__ju367vfx"
        },
        standby: {
          conditions: {
            base: "sprinkles_color_standby_base__ju367vg0",
            hover: "sprinkles_color_standby_hover__ju367vg1",
            active: "sprinkles_color_standby_active__ju367vg2"
          },
          defaultClass: "sprinkles_color_standby_base__ju367vg0"
        }
      }
    }
  }
}, {
  conditions: {
    defaultCondition: "base",
    conditionNames: ["base", "hover", "active"],
    responsiveArray: void 0
  },
  styles: {
    transform: {
      values: {
        grow: {
          conditions: {
            base: "sprinkles_transform_grow_base__ju367v0",
            hover: "sprinkles_transform_grow_hover__ju367v1",
            active: "sprinkles_transform_grow_active__ju367v2"
          },
          defaultClass: "sprinkles_transform_grow_base__ju367v0"
        },
        growLg: {
          conditions: {
            base: "sprinkles_transform_growLg_base__ju367v3",
            hover: "sprinkles_transform_growLg_hover__ju367v4",
            active: "sprinkles_transform_growLg_active__ju367v5"
          },
          defaultClass: "sprinkles_transform_growLg_base__ju367v3"
        },
        shrink: {
          conditions: {
            base: "sprinkles_transform_shrink_base__ju367v6",
            hover: "sprinkles_transform_shrink_hover__ju367v7",
            active: "sprinkles_transform_shrink_active__ju367v8"
          },
          defaultClass: "sprinkles_transform_shrink_base__ju367v6"
        },
        shrinkSm: {
          conditions: {
            base: "sprinkles_transform_shrinkSm_base__ju367v9",
            hover: "sprinkles_transform_shrinkSm_hover__ju367va",
            active: "sprinkles_transform_shrinkSm_active__ju367vb"
          },
          defaultClass: "sprinkles_transform_shrinkSm_base__ju367v9"
        }
      }
    },
    transition: {
      values: {
        "default": {
          conditions: {
            base: "sprinkles_transition_default_base__ju367vc",
            hover: "sprinkles_transition_default_hover__ju367vd",
            active: "sprinkles_transition_default_active__ju367ve"
          },
          defaultClass: "sprinkles_transition_default_base__ju367vc"
        }
      }
    }
  }
}, {
  conditions: {
    defaultCondition: "smallScreen",
    conditionNames: ["smallScreen", "largeScreen"],
    responsiveArray: void 0
  },
  styles: {
    alignItems: {
      values: {
        "flex-start": {
          conditions: {
            smallScreen: "sprinkles_alignItems_flex-start_smallScreen__ju367vf",
            largeScreen: "sprinkles_alignItems_flex-start_largeScreen__ju367vg"
          },
          defaultClass: "sprinkles_alignItems_flex-start_smallScreen__ju367vf"
        },
        "flex-end": {
          conditions: {
            smallScreen: "sprinkles_alignItems_flex-end_smallScreen__ju367vh",
            largeScreen: "sprinkles_alignItems_flex-end_largeScreen__ju367vi"
          },
          defaultClass: "sprinkles_alignItems_flex-end_smallScreen__ju367vh"
        },
        center: {
          conditions: {
            smallScreen: "sprinkles_alignItems_center_smallScreen__ju367vj",
            largeScreen: "sprinkles_alignItems_center_largeScreen__ju367vk"
          },
          defaultClass: "sprinkles_alignItems_center_smallScreen__ju367vj"
        }
      }
    },
    display: {
      values: {
        none: {
          conditions: {
            smallScreen: "sprinkles_display_none_smallScreen__ju367vl",
            largeScreen: "sprinkles_display_none_largeScreen__ju367vm"
          },
          defaultClass: "sprinkles_display_none_smallScreen__ju367vl"
        },
        block: {
          conditions: {
            smallScreen: "sprinkles_display_block_smallScreen__ju367vn",
            largeScreen: "sprinkles_display_block_largeScreen__ju367vo"
          },
          defaultClass: "sprinkles_display_block_smallScreen__ju367vn"
        },
        flex: {
          conditions: {
            smallScreen: "sprinkles_display_flex_smallScreen__ju367vp",
            largeScreen: "sprinkles_display_flex_largeScreen__ju367vq"
          },
          defaultClass: "sprinkles_display_flex_smallScreen__ju367vp"
        }
      }
    }
  }
}, {
  conditions: void 0,
  styles: {
    margin: {
      mappings: ["marginTop", "marginBottom", "marginLeft", "marginRight"]
    },
    marginX: {
      mappings: ["marginLeft", "marginRight"]
    },
    marginY: {
      mappings: ["marginTop", "marginBottom"]
    },
    padding: {
      mappings: ["paddingTop", "paddingBottom", "paddingLeft", "paddingRight"]
    },
    paddingX: {
      mappings: ["paddingLeft", "paddingRight"]
    },
    paddingY: {
      mappings: ["paddingTop", "paddingBottom"]
    },
    alignSelf: {
      values: {
        "flex-start": {
          defaultClass: "sprinkles_alignSelf_flex-start__ju367vr"
        },
        "flex-end": {
          defaultClass: "sprinkles_alignSelf_flex-end__ju367vs"
        },
        center: {
          defaultClass: "sprinkles_alignSelf_center__ju367vt"
        }
      }
    },
    backgroundSize: {
      values: {
        cover: {
          defaultClass: "sprinkles_backgroundSize_cover__ju367vu"
        }
      }
    },
    borderRadius: {
      values: {
        "1": {
          defaultClass: "sprinkles_borderRadius_1__ju367vv"
        },
        "6": {
          defaultClass: "sprinkles_borderRadius_6__ju367vw"
        },
        "10": {
          defaultClass: "sprinkles_borderRadius_10__ju367vx"
        },
        "13": {
          defaultClass: "sprinkles_borderRadius_13__ju367vy"
        },
        actionButton: {
          defaultClass: "sprinkles_borderRadius_actionButton__ju367vz"
        },
        connectButton: {
          defaultClass: "sprinkles_borderRadius_connectButton__ju367v10"
        },
        menuButton: {
          defaultClass: "sprinkles_borderRadius_menuButton__ju367v11"
        },
        modal: {
          defaultClass: "sprinkles_borderRadius_modal__ju367v12"
        },
        modalMobile: {
          defaultClass: "sprinkles_borderRadius_modalMobile__ju367v13"
        },
        full: {
          defaultClass: "sprinkles_borderRadius_full__ju367v14"
        }
      }
    },
    borderStyle: {
      values: {
        solid: {
          defaultClass: "sprinkles_borderStyle_solid__ju367v15"
        }
      }
    },
    borderWidth: {
      values: {
        "0": {
          defaultClass: "sprinkles_borderWidth_0__ju367v16"
        },
        "1": {
          defaultClass: "sprinkles_borderWidth_1__ju367v17"
        },
        "2": {
          defaultClass: "sprinkles_borderWidth_2__ju367v18"
        },
        "4": {
          defaultClass: "sprinkles_borderWidth_4__ju367v19"
        },
        modalBorderWidth: {
          defaultClass: "sprinkles_borderWidth_modalBorderWidth__ju367v1a"
        }
      }
    },
    cursor: {
      values: {
        pointer: {
          defaultClass: "sprinkles_cursor_pointer__ju367v1b"
        }
      }
    },
    flexDirection: {
      values: {
        row: {
          defaultClass: "sprinkles_flexDirection_row__ju367v1c"
        },
        column: {
          defaultClass: "sprinkles_flexDirection_column__ju367v1d"
        }
      }
    },
    fontFamily: {
      values: {
        body: {
          defaultClass: "sprinkles_fontFamily_body__ju367v1e"
        }
      }
    },
    fontSize: {
      values: {
        "12": {
          defaultClass: "sprinkles_fontSize_12__ju367v1f"
        },
        "13": {
          defaultClass: "sprinkles_fontSize_13__ju367v1g"
        },
        "14": {
          defaultClass: "sprinkles_fontSize_14__ju367v1h"
        },
        "16": {
          defaultClass: "sprinkles_fontSize_16__ju367v1i"
        },
        "18": {
          defaultClass: "sprinkles_fontSize_18__ju367v1j"
        },
        "20": {
          defaultClass: "sprinkles_fontSize_20__ju367v1k"
        },
        "23": {
          defaultClass: "sprinkles_fontSize_23__ju367v1l"
        }
      }
    },
    fontWeight: {
      values: {
        regular: {
          defaultClass: "sprinkles_fontWeight_regular__ju367v1m"
        },
        medium: {
          defaultClass: "sprinkles_fontWeight_medium__ju367v1n"
        },
        semibold: {
          defaultClass: "sprinkles_fontWeight_semibold__ju367v1o"
        },
        bold: {
          defaultClass: "sprinkles_fontWeight_bold__ju367v1p"
        },
        heavy: {
          defaultClass: "sprinkles_fontWeight_heavy__ju367v1q"
        }
      }
    },
    gap: {
      values: {
        "0": {
          defaultClass: "sprinkles_gap_0__ju367v1r"
        },
        "1": {
          defaultClass: "sprinkles_gap_1__ju367v1s"
        },
        "2": {
          defaultClass: "sprinkles_gap_2__ju367v1t"
        },
        "4": {
          defaultClass: "sprinkles_gap_4__ju367v1u"
        },
        "5": {
          defaultClass: "sprinkles_gap_5__ju367v1v"
        },
        "6": {
          defaultClass: "sprinkles_gap_6__ju367v1w"
        },
        "8": {
          defaultClass: "sprinkles_gap_8__ju367v1x"
        },
        "10": {
          defaultClass: "sprinkles_gap_10__ju367v1y"
        },
        "12": {
          defaultClass: "sprinkles_gap_12__ju367v1z"
        },
        "14": {
          defaultClass: "sprinkles_gap_14__ju367v20"
        },
        "16": {
          defaultClass: "sprinkles_gap_16__ju367v21"
        },
        "18": {
          defaultClass: "sprinkles_gap_18__ju367v22"
        },
        "20": {
          defaultClass: "sprinkles_gap_20__ju367v23"
        },
        "24": {
          defaultClass: "sprinkles_gap_24__ju367v24"
        },
        "28": {
          defaultClass: "sprinkles_gap_28__ju367v25"
        },
        "32": {
          defaultClass: "sprinkles_gap_32__ju367v26"
        },
        "36": {
          defaultClass: "sprinkles_gap_36__ju367v27"
        },
        "44": {
          defaultClass: "sprinkles_gap_44__ju367v28"
        },
        "64": {
          defaultClass: "sprinkles_gap_64__ju367v29"
        }
      }
    },
    height: {
      values: {
        "1": {
          defaultClass: "sprinkles_height_1__ju367v2a"
        },
        "2": {
          defaultClass: "sprinkles_height_2__ju367v2b"
        },
        "4": {
          defaultClass: "sprinkles_height_4__ju367v2c"
        },
        "8": {
          defaultClass: "sprinkles_height_8__ju367v2d"
        },
        "12": {
          defaultClass: "sprinkles_height_12__ju367v2e"
        },
        "20": {
          defaultClass: "sprinkles_height_20__ju367v2f"
        },
        "24": {
          defaultClass: "sprinkles_height_24__ju367v2g"
        },
        "28": {
          defaultClass: "sprinkles_height_28__ju367v2h"
        },
        "32": {
          defaultClass: "sprinkles_height_32__ju367v2i"
        },
        "34": {
          defaultClass: "sprinkles_height_34__ju367v2j"
        },
        "36": {
          defaultClass: "sprinkles_height_36__ju367v2k"
        },
        "40": {
          defaultClass: "sprinkles_height_40__ju367v2l"
        },
        "48": {
          defaultClass: "sprinkles_height_48__ju367v2m"
        },
        "54": {
          defaultClass: "sprinkles_height_54__ju367v2n"
        },
        "60": {
          defaultClass: "sprinkles_height_60__ju367v2o"
        },
        full: {
          defaultClass: "sprinkles_height_full__ju367v2p"
        },
        max: {
          defaultClass: "sprinkles_height_max__ju367v2q"
        }
      }
    },
    justifyContent: {
      values: {
        "flex-start": {
          defaultClass: "sprinkles_justifyContent_flex-start__ju367v2r"
        },
        "flex-end": {
          defaultClass: "sprinkles_justifyContent_flex-end__ju367v2s"
        },
        center: {
          defaultClass: "sprinkles_justifyContent_center__ju367v2t"
        },
        "space-between": {
          defaultClass: "sprinkles_justifyContent_space-between__ju367v2u"
        }
      }
    },
    marginBottom: {
      values: {
        "0": {
          defaultClass: "sprinkles_marginBottom_0__ju367v2v"
        },
        "1": {
          defaultClass: "sprinkles_marginBottom_1__ju367v2w"
        },
        "2": {
          defaultClass: "sprinkles_marginBottom_2__ju367v2x"
        },
        "4": {
          defaultClass: "sprinkles_marginBottom_4__ju367v2y"
        },
        "5": {
          defaultClass: "sprinkles_marginBottom_5__ju367v2z"
        },
        "6": {
          defaultClass: "sprinkles_marginBottom_6__ju367v30"
        },
        "8": {
          defaultClass: "sprinkles_marginBottom_8__ju367v31"
        },
        "10": {
          defaultClass: "sprinkles_marginBottom_10__ju367v32"
        },
        "12": {
          defaultClass: "sprinkles_marginBottom_12__ju367v33"
        },
        "14": {
          defaultClass: "sprinkles_marginBottom_14__ju367v34"
        },
        "16": {
          defaultClass: "sprinkles_marginBottom_16__ju367v35"
        },
        "18": {
          defaultClass: "sprinkles_marginBottom_18__ju367v36"
        },
        "20": {
          defaultClass: "sprinkles_marginBottom_20__ju367v37"
        },
        "24": {
          defaultClass: "sprinkles_marginBottom_24__ju367v38"
        },
        "28": {
          defaultClass: "sprinkles_marginBottom_28__ju367v39"
        },
        "32": {
          defaultClass: "sprinkles_marginBottom_32__ju367v3a"
        },
        "36": {
          defaultClass: "sprinkles_marginBottom_36__ju367v3b"
        },
        "44": {
          defaultClass: "sprinkles_marginBottom_44__ju367v3c"
        },
        "64": {
          defaultClass: "sprinkles_marginBottom_64__ju367v3d"
        }
      }
    },
    marginLeft: {
      values: {
        "0": {
          defaultClass: "sprinkles_marginLeft_0__ju367v3e"
        },
        "1": {
          defaultClass: "sprinkles_marginLeft_1__ju367v3f"
        },
        "2": {
          defaultClass: "sprinkles_marginLeft_2__ju367v3g"
        },
        "4": {
          defaultClass: "sprinkles_marginLeft_4__ju367v3h"
        },
        "5": {
          defaultClass: "sprinkles_marginLeft_5__ju367v3i"
        },
        "6": {
          defaultClass: "sprinkles_marginLeft_6__ju367v3j"
        },
        "8": {
          defaultClass: "sprinkles_marginLeft_8__ju367v3k"
        },
        "10": {
          defaultClass: "sprinkles_marginLeft_10__ju367v3l"
        },
        "12": {
          defaultClass: "sprinkles_marginLeft_12__ju367v3m"
        },
        "14": {
          defaultClass: "sprinkles_marginLeft_14__ju367v3n"
        },
        "16": {
          defaultClass: "sprinkles_marginLeft_16__ju367v3o"
        },
        "18": {
          defaultClass: "sprinkles_marginLeft_18__ju367v3p"
        },
        "20": {
          defaultClass: "sprinkles_marginLeft_20__ju367v3q"
        },
        "24": {
          defaultClass: "sprinkles_marginLeft_24__ju367v3r"
        },
        "28": {
          defaultClass: "sprinkles_marginLeft_28__ju367v3s"
        },
        "32": {
          defaultClass: "sprinkles_marginLeft_32__ju367v3t"
        },
        "36": {
          defaultClass: "sprinkles_marginLeft_36__ju367v3u"
        },
        "44": {
          defaultClass: "sprinkles_marginLeft_44__ju367v3v"
        },
        "64": {
          defaultClass: "sprinkles_marginLeft_64__ju367v3w"
        }
      }
    },
    marginRight: {
      values: {
        "0": {
          defaultClass: "sprinkles_marginRight_0__ju367v3x"
        },
        "1": {
          defaultClass: "sprinkles_marginRight_1__ju367v3y"
        },
        "2": {
          defaultClass: "sprinkles_marginRight_2__ju367v3z"
        },
        "4": {
          defaultClass: "sprinkles_marginRight_4__ju367v40"
        },
        "5": {
          defaultClass: "sprinkles_marginRight_5__ju367v41"
        },
        "6": {
          defaultClass: "sprinkles_marginRight_6__ju367v42"
        },
        "8": {
          defaultClass: "sprinkles_marginRight_8__ju367v43"
        },
        "10": {
          defaultClass: "sprinkles_marginRight_10__ju367v44"
        },
        "12": {
          defaultClass: "sprinkles_marginRight_12__ju367v45"
        },
        "14": {
          defaultClass: "sprinkles_marginRight_14__ju367v46"
        },
        "16": {
          defaultClass: "sprinkles_marginRight_16__ju367v47"
        },
        "18": {
          defaultClass: "sprinkles_marginRight_18__ju367v48"
        },
        "20": {
          defaultClass: "sprinkles_marginRight_20__ju367v49"
        },
        "24": {
          defaultClass: "sprinkles_marginRight_24__ju367v4a"
        },
        "28": {
          defaultClass: "sprinkles_marginRight_28__ju367v4b"
        },
        "32": {
          defaultClass: "sprinkles_marginRight_32__ju367v4c"
        },
        "36": {
          defaultClass: "sprinkles_marginRight_36__ju367v4d"
        },
        "44": {
          defaultClass: "sprinkles_marginRight_44__ju367v4e"
        },
        "64": {
          defaultClass: "sprinkles_marginRight_64__ju367v4f"
        }
      }
    },
    marginTop: {
      values: {
        "0": {
          defaultClass: "sprinkles_marginTop_0__ju367v4g"
        },
        "1": {
          defaultClass: "sprinkles_marginTop_1__ju367v4h"
        },
        "2": {
          defaultClass: "sprinkles_marginTop_2__ju367v4i"
        },
        "4": {
          defaultClass: "sprinkles_marginTop_4__ju367v4j"
        },
        "5": {
          defaultClass: "sprinkles_marginTop_5__ju367v4k"
        },
        "6": {
          defaultClass: "sprinkles_marginTop_6__ju367v4l"
        },
        "8": {
          defaultClass: "sprinkles_marginTop_8__ju367v4m"
        },
        "10": {
          defaultClass: "sprinkles_marginTop_10__ju367v4n"
        },
        "12": {
          defaultClass: "sprinkles_marginTop_12__ju367v4o"
        },
        "14": {
          defaultClass: "sprinkles_marginTop_14__ju367v4p"
        },
        "16": {
          defaultClass: "sprinkles_marginTop_16__ju367v4q"
        },
        "18": {
          defaultClass: "sprinkles_marginTop_18__ju367v4r"
        },
        "20": {
          defaultClass: "sprinkles_marginTop_20__ju367v4s"
        },
        "24": {
          defaultClass: "sprinkles_marginTop_24__ju367v4t"
        },
        "28": {
          defaultClass: "sprinkles_marginTop_28__ju367v4u"
        },
        "32": {
          defaultClass: "sprinkles_marginTop_32__ju367v4v"
        },
        "36": {
          defaultClass: "sprinkles_marginTop_36__ju367v4w"
        },
        "44": {
          defaultClass: "sprinkles_marginTop_44__ju367v4x"
        },
        "64": {
          defaultClass: "sprinkles_marginTop_64__ju367v4y"
        }
      }
    },
    maxWidth: {
      values: {
        "1": {
          defaultClass: "sprinkles_maxWidth_1__ju367v4z"
        },
        "2": {
          defaultClass: "sprinkles_maxWidth_2__ju367v50"
        },
        "4": {
          defaultClass: "sprinkles_maxWidth_4__ju367v51"
        },
        "8": {
          defaultClass: "sprinkles_maxWidth_8__ju367v52"
        },
        "12": {
          defaultClass: "sprinkles_maxWidth_12__ju367v53"
        },
        "20": {
          defaultClass: "sprinkles_maxWidth_20__ju367v54"
        },
        "24": {
          defaultClass: "sprinkles_maxWidth_24__ju367v55"
        },
        "28": {
          defaultClass: "sprinkles_maxWidth_28__ju367v56"
        },
        "32": {
          defaultClass: "sprinkles_maxWidth_32__ju367v57"
        },
        "34": {
          defaultClass: "sprinkles_maxWidth_34__ju367v58"
        },
        "36": {
          defaultClass: "sprinkles_maxWidth_36__ju367v59"
        },
        "40": {
          defaultClass: "sprinkles_maxWidth_40__ju367v5a"
        },
        "48": {
          defaultClass: "sprinkles_maxWidth_48__ju367v5b"
        },
        "54": {
          defaultClass: "sprinkles_maxWidth_54__ju367v5c"
        },
        "60": {
          defaultClass: "sprinkles_maxWidth_60__ju367v5d"
        },
        full: {
          defaultClass: "sprinkles_maxWidth_full__ju367v5e"
        },
        max: {
          defaultClass: "sprinkles_maxWidth_max__ju367v5f"
        }
      }
    },
    minWidth: {
      values: {
        "1": {
          defaultClass: "sprinkles_minWidth_1__ju367v5g"
        },
        "2": {
          defaultClass: "sprinkles_minWidth_2__ju367v5h"
        },
        "4": {
          defaultClass: "sprinkles_minWidth_4__ju367v5i"
        },
        "8": {
          defaultClass: "sprinkles_minWidth_8__ju367v5j"
        },
        "12": {
          defaultClass: "sprinkles_minWidth_12__ju367v5k"
        },
        "20": {
          defaultClass: "sprinkles_minWidth_20__ju367v5l"
        },
        "24": {
          defaultClass: "sprinkles_minWidth_24__ju367v5m"
        },
        "28": {
          defaultClass: "sprinkles_minWidth_28__ju367v5n"
        },
        "32": {
          defaultClass: "sprinkles_minWidth_32__ju367v5o"
        },
        "34": {
          defaultClass: "sprinkles_minWidth_34__ju367v5p"
        },
        "36": {
          defaultClass: "sprinkles_minWidth_36__ju367v5q"
        },
        "40": {
          defaultClass: "sprinkles_minWidth_40__ju367v5r"
        },
        "48": {
          defaultClass: "sprinkles_minWidth_48__ju367v5s"
        },
        "54": {
          defaultClass: "sprinkles_minWidth_54__ju367v5t"
        },
        "60": {
          defaultClass: "sprinkles_minWidth_60__ju367v5u"
        },
        full: {
          defaultClass: "sprinkles_minWidth_full__ju367v5v"
        },
        max: {
          defaultClass: "sprinkles_minWidth_max__ju367v5w"
        }
      }
    },
    overflow: {
      values: {
        hidden: {
          defaultClass: "sprinkles_overflow_hidden__ju367v5x"
        }
      }
    },
    paddingBottom: {
      values: {
        "0": {
          defaultClass: "sprinkles_paddingBottom_0__ju367v5y"
        },
        "1": {
          defaultClass: "sprinkles_paddingBottom_1__ju367v5z"
        },
        "2": {
          defaultClass: "sprinkles_paddingBottom_2__ju367v60"
        },
        "4": {
          defaultClass: "sprinkles_paddingBottom_4__ju367v61"
        },
        "5": {
          defaultClass: "sprinkles_paddingBottom_5__ju367v62"
        },
        "6": {
          defaultClass: "sprinkles_paddingBottom_6__ju367v63"
        },
        "8": {
          defaultClass: "sprinkles_paddingBottom_8__ju367v64"
        },
        "10": {
          defaultClass: "sprinkles_paddingBottom_10__ju367v65"
        },
        "12": {
          defaultClass: "sprinkles_paddingBottom_12__ju367v66"
        },
        "14": {
          defaultClass: "sprinkles_paddingBottom_14__ju367v67"
        },
        "16": {
          defaultClass: "sprinkles_paddingBottom_16__ju367v68"
        },
        "18": {
          defaultClass: "sprinkles_paddingBottom_18__ju367v69"
        },
        "20": {
          defaultClass: "sprinkles_paddingBottom_20__ju367v6a"
        },
        "24": {
          defaultClass: "sprinkles_paddingBottom_24__ju367v6b"
        },
        "28": {
          defaultClass: "sprinkles_paddingBottom_28__ju367v6c"
        },
        "32": {
          defaultClass: "sprinkles_paddingBottom_32__ju367v6d"
        },
        "36": {
          defaultClass: "sprinkles_paddingBottom_36__ju367v6e"
        },
        "44": {
          defaultClass: "sprinkles_paddingBottom_44__ju367v6f"
        },
        "64": {
          defaultClass: "sprinkles_paddingBottom_64__ju367v6g"
        }
      }
    },
    paddingLeft: {
      values: {
        "0": {
          defaultClass: "sprinkles_paddingLeft_0__ju367v6h"
        },
        "1": {
          defaultClass: "sprinkles_paddingLeft_1__ju367v6i"
        },
        "2": {
          defaultClass: "sprinkles_paddingLeft_2__ju367v6j"
        },
        "4": {
          defaultClass: "sprinkles_paddingLeft_4__ju367v6k"
        },
        "5": {
          defaultClass: "sprinkles_paddingLeft_5__ju367v6l"
        },
        "6": {
          defaultClass: "sprinkles_paddingLeft_6__ju367v6m"
        },
        "8": {
          defaultClass: "sprinkles_paddingLeft_8__ju367v6n"
        },
        "10": {
          defaultClass: "sprinkles_paddingLeft_10__ju367v6o"
        },
        "12": {
          defaultClass: "sprinkles_paddingLeft_12__ju367v6p"
        },
        "14": {
          defaultClass: "sprinkles_paddingLeft_14__ju367v6q"
        },
        "16": {
          defaultClass: "sprinkles_paddingLeft_16__ju367v6r"
        },
        "18": {
          defaultClass: "sprinkles_paddingLeft_18__ju367v6s"
        },
        "20": {
          defaultClass: "sprinkles_paddingLeft_20__ju367v6t"
        },
        "24": {
          defaultClass: "sprinkles_paddingLeft_24__ju367v6u"
        },
        "28": {
          defaultClass: "sprinkles_paddingLeft_28__ju367v6v"
        },
        "32": {
          defaultClass: "sprinkles_paddingLeft_32__ju367v6w"
        },
        "36": {
          defaultClass: "sprinkles_paddingLeft_36__ju367v6x"
        },
        "44": {
          defaultClass: "sprinkles_paddingLeft_44__ju367v6y"
        },
        "64": {
          defaultClass: "sprinkles_paddingLeft_64__ju367v6z"
        }
      }
    },
    paddingRight: {
      values: {
        "0": {
          defaultClass: "sprinkles_paddingRight_0__ju367v70"
        },
        "1": {
          defaultClass: "sprinkles_paddingRight_1__ju367v71"
        },
        "2": {
          defaultClass: "sprinkles_paddingRight_2__ju367v72"
        },
        "4": {
          defaultClass: "sprinkles_paddingRight_4__ju367v73"
        },
        "5": {
          defaultClass: "sprinkles_paddingRight_5__ju367v74"
        },
        "6": {
          defaultClass: "sprinkles_paddingRight_6__ju367v75"
        },
        "8": {
          defaultClass: "sprinkles_paddingRight_8__ju367v76"
        },
        "10": {
          defaultClass: "sprinkles_paddingRight_10__ju367v77"
        },
        "12": {
          defaultClass: "sprinkles_paddingRight_12__ju367v78"
        },
        "14": {
          defaultClass: "sprinkles_paddingRight_14__ju367v79"
        },
        "16": {
          defaultClass: "sprinkles_paddingRight_16__ju367v7a"
        },
        "18": {
          defaultClass: "sprinkles_paddingRight_18__ju367v7b"
        },
        "20": {
          defaultClass: "sprinkles_paddingRight_20__ju367v7c"
        },
        "24": {
          defaultClass: "sprinkles_paddingRight_24__ju367v7d"
        },
        "28": {
          defaultClass: "sprinkles_paddingRight_28__ju367v7e"
        },
        "32": {
          defaultClass: "sprinkles_paddingRight_32__ju367v7f"
        },
        "36": {
          defaultClass: "sprinkles_paddingRight_36__ju367v7g"
        },
        "44": {
          defaultClass: "sprinkles_paddingRight_44__ju367v7h"
        },
        "64": {
          defaultClass: "sprinkles_paddingRight_64__ju367v7i"
        }
      }
    },
    paddingTop: {
      values: {
        "0": {
          defaultClass: "sprinkles_paddingTop_0__ju367v7j"
        },
        "1": {
          defaultClass: "sprinkles_paddingTop_1__ju367v7k"
        },
        "2": {
          defaultClass: "sprinkles_paddingTop_2__ju367v7l"
        },
        "4": {
          defaultClass: "sprinkles_paddingTop_4__ju367v7m"
        },
        "5": {
          defaultClass: "sprinkles_paddingTop_5__ju367v7n"
        },
        "6": {
          defaultClass: "sprinkles_paddingTop_6__ju367v7o"
        },
        "8": {
          defaultClass: "sprinkles_paddingTop_8__ju367v7p"
        },
        "10": {
          defaultClass: "sprinkles_paddingTop_10__ju367v7q"
        },
        "12": {
          defaultClass: "sprinkles_paddingTop_12__ju367v7r"
        },
        "14": {
          defaultClass: "sprinkles_paddingTop_14__ju367v7s"
        },
        "16": {
          defaultClass: "sprinkles_paddingTop_16__ju367v7t"
        },
        "18": {
          defaultClass: "sprinkles_paddingTop_18__ju367v7u"
        },
        "20": {
          defaultClass: "sprinkles_paddingTop_20__ju367v7v"
        },
        "24": {
          defaultClass: "sprinkles_paddingTop_24__ju367v7w"
        },
        "28": {
          defaultClass: "sprinkles_paddingTop_28__ju367v7x"
        },
        "32": {
          defaultClass: "sprinkles_paddingTop_32__ju367v7y"
        },
        "36": {
          defaultClass: "sprinkles_paddingTop_36__ju367v7z"
        },
        "44": {
          defaultClass: "sprinkles_paddingTop_44__ju367v80"
        },
        "64": {
          defaultClass: "sprinkles_paddingTop_64__ju367v81"
        }
      }
    },
    position: {
      values: {
        absolute: {
          defaultClass: "sprinkles_position_absolute__ju367v82"
        },
        fixed: {
          defaultClass: "sprinkles_position_fixed__ju367v83"
        },
        relative: {
          defaultClass: "sprinkles_position_relative__ju367v84"
        }
      }
    },
    right: {
      values: {
        "0": {
          defaultClass: "sprinkles_right_0__ju367v85"
        }
      }
    },
    userSelect: {
      values: {
        none: {
          defaultClass: "sprinkles_userSelect_none__ju367v86"
        }
      }
    },
    width: {
      values: {
        "1": {
          defaultClass: "sprinkles_width_1__ju367v87"
        },
        "2": {
          defaultClass: "sprinkles_width_2__ju367v88"
        },
        "4": {
          defaultClass: "sprinkles_width_4__ju367v89"
        },
        "8": {
          defaultClass: "sprinkles_width_8__ju367v8a"
        },
        "12": {
          defaultClass: "sprinkles_width_12__ju367v8b"
        },
        "20": {
          defaultClass: "sprinkles_width_20__ju367v8c"
        },
        "24": {
          defaultClass: "sprinkles_width_24__ju367v8d"
        },
        "28": {
          defaultClass: "sprinkles_width_28__ju367v8e"
        },
        "32": {
          defaultClass: "sprinkles_width_32__ju367v8f"
        },
        "34": {
          defaultClass: "sprinkles_width_34__ju367v8g"
        },
        "36": {
          defaultClass: "sprinkles_width_36__ju367v8h"
        },
        "40": {
          defaultClass: "sprinkles_width_40__ju367v8i"
        },
        "48": {
          defaultClass: "sprinkles_width_48__ju367v8j"
        },
        "54": {
          defaultClass: "sprinkles_width_54__ju367v8k"
        },
        "60": {
          defaultClass: "sprinkles_width_60__ju367v8l"
        },
        full: {
          defaultClass: "sprinkles_width_full__ju367v8m"
        },
        max: {
          defaultClass: "sprinkles_width_max__ju367v8n"
        }
      }
    }
  }
});

var themeVars = {
  colors: {
    accentColor: "var(--rk-colors-accentColor)",
    actionButtonBorder: "var(--rk-colors-actionButtonBorder)",
    actionButtonBorderMobile: "var(--rk-colors-actionButtonBorderMobile)",
    actionButtonSecondaryBackground: "var(--rk-colors-actionButtonSecondaryBackground)",
    actionButtonText: "var(--rk-colors-actionButtonText)",
    closeButton: "var(--rk-colors-closeButton)",
    closeButtonBackground: "var(--rk-colors-closeButtonBackground)",
    connectButtonBackground: "var(--rk-colors-connectButtonBackground)",
    connectButtonBackgroundError: "var(--rk-colors-connectButtonBackgroundError)",
    connectButtonInnerBackground: "var(--rk-colors-connectButtonInnerBackground)",
    connectButtonText: "var(--rk-colors-connectButtonText)",
    connectButtonTextError: "var(--rk-colors-connectButtonTextError)",
    connectionIndicator: "var(--rk-colors-connectionIndicator)",
    error: "var(--rk-colors-error)",
    generalBorder: "var(--rk-colors-generalBorder)",
    generalBorderDim: "var(--rk-colors-generalBorderDim)",
    menuItemBackground: "var(--rk-colors-menuItemBackground)",
    modalBackdrop: "var(--rk-colors-modalBackdrop)",
    modalBackground: "var(--rk-colors-modalBackground)",
    modalBorder: "var(--rk-colors-modalBorder)",
    modalText: "var(--rk-colors-modalText)",
    modalTextDim: "var(--rk-colors-modalTextDim)",
    modalTextSecondary: "var(--rk-colors-modalTextSecondary)",
    profileAction: "var(--rk-colors-profileAction)",
    profileActionHover: "var(--rk-colors-profileActionHover)",
    profileForeground: "var(--rk-colors-profileForeground)",
    selectedOptionBorder: "var(--rk-colors-selectedOptionBorder)",
    standby: "var(--rk-colors-standby)"
  },
  fonts: {
    body: "var(--rk-fonts-body)"
  },
  radii: {
    actionButton: "var(--rk-radii-actionButton)",
    connectButton: "var(--rk-radii-connectButton)",
    menuButton: "var(--rk-radii-menuButton)",
    modal: "var(--rk-radii-modal)",
    modalMobile: "var(--rk-radii-modalMobile)"
  },
  shadows: {
    connectButton: "var(--rk-shadows-connectButton)",
    dialog: "var(--rk-shadows-dialog)",
    profileDetailsAction: "var(--rk-shadows-profileDetailsAction)",
    selectedOption: "var(--rk-shadows-selectedOption)",
    selectedWallet: "var(--rk-shadows-selectedWallet)"
  },
  borders: {
    modalBorderWidth: "var(--rk-borders-modalBorderWidth)"
  }
}; // src/components/Avatar/Avatar.tsx

import React2, { useMemo } from "react"; // src/components/Box/Box.ts

import clsx2 from "clsx";
import * as React from "react"; // src/css/atoms.ts

import clsx from "clsx"; // src/css/reset.css.ts

var base = "reset__iekbcc0";
var element = {
  a: "reset__iekbcca",
  blockquote: "reset__iekbcc2",
  button: "reset__iekbcc9",
  input: "reset__iekbcc8 reset__iekbcc5 reset__iekbcc4",
  mark: "reset__iekbcc6",
  ol: "reset__iekbcc1",
  q: "reset__iekbcc2",
  select: "reset__iekbcc7 reset__iekbcc5 reset__iekbcc4",
  table: "reset__iekbcc3",
  textarea: "reset__iekbcc5 reset__iekbcc4",
  ul: "reset__iekbcc1"
}; // src/css/atoms.ts

var atoms = function atoms(_ref) {
  var reset = _ref.reset,
      rest = _objectWithoutProperties(_ref, _excluded);

  if (!reset) return sprinkles(rest);
  var elementReset = element[reset];
  var sprinklesClasses = sprinkles(rest);
  return clsx(base, elementReset, sprinklesClasses);
}; // src/components/Box/Box.ts


var Box = React.forwardRef(function (_ref2, ref) {
  var _ref2$as = _ref2.as,
      as = _ref2$as === void 0 ? "div" : _ref2$as,
      className = _ref2.className,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var atomProps = {};
  var nativeProps = {};

  for (var key in props) {
    if (sprinkles.properties.has(key)) {
      atomProps[key] = props[key];
    } else {
      nativeProps[key] = props[key];
    }
  }

  var atomicClasses = atoms(_objectSpread({
    reset: typeof as === "string" ? as : "div"
  }, atomProps));
  return React.createElement(as, _objectSpread(_objectSpread({
    className: clsx2(atomicClasses, className)
  }, nativeProps), {}, {
    ref: ref
  }));
});
Box.displayName = "Box"; // src/components/Avatar/emojiAvatarForAddress.ts

var colors = ["#FC5C54", "#FFD95A", "#E95D72", "#6A87C8", "#5FD0F3", "#75C06B", "#FFDD86", "#5FC6D4", "#FF949A", "#FF8024", "#9BA1A4", "#EC66FF", "#FF8CBC", "#FF9A23", "#C5DADB", "#A8CE63", "#71ABFF", "#FFE279", "#B6B1B6", "#FF6780", "#A575FF", "#4D82FF", "#FFB35A"];
var avatars = [{
  color: colors[0],
  emoji: "\uD83C\uDF36"
}, {
  color: colors[1],
  emoji: "\uD83E\uDD11"
}, {
  color: colors[2],
  emoji: "\uD83D\uDC19"
}, {
  color: colors[3],
  emoji: "\uD83E\uDED0"
}, {
  color: colors[4],
  emoji: "\uD83D\uDC33"
}, {
  color: colors[0],
  emoji: "\uD83E\uDD36"
}, {
  color: colors[5],
  emoji: "\uD83C\uDF32"
}, {
  color: colors[6],
  emoji: "\uD83C\uDF1E"
}, {
  color: colors[7],
  emoji: "\uD83D\uDC12"
}, {
  color: colors[8],
  emoji: "\uD83D\uDC35"
}, {
  color: colors[9],
  emoji: "\uD83E\uDD8A"
}, {
  color: colors[10],
  emoji: "\uD83D\uDC3C"
}, {
  color: colors[11],
  emoji: "\uD83E\uDD84"
}, {
  color: colors[12],
  emoji: "\uD83D\uDC37"
}, {
  color: colors[13],
  emoji: "\uD83D\uDC27"
}, {
  color: colors[8],
  emoji: "\uD83E\uDDA9"
}, {
  color: colors[14],
  emoji: "\uD83D\uDC7D"
}, {
  color: colors[0],
  emoji: "\uD83C\uDF88"
}, {
  color: colors[8],
  emoji: "\uD83C\uDF49"
}, {
  color: colors[1],
  emoji: "\uD83C\uDF89"
}, {
  color: colors[15],
  emoji: "\uD83D\uDC32"
}, {
  color: colors[16],
  emoji: "\uD83C\uDF0E"
}, {
  color: colors[17],
  emoji: "\uD83C\uDF4A"
}, {
  color: colors[18],
  emoji: "\uD83D\uDC2D"
}, {
  color: colors[19],
  emoji: "\uD83C\uDF63"
}, {
  color: colors[1],
  emoji: "\uD83D\uDC25"
}, {
  color: colors[20],
  emoji: "\uD83D\uDC7E"
}, {
  color: colors[15],
  emoji: "\uD83E\uDD66"
}, {
  color: colors[0],
  emoji: "\uD83D\uDC79"
}, {
  color: colors[17],
  emoji: "\uD83D\uDE40"
}, {
  color: colors[4],
  emoji: "\u26F1"
}, {
  color: colors[21],
  emoji: "\u26F5\uFE0F"
}, {
  color: colors[17],
  emoji: "\uD83E\uDD73"
}, {
  color: colors[8],
  emoji: "\uD83E\uDD2F"
}, {
  color: colors[22],
  emoji: "\uD83E\uDD20"
}];

function hashCode(text) {
  var hash = 0;
  if (text.length === 0) return hash;

  for (var i = 0; i < text.length; i++) {
    var chr = text.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }

  return hash;
}

function emojiAvatarForAddress(address) {
  var resolvedAddress = typeof address === "string" ? address : "";
  var avatarIndex = Math.abs(hashCode(resolvedAddress.toLowerCase()) % avatars.length);
  return avatars[avatarIndex != null ? avatarIndex : 0];
} // src/components/Avatar/Avatar.tsx


function Avatar(_ref3) {
  var address = _ref3.address,
      imageUrl = _ref3.imageUrl,
      size = _ref3.size;

  var _useMemo = useMemo(function () {
    return emojiAvatarForAddress(address);
  }, [address]),
      backgroundColor = _useMemo.color,
      emoji = _useMemo.emoji;

  return /* @__PURE__ */React2.createElement(Box, {
    alignItems: "center",
    "aria-hidden": true,
    borderRadius: "full",
    display: "flex",
    justifyContent: "center",
    overflow: "hidden",
    position: "relative",
    style: {
      backgroundColor: backgroundColor,
      fontSize: "".concat(Math.round(size * 0.55), "px"),
      height: "".concat(size, "px"),
      width: "".concat(size, "px")
    },
    userSelect: "none"
  }, /* @__PURE__ */React2.createElement(Box, {
    backgroundSize: "cover",
    height: "full",
    position: "absolute",
    style: {
      backgroundImage: "url(".concat(imageUrl, ")")
    },
    width: "full"
  }), emoji);
} // src/components/Icons/Dropdown.tsx


import React3 from "react";

var DropdownIcon = function DropdownIcon() {
  return /* @__PURE__ */React3.createElement("svg", {
    fill: "none",
    height: "7",
    width: "14",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React3.createElement("path", {
    d: "M12.75 1.54001L8.51647 5.0038C7.77974 5.60658 6.72026 5.60658 5.98352 5.0038L1.75 1.54001",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2.5",
    xmlns: "http://www.w3.org/2000/svg"
  }));
}; // src/components/ConnectButton/ConnectButtonRenderer.tsx


import React34, { useCallback as useCallback5, useEffect as useEffect7, useState as useState6 } from "react";
import { useAccount as useAccount2, useBalance, useNetwork as useNetwork2 } from "wagmi"; // src/hooks/useIsMounted.ts

import { useEffect, useState } from "react";

var useIsMounted = function useIsMounted() {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      mounted = _useState2[0],
      setMounted = _useState2[1];

  useEffect(function () {
    return setMounted(true);
  }, []);
  return mounted;
}; // src/components/AccountModal/AccountModal.tsx


import React16 from "react"; // src/components/Dialog/Dialog.tsx

import React6, { useCallback as useCallback2, useEffect as useEffect3 } from "react";
import { createPortal } from "react-dom";
import { RemoveScroll } from "react-remove-scroll"; // src/components/RainbowKitProvider/RainbowKitProvider.tsx

import React4, { createContext as createContext3, useContext as useContext2, useMemo as useMemo3 } from "react"; // src/css/cssObjectFromTheme.ts

import { assignInlineVars } from "@vanilla-extract/dynamic";

var resolveThemeVars = function resolveThemeVars(theme) {
  return typeof theme === "function" ? theme() : theme;
};

function cssObjectFromTheme(theme) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      baseTheme = _ref4.extends;

  var resolvedThemeVars = _objectSpread({}, assignInlineVars(themeVars, resolveThemeVars(theme)));

  if (!baseTheme) {
    return resolvedThemeVars;
  }

  var resolvedBaseThemeVars = assignInlineVars(themeVars, resolveThemeVars(baseTheme));
  var filteredVars = Object.fromEntries(Object.entries(resolvedThemeVars).filter(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        varName = _ref6[0],
        value = _ref6[1];

    return value !== resolvedBaseThemeVars[varName];
  }));
  return filteredVars;
} // src/css/cssStringFromTheme.ts


function cssStringFromTheme(theme) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.entries(cssObjectFromTheme(theme, options)).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        key = _ref8[0],
        value = _ref8[1];

    return "".concat(key, ":").concat(value, ";");
  }).join("");
} // src/components/RainbowKitProvider/LearnMoreUrlContext.ts


import { createContext } from "react";
var defaultLearnMoreUrl = "https://learn.rainbow.me/what-is-a-cryptoweb3-wallet-actually";
var LearnMoreUrlContext = createContext(defaultLearnMoreUrl); // src/components/RainbowKitProvider/RainbowKitChainContext.ts

import { createContext as createContext2, useContext, useMemo as useMemo2 } from "react";
var RainbowKitChainContext = createContext2([]);

var useRainbowKitChainsById = function useRainbowKitChainsById() {
  var rainbowkitChains = useContext(RainbowKitChainContext);
  return useMemo2(function () {
    var rainbowkitChainsById = {};
    rainbowkitChains.forEach(function (rkChain) {
      rainbowkitChainsById[rkChain.id] = rkChain;
    });
    return rainbowkitChainsById;
  }, [rainbowkitChains]);
}; // src/utils/isNotNullish.ts


function isNotNullish(value) {
  return value != null;
} // src/components/RainbowKitProvider/provideRainbowKitChains.ts


var chainMetadata = _objectSpread({
  arbitrumOne: {
    chainId: 42161,
    iconUrl: "https://cloudflare-ipfs.com/ipfs/QmVUztw7AXEqh9yFEAUZarG6LYzYFbYAwkxgx2myXgBi7L"
  },
  avalanche: {
    chainId: 43114,
    iconUrl: "https://cloudflare-ipfs.com/ipfs/QmX5GEd2Siv5qpamrujYZjXEAkbEueQK8fvNpEXtiBpjRm"
  },
  hardhat: {
    chainId: 31337,
    iconUrl: "https://cloudflare-ipfs.com/ipfs/QmUjW7Nf8FjaHRk3ADjpnQKP8WE3B4no1wrZYaXz62VinU"
  },
  mainnet: {
    chainId: 1,
    iconUrl: "https://cloudflare-ipfs.com/ipfs/QmV1rDdxo8PzgnMJHG8E2jHsBU1AxyE2T68tm4yv9jKMGh"
  },
  optimism: {
    chainId: 10,
    iconUrl: "https://cloudflare-ipfs.com/ipfs/QmeK3XmVA5vCpzBWoaQLm4o4QdDZV5z4EcABPGhcQtK8Bo"
  },
  polygonMainnet: {
    chainId: 137,
    iconUrl: "https://cloudflare-ipfs.com/ipfs/QmdyoFWCpGCaxmtsYw6FFpuVBv6LCHTzZPYeZagvKYB964"
  }
}, {
  arbitrumRinkeby: null,
  avalancheFuji: null,
  goerli: null,
  kovan: null,
  localhost: null,
  optimismKovan: null,
  polygonTestnetMumbai: null,
  rinkeby: null,
  ropsten: null
});

var chainIconUrlsById = Object.fromEntries(Object.values(chainMetadata).filter(isNotNullish).map(function (_ref9) {
  var chainId = _ref9.chainId,
      iconUrl = _ref9.iconUrl;
  return [chainId, iconUrl];
}));

var provideRainbowKitChains = function provideRainbowKitChains(chains) {
  return chains.map(function (chain) {
    return _objectSpread({
      iconUrl: chainIconUrlsById[chain.id]
    }, chain);
  });
}; // src/components/RainbowKitProvider/RainbowKitProvider.tsx


var ThemeIdContext = createContext3(void 0);
var anonymousDataAttribute = "data-rk";
var idDataAttribute = "data-rk-id";

var createThemeRootProps = function createThemeRootProps(id) {
  return id ? _defineProperty({}, idDataAttribute, id) : _defineProperty({}, anonymousDataAttribute, "");
};

var createThemeRootSelector = function createThemeRootSelector(id) {
  return id ? "[".concat(idDataAttribute, "=\"").concat(id, "\"]") : "[".concat(anonymousDataAttribute, "]");
};

var useThemeRootProps = function useThemeRootProps() {
  var id = useContext2(ThemeIdContext);
  return createThemeRootProps(id);
};

var defaultTheme = lightTheme();

function RainbowKitProvider(_ref12) {
  var chains = _ref12.chains,
      id = _ref12.id,
      _ref12$theme = _ref12.theme,
      theme = _ref12$theme === void 0 ? defaultTheme : _ref12$theme,
      children = _ref12.children,
      _ref12$learnMoreUrl = _ref12.learnMoreUrl,
      learnMoreUrl = _ref12$learnMoreUrl === void 0 ? defaultLearnMoreUrl : _ref12$learnMoreUrl;
  var rainbowkitChains = useMemo3(function () {
    return provideRainbowKitChains(chains);
  }, [chains]);

  if (typeof theme === "function") {
    throw new Error('A theme function was provided to the "theme" prop instead of a theme object. You must execute this function to get the resulting theme object.');
  }

  var selector = createThemeRootSelector(id);
  return /* @__PURE__ */React4.createElement(RainbowKitChainContext.Provider, {
    value: rainbowkitChains
  }, /* @__PURE__ */React4.createElement(LearnMoreUrlContext.Provider, {
    value: learnMoreUrl
  }, /* @__PURE__ */React4.createElement(ThemeIdContext.Provider, {
    value: id
  }, theme ? /* @__PURE__ */React4.createElement("div", _objectSpread({}, createThemeRootProps(id)), /* @__PURE__ */React4.createElement("style", null, ["".concat(selector, "{").concat(cssStringFromTheme("lightMode" in theme ? theme.lightMode : theme), "}"), "darkMode" in theme ? "@media(prefers-color-scheme:dark){".concat(selector, "{").concat(cssStringFromTheme(theme.darkMode, {
    extends: theme.lightMode
  }), "}}") : null].join("")), children) : children)));
} // src/components/Dialog/Dialog.css.ts


var content = "Dialog__9pm4ki5 sprinkles_display_flex_smallScreen__ju367vp sprinkles_flexDirection_column__ju367v1d sprinkles_position_relative__ju367v84";
var overlay = "Dialog__9pm4ki3 sprinkles_alignItems_center_largeScreen__ju367vk sprinkles_alignItems_flex-end_smallScreen__ju367vh sprinkles_background_modalBackdrop_base__ju367va3 sprinkles_display_flex_smallScreen__ju367vp sprinkles_justifyContent_center__ju367v2t sprinkles_position_fixed__ju367v83"; // src/components/Dialog/FocusTrap.tsx

import React5, { useCallback, useEffect as useEffect2, useRef } from "react";

var moveFocusWithin = function moveFocusWithin(element2, position) {
  var focusableElements = element2.querySelectorAll("button:not(:disabled), a[href]");
  if (focusableElements.length === 0) return;
  focusableElements[position === "end" ? focusableElements.length - 1 : 0].focus();
};

function FocusTrap(props) {
  var contentRef = useRef(null);
  useEffect2(function () {
    var previouslyActiveElement = document.activeElement;
    return function () {
      var _a;

      (_a = previouslyActiveElement.focus) == null ? void 0 : _a.call(previouslyActiveElement);
    };
  }, []);
  useEffect2(function () {
    if (contentRef.current) {
      var elementToFocus = contentRef.current.querySelector("[data-auto-focus]");

      if (elementToFocus) {
        elementToFocus.focus();
      } else {
        contentRef.current.focus();
      }
    }
  }, [contentRef]);
  return /* @__PURE__ */React5.createElement(React5.Fragment, null, /* @__PURE__ */React5.createElement("div", {
    onFocus: useCallback(function () {
      return contentRef.current && moveFocusWithin(contentRef.current, "end");
    }, []),
    tabIndex: 0
  }), /* @__PURE__ */React5.createElement("div", _objectSpread({
    ref: contentRef,
    style: {
      outline: "none"
    },
    tabIndex: -1
  }, props)), /* @__PURE__ */React5.createElement("div", {
    onFocus: useCallback(function () {
      return contentRef.current && moveFocusWithin(contentRef.current, "start");
    }, []),
    tabIndex: 0
  }));
} // src/components/Dialog/Dialog.tsx


var stopPropagation = function stopPropagation(event) {
  return event.stopPropagation();
};

function Dialog(_ref13) {
  var children = _ref13.children,
      onClose = _ref13.onClose,
      open = _ref13.open,
      titleId = _ref13.titleId;
  useEffect3(function () {
    var handleEscape = function handleEscape(event) {
      return open && event.key === "Escape" && onClose();
    };

    document.addEventListener("keydown", handleEscape);
    return function () {
      return document.removeEventListener("keydown", handleEscape);
    };
  }, [open, onClose]);
  var handleBackdropClick = useCallback2(function () {
    return onClose();
  }, [onClose]);
  var themeRootProps = useThemeRootProps();
  return /* @__PURE__ */React6.createElement(React6.Fragment, null, open ? createPortal( /* @__PURE__ */React6.createElement(RemoveScroll, null, /* @__PURE__ */React6.createElement(Box, _objectSpread(_objectSpread({}, themeRootProps), {}, {
    "aria-labelledby": titleId,
    "aria-modal": true,
    className: overlay,
    onClick: handleBackdropClick,
    position: "fixed",
    role: "dialog"
  }), /* @__PURE__ */React6.createElement(FocusTrap, {
    className: content,
    onClick: stopPropagation,
    role: "document"
  }, children))), document.body) : null);
} // src/components/Dialog/DialogContent.tsx


import React7 from "react"; // src/utils/isMobile.ts

import { detect } from "detect-browser";

function detectEnv(userAgent) {
  return detect(userAgent);
}

function isAndroid() {
  var os = detectOS();
  return os ? os.toLowerCase().includes("android") : false;
}

function isIOS() {
  var os = detectOS();
  return os ? os.toLowerCase().includes("ios") || os.toLowerCase().includes("mac") && navigator.maxTouchPoints > 1 : false;
}

function detectOS() {
  var env = detectEnv();
  return (env == null ? void 0 : env.os) ? env.os : void 0;
}

function isMobile() {
  var os = detectOS();
  return os ? isAndroid() || isIOS() : false;
} // src/components/Dialog/DialogContent.css.ts


var bottomSheetOverrides = "DialogContent__1ckjpok6";
var dialogContent = "DialogContent__1ckjpok1 sprinkles_background_modalBackground_base__ju367va6 sprinkles_borderColor_modalBorder_base__ju367vcl sprinkles_borderRadius_modal__ju367v12 sprinkles_borderStyle_solid__ju367v15 sprinkles_borderWidth_modalBorderWidth__ju367v1a sprinkles_boxShadow_dialog_base__ju367vdf sprinkles_display_flex_smallScreen__ju367vp sprinkles_flexDirection_column__ju367v1d sprinkles_overflow_hidden__ju367v5x sprinkles_position_relative__ju367v84";
var dialogContentMobile = "DialogContent__1ckjpok5 sprinkles_borderRadius_modalMobile__ju367v13";
var dialogContentWideDesktop = "DialogContent__1ckjpok3 DialogContent__1ckjpok1 sprinkles_background_modalBackground_base__ju367va6 sprinkles_borderColor_modalBorder_base__ju367vcl sprinkles_borderRadius_modal__ju367v12 sprinkles_borderStyle_solid__ju367v15 sprinkles_borderWidth_modalBorderWidth__ju367v1a sprinkles_boxShadow_dialog_base__ju367vdf sprinkles_display_flex_smallScreen__ju367vp sprinkles_flexDirection_column__ju367v1d sprinkles_overflow_hidden__ju367v5x sprinkles_position_relative__ju367v84";
var dialogContentWideMobile = "DialogContent__1ckjpok2 DialogContent__1ckjpok1 sprinkles_background_modalBackground_base__ju367va6 sprinkles_borderColor_modalBorder_base__ju367vcl sprinkles_borderRadius_modal__ju367v12 sprinkles_borderStyle_solid__ju367v15 sprinkles_borderWidth_modalBorderWidth__ju367v1a sprinkles_boxShadow_dialog_base__ju367vdf sprinkles_display_flex_smallScreen__ju367vp sprinkles_flexDirection_column__ju367v1d sprinkles_overflow_hidden__ju367v5x sprinkles_position_relative__ju367v84"; // src/components/Dialog/DialogContent.tsx

function DialogContent(_ref14) {
  var _ref14$bottomSheetOnM = _ref14.bottomSheetOnMobile,
      bottomSheetOnMobile = _ref14$bottomSheetOnM === void 0 ? false : _ref14$bottomSheetOnM,
      children = _ref14.children,
      marginTop = _ref14.marginTop,
      _ref14$padding = _ref14.padding,
      padding = _ref14$padding === void 0 ? "16" : _ref14$padding,
      _ref14$wide = _ref14.wide,
      wide = _ref14$wide === void 0 ? false : _ref14$wide;
  var mobile = isMobile();
  return /* @__PURE__ */React7.createElement(Box, {
    marginTop: marginTop
  }, /* @__PURE__ */React7.createElement(Box, {
    className: [wide ? mobile ? dialogContentWideMobile : dialogContentWideDesktop : dialogContent, mobile ? dialogContentMobile : null, bottomSheetOnMobile ? bottomSheetOverrides : null].join(" ")
  }, /* @__PURE__ */React7.createElement(Box, {
    padding: padding
  }, children)));
} // src/components/ProfileDetails/ProfileDetails.tsx


import React15, { useCallback as useCallback3, useEffect as useEffect4, useState as useState2 } from "react"; // src/components/CloseButton/CloseButton.tsx

import React9 from "react"; // src/components/Icons/Close.tsx

import React8 from "react";

var CloseIcon = function CloseIcon() {
  return /* @__PURE__ */React8.createElement("svg", {
    fill: "none",
    height: "11",
    viewBox: "0 0 12 11",
    width: "12",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React8.createElement("path", {
    d: "M1.34766 10.4277C1.76367 10.8379 2.48438 10.8203 2.86523 10.4395L6 7.30469L9.12305 10.4336C9.52734 10.8379 10.2246 10.8379 10.6348 10.4219C11.0508 10.0059 11.0566 9.30859 10.6523 8.9043L7.5293 5.77539L10.6523 2.65234C11.0566 2.24805 11.0508 1.55078 10.6348 1.14062C10.2188 0.724609 9.52734 0.71875 9.12305 1.12305L6 4.24609L2.86523 1.11719C2.48438 0.736328 1.76367 0.71875 1.34766 1.13477C0.9375 1.55078 0.949219 2.26562 1.33594 2.64648L4.4707 5.77539L1.33594 8.91016C0.949219 9.29102 0.931641 10.0117 1.34766 10.4277Z",
    fill: "currentColor",
    fillOpacity: "0.8"
  }));
}; // src/components/CloseButton/CloseButton.tsx


var CloseButton = function CloseButton(_ref15) {
  var onClose = _ref15.onClose,
      style = _ref15.style;
  var mobile = isMobile();
  return /* @__PURE__ */React9.createElement(Box, {
    alignItems: "center",
    as: "button",
    background: "closeButtonBackground",
    borderColor: "actionButtonBorder",
    borderRadius: "full",
    borderStyle: "solid",
    borderWidth: mobile ? "0" : "1",
    color: "closeButton",
    display: "flex",
    height: mobile ? "32" : "28",
    justifyContent: "center",
    onClick: onClose,
    style: _objectSpread({
      willChange: "transform"
    }, style != null ? style : {}),
    transform: {
      active: "shrinkSm",
      hover: "growLg"
    },
    transition: "default",
    width: mobile ? "32" : "28"
  }, /* @__PURE__ */React9.createElement(CloseIcon, null));
}; // src/components/ConnectButton/formatAddress.ts


function formatAddress(address) {
  var leadingChars = 4;
  var trailingChars = 4;
  return address.length < leadingChars + trailingChars ? address : "".concat(address.substring(0, leadingChars), "\u2026").concat(address.substring(address.length - trailingChars));
} // src/components/Icons/Copied.tsx


import React10 from "react";

var CopiedIcon = function CopiedIcon() {
  return /* @__PURE__ */React10.createElement("svg", {
    fill: "none",
    height: "13",
    viewBox: "0 0 13 13",
    width: "13",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React10.createElement("path", {
    d: "M4.94568 12.2646C5.41052 12.2646 5.77283 12.0869 6.01892 11.7109L12.39 1.96973C12.5677 1.69629 12.6429 1.44336 12.6429 1.2041C12.6429 0.561523 12.1644 0.0966797 11.5082 0.0966797C11.057 0.0966797 10.7767 0.260742 10.5033 0.691406L4.9115 9.50977L2.07458 5.98926C1.82166 5.68848 1.54822 5.55176 1.16541 5.55176C0.502319 5.55176 0.0238037 6.02344 0.0238037 6.66602C0.0238037 6.95312 0.112671 7.20605 0.358765 7.48633L3.88611 11.7588C4.18005 12.1074 4.50818 12.2646 4.94568 12.2646Z",
    fill: "currentColor"
  }));
}; // src/components/Icons/Copy.tsx


import React11 from "react";

var CopyIcon = function CopyIcon() {
  return /* @__PURE__ */React11.createElement("svg", {
    fill: "none",
    height: "16",
    viewBox: "0 0 17 16",
    width: "17",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React11.createElement("path", {
    d: "M3.04236 12.3027H4.18396V13.3008C4.18396 14.8525 5.03845 15.7002 6.59705 15.7002H13.6244C15.183 15.7002 16.0375 14.8525 16.0375 13.3008V6.24609C16.0375 4.69434 15.183 3.84668 13.6244 3.84668H12.4828V2.8418C12.4828 1.29688 11.6283 0.442383 10.0697 0.442383H3.04236C1.48376 0.442383 0.629272 1.29004 0.629272 2.8418V9.90332C0.629272 11.4551 1.48376 12.3027 3.04236 12.3027ZM3.23376 10.5391C2.68689 10.5391 2.39294 10.2656 2.39294 9.68457V3.06055C2.39294 2.47949 2.68689 2.21289 3.23376 2.21289H9.8783C10.4252 2.21289 10.7191 2.47949 10.7191 3.06055V3.84668H6.59705C5.03845 3.84668 4.18396 4.69434 4.18396 6.24609V10.5391H3.23376ZM6.78845 13.9365C6.24158 13.9365 5.94763 13.6699 5.94763 13.0889V6.45801C5.94763 5.87695 6.24158 5.61035 6.78845 5.61035H13.433C13.9799 5.61035 14.2738 5.87695 14.2738 6.45801V13.0889C14.2738 13.6699 13.9799 13.9365 13.433 13.9365H6.78845Z",
    fill: "currentColor"
  }));
}; // src/components/Icons/Disconnect.tsx


import React12 from "react";

var DisconnectIcon = function DisconnectIcon() {
  return /* @__PURE__ */React12.createElement("svg", {
    fill: "none",
    height: "16",
    viewBox: "0 0 18 16",
    width: "18",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React12.createElement("path", {
    d: "M2.67834 15.5908H9.99963C11.5514 15.5908 12.399 14.7432 12.399 13.1777V10.2656H10.6354V12.9863C10.6354 13.5332 10.3688 13.8271 9.78772 13.8271H2.89026C2.3092 13.8271 2.0426 13.5332 2.0426 12.9863V3.15625C2.0426 2.60254 2.3092 2.30859 2.89026 2.30859H9.78772C10.3688 2.30859 10.6354 2.60254 10.6354 3.15625V5.89746H12.399V2.95801C12.399 1.39941 11.5514 0.544922 9.99963 0.544922H2.67834C1.12659 0.544922 0.278931 1.39941 0.278931 2.95801V13.1777C0.278931 14.7432 1.12659 15.5908 2.67834 15.5908ZM7.43616 8.85059H14.0875L15.0924 8.78906L14.566 9.14453L13.6842 9.96484C13.5406 10.1016 13.4586 10.2861 13.4586 10.4844C13.4586 10.8398 13.7321 11.168 14.1217 11.168C14.3199 11.168 14.4635 11.0928 14.6002 10.9561L16.7809 8.68652C16.986 8.48145 17.0543 8.27637 17.0543 8.06445C17.0543 7.85254 16.986 7.64746 16.7809 7.43555L14.6002 5.17285C14.4635 5.03613 14.3199 4.9541 14.1217 4.9541C13.7321 4.9541 13.4586 5.27539 13.4586 5.6377C13.4586 5.83594 13.5406 6.02734 13.6842 6.15723L14.566 6.98438L15.0924 7.33984L14.0875 7.27148H7.43616C7.01917 7.27148 6.65686 7.62012 6.65686 8.06445C6.65686 8.50195 7.01917 8.85059 7.43616 8.85059Z",
    fill: "currentColor"
  }));
}; // src/components/Text/Text.tsx


import React13 from "react";
var Text = React13.forwardRef(function (_ref16, ref) {
  var _ref16$as = _ref16.as,
      as = _ref16$as === void 0 ? "div" : _ref16$as,
      children = _ref16.children,
      className = _ref16.className,
      color = _ref16.color,
      _ref16$font = _ref16.font,
      font = _ref16$font === void 0 ? "body" : _ref16$font,
      id = _ref16.id,
      _ref16$size = _ref16.size,
      size = _ref16$size === void 0 ? "16" : _ref16$size,
      tabIndex = _ref16.tabIndex,
      _ref16$weight = _ref16.weight,
      weight = _ref16$weight === void 0 ? "regular" : _ref16$weight;
  return /* @__PURE__ */React13.createElement(Box, {
    as: as,
    className: className,
    color: color,
    fontFamily: font,
    fontSize: size,
    fontWeight: weight,
    id: id,
    ref: ref,
    tabIndex: tabIndex
  }, children);
});
Text.displayName = "Text"; // src/components/ProfileDetails/ProfileDetailsAction.tsx

import React14 from "react";

function ProfileDetailsAction(_ref17) {
  var action = _ref17.action,
      icon = _ref17.icon,
      label = _ref17.label,
      url = _ref17.url;
  var urlProps = url ? {
    href: url,
    rel: "noreferrer",
    target: "_blank"
  } : {};
  var mobile = isMobile();
  return /* @__PURE__ */React14.createElement(Box, _objectSpread(_objectSpread({
    as: url ? "a" : "button",
    onClick: action
  }, urlProps), {}, {
    background: {
      base: "profileAction",
      hover: "profileActionHover"
    },
    borderRadius: "menuButton",
    boxShadow: "profileDetailsAction",
    padding: mobile ? "8" : "10",
    style: {
      flexBasis: 0,
      flexGrow: 1,
      willChange: "transform"
    },
    transform: {
      active: "shrinkSm",
      hover: "grow"
    },
    transition: "default"
  }), /* @__PURE__ */React14.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "2",
    justifyContent: "center"
  }, /* @__PURE__ */React14.createElement(Box, {
    color: "modalText",
    height: "max"
  }, icon), /* @__PURE__ */React14.createElement(Box, null, /* @__PURE__ */React14.createElement(Text, {
    color: "modalText",
    size: mobile ? "12" : "13",
    weight: "semibold"
  }, label))));
} // src/components/ProfileDetails/ProfileDetails.tsx


function ProfileDetails(_ref18) {
  var accountData = _ref18.accountData,
      balanceData = _ref18.balanceData,
      onClose = _ref18.onClose,
      onDisconnect = _ref18.onDisconnect;

  var _a, _b, _c;

  var _useState3 = useState2(false),
      _useState4 = _slicedToArray(_useState3, 2),
      copiedAddress = _useState4[0],
      setCopiedAddress = _useState4[1];

  var copyAddressAction = useCallback3(function () {
    if (accountData == null ? void 0 : accountData.address) {
      navigator.clipboard.writeText(accountData == null ? void 0 : accountData.address);
      setCopiedAddress(true);
    }
  }, [accountData == null ? void 0 : accountData.address]);
  useEffect4(function () {
    if (copiedAddress) {
      var timer = setTimeout(function () {
        setCopiedAddress(false);
      }, 1500);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [copiedAddress]);

  if (!accountData) {
    return null;
  }

  var accountName = (_b = (_a = accountData.ens) == null ? void 0 : _a.name) != null ? _b : formatAddress(accountData.address);
  var ethBalance = balanceData == null ? void 0 : balanceData.formatted;
  var balance = Number(ethBalance).toPrecision(3);
  var titleId = "rk_profile_title";
  var mobile = isMobile();
  return /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, /* @__PURE__ */React15.createElement(Box, {
    background: "profileForeground",
    padding: "16"
  }, /* @__PURE__ */React15.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "16" : "12",
    justifyContent: "center",
    margin: "8",
    style: {
      textAlign: "center"
    }
  }, /* @__PURE__ */React15.createElement(CloseButton, {
    onClose: onClose,
    style: {
      position: "absolute",
      right: 16,
      top: 16,
      willChange: "transform"
    }
  }), " ", /* @__PURE__ */React15.createElement(Box, {
    marginTop: mobile ? "24" : "0"
  }, /* @__PURE__ */React15.createElement(Avatar, {
    address: accountData.address,
    imageUrl: (_c = accountData.ens) == null ? void 0 : _c.avatar,
    size: mobile ? 82 : 74
  })), /* @__PURE__ */React15.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: mobile ? "4" : "0"
  }, /* @__PURE__ */React15.createElement(Box, null, /* @__PURE__ */React15.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: mobile ? "20" : "18",
    weight: "heavy"
  }, accountName)), /* @__PURE__ */React15.createElement(Box, null, balanceData && /* @__PURE__ */React15.createElement(Box, null, /* @__PURE__ */React15.createElement(Text, {
    as: "h1",
    color: "modalTextSecondary",
    id: titleId,
    size: mobile ? "16" : "14",
    weight: "semibold"
  }, balance, " ", balanceData.symbol))))), /* @__PURE__ */React15.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    gap: "8",
    margin: "2",
    marginTop: "16"
  }, /* @__PURE__ */React15.createElement(ProfileDetailsAction, {
    action: copyAddressAction,
    icon: copiedAddress ? /* @__PURE__ */React15.createElement(CopiedIcon, null) : /* @__PURE__ */React15.createElement(CopyIcon, null),
    label: copiedAddress ? "Copied!" : "Copy Address"
  }), /* @__PURE__ */React15.createElement(ProfileDetailsAction, {
    action: onDisconnect,
    icon: /* @__PURE__ */React15.createElement(DisconnectIcon, null),
    label: "Disconnect"
  })))));
} // src/components/AccountModal/AccountModal.tsx


function AccountModal(_ref19) {
  var accountData = _ref19.accountData,
      balanceData = _ref19.balanceData,
      onClose = _ref19.onClose,
      onDisconnect = _ref19.onDisconnect,
      open = _ref19.open;

  if (!accountData) {
    return null;
  }

  var titleId = "rk_account_modal_title";
  return /* @__PURE__ */React16.createElement(React16.Fragment, null, accountData && /* @__PURE__ */React16.createElement(Dialog, {
    onClose: onClose,
    open: open,
    titleId: titleId
  }, /* @__PURE__ */React16.createElement(DialogContent, {
    bottomSheetOnMobile: true,
    padding: "0"
  }, /* @__PURE__ */React16.createElement(ProfileDetails, {
    accountData: accountData,
    balanceData: balanceData,
    onClose: onClose,
    onDisconnect: onDisconnect
  }))));
} // src/components/ChainModal/ChainModal.tsx


import React18, { Fragment, useEffect as useEffect5, useState as useState3 } from "react";
import { useConnect } from "wagmi"; // src/components/MenuButton/MenuButton.tsx

import React17 from "react"; // src/components/MenuButton/MenuButton.css.ts

var MenuButtonClassName = "sprinkles_paddingTop_6__ju367v7o sprinkles_paddingBottom_6__ju367v63 sprinkles_paddingLeft_6__ju367v6m sprinkles_paddingRight_6__ju367v75 sprinkles_background_menuItemBackground_hover__ju367va1 sprinkles_borderRadius_menuButton__ju367v11 sprinkles_color_modalText_base__ju367vff sprinkles_transform_shrink_active__ju367v8 sprinkles_transition_default_base__ju367vc";
var MobileMenuButtonClassName = "sprinkles_paddingTop_8__ju367v7p sprinkles_paddingBottom_8__ju367v64 sprinkles_paddingLeft_8__ju367v6n sprinkles_paddingRight_8__ju367v76";
var SelectedMenuButtonClassName = "sprinkles_paddingTop_6__ju367v7o sprinkles_paddingBottom_6__ju367v63 sprinkles_paddingLeft_6__ju367v6m sprinkles_paddingRight_6__ju367v75 sprinkles_background_accentColor_base__ju367v8o sprinkles_borderColor_selectedOptionBorder_base__ju367vd6 sprinkles_borderRadius_menuButton__ju367v11 sprinkles_borderStyle_solid__ju367v15 sprinkles_borderWidth_1__ju367v17 sprinkles_boxShadow_selectedOption_base__ju367vdl sprinkles_color_actionButtonText_base__ju367ve3"; // src/components/MenuButton/MenuButton.tsx

var MenuButton = React17.forwardRef(function (_ref20, ref) {
  var _ref20$as = _ref20.as,
      as = _ref20$as === void 0 ? "button" : _ref20$as,
      children = _ref20.children,
      _ref20$currentlySelec = _ref20.currentlySelected,
      currentlySelected = _ref20$currentlySelec === void 0 ? false : _ref20$currentlySelec,
      onClick = _ref20.onClick,
      urlProps = _objectWithoutProperties(_ref20, _excluded3);

  var mobile = isMobile();
  return /* @__PURE__ */React17.createElement(Box, _objectSpread({
    as: as,
    className: [currentlySelected ? SelectedMenuButtonClassName : MenuButtonClassName, mobile ? MobileMenuButtonClassName : null],
    disabled: currentlySelected,
    onClick: onClick,
    ref: ref
  }, urlProps), children);
});
MenuButton.displayName = "MenuButton"; // src/components/ChainModal/ChainModal.tsx

function ChainModal(_ref21) {
  var networkData = _ref21.networkData,
      onClose = _ref21.onClose,
      onSwitchNetwork = _ref21.onSwitchNetwork,
      open = _ref21.open;

  var _useState5 = useState3(),
      _useState6 = _slicedToArray(_useState5, 2),
      switchingToChain = _useState6[0],
      setSwitchingToChain = _useState6[1];

  var _useConnect = useConnect(),
      _useConnect2 = _slicedToArray(_useConnect, 1),
      connectData = _useConnect2[0].data;

  var titleId = "rk_chain_modal_title";
  var mobile = isMobile();
  var rainbowkitChainsById = useRainbowKitChainsById();
  useEffect5(function () {
    if (!connectData.connector) {
      return;
    }

    var stopSwitching = function stopSwitching() {
      setSwitchingToChain(null);
      onClose();
    };

    var provider = connectData.connector.getProvider();
    provider.on("chainChanged", stopSwitching);
    return function () {
      provider.removeListener("chainChanged", stopSwitching);
    };
  }, [connectData.connector, setSwitchingToChain, onClose]);

  if (!networkData || !networkData.chain) {
    return null;
  }

  return /* @__PURE__ */React18.createElement(Dialog, {
    onClose: onClose,
    open: open,
    titleId: titleId
  }, /* @__PURE__ */React18.createElement(DialogContent, {
    bottomSheetOnMobile: true
  }, /* @__PURE__ */React18.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "14"
  }, /* @__PURE__ */React18.createElement(Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
  }, mobile && /* @__PURE__ */React18.createElement("div", null), /* @__PURE__ */React18.createElement(Box, {
    paddingBottom: "0",
    paddingLeft: "10",
    paddingTop: "4"
  }, /* @__PURE__ */React18.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: mobile ? "20" : "18",
    weight: "heavy"
  }, "Switch Networks")), /* @__PURE__ */React18.createElement(CloseButton, {
    onClose: onClose
  })), /* @__PURE__ */React18.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4",
    padding: "2"
  }, onSwitchNetwork && networkData.chains.map(function (chain, idx) {
    var _a, _b, _c;

    var isCurrentChain = chain.id === ((_a = networkData.chain) == null ? void 0 : _a.id);
    var switching = chain.id === switchingToChain;
    var chainIconUrl = (_b = rainbowkitChainsById[chain.id]) == null ? void 0 : _b.iconUrl;
    return /* @__PURE__ */React18.createElement(Fragment, {
      key: chain.id
    }, /* @__PURE__ */React18.createElement(MenuButton, {
      currentlySelected: isCurrentChain,
      onClick: isCurrentChain ? void 0 : function () {
        setSwitchingToChain(chain.id);
        onSwitchNetwork(chain.id);
      }
    }, /* @__PURE__ */React18.createElement(Box, {
      fontFamily: "body",
      fontSize: "16",
      fontWeight: "bold"
    }, /* @__PURE__ */React18.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between"
    }, /* @__PURE__ */React18.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "4",
      height: mobile ? "36" : "28"
    }, chainIconUrl ? /* @__PURE__ */React18.createElement(Box, {
      height: "full",
      marginRight: "8"
    }, /* @__PURE__ */React18.createElement("img", {
      alt: chain.name,
      src: chainIconUrl,
      width: mobile ? "36" : "28"
    })) : null, /* @__PURE__ */React18.createElement("div", null, chain.name)), isCurrentChain && /* @__PURE__ */React18.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      marginRight: "6"
    }, /* @__PURE__ */React18.createElement(Text, {
      color: "actionButtonText",
      size: "14",
      weight: "medium"
    }, "Connected"), /* @__PURE__ */React18.createElement(Box, {
      background: "connectionIndicator",
      borderColor: "selectedOptionBorder",
      borderRadius: "full",
      borderStyle: "solid",
      borderWidth: "2",
      height: "8",
      marginLeft: "8",
      width: "8"
    })), switching && /* @__PURE__ */React18.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      marginRight: "6"
    }, /* @__PURE__ */React18.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "medium"
    }, "Confirm in Wallet"), /* @__PURE__ */React18.createElement(Box, {
      background: "standby",
      borderColor: "selectedOptionBorder",
      borderRadius: "full",
      borderStyle: "solid",
      borderWidth: "2",
      height: "8",
      marginLeft: "8",
      width: "8"
    }))))), mobile && idx < ((_c = networkData == null ? void 0 : networkData.chains) == null ? void 0 : _c.length) - 1 && /* @__PURE__ */React18.createElement(Box, {
      background: "generalBorderDim",
      height: "1",
      marginX: "8"
    }));
  })))));
} // src/components/ConnectModal/ConnectModal.tsx


import React33 from "react";
import { useAccount } from "wagmi"; // src/components/ConnectOptions/ConnectOptions.tsx

import React32 from "react"; // src/components/ConnectOptions/DesktopOptions.tsx

import React30, { Fragment as Fragment2, useEffect as useEffect6, useState as useState4 } from "react"; // src/utils/groupBy.ts

function groupBy(items, getKey) {
  var groupedItems = {};
  items.forEach(function (item) {
    var key = getKey(item);

    if (!key) {
      return;
    }

    if (!groupedItems[key]) {
      groupedItems[key] = [];
    }

    groupedItems[key].push(item);
  });
  return groupedItems;
} // src/wallets/useWalletConnectors.ts


import { useConnect as useConnect2 } from "wagmi"; // src/utils/indexBy.ts

function indexBy(items, getKey) {
  var indexedItems = {};
  items.forEach(function (item) {
    var key = getKey(item);

    if (!key) {
      return;
    }

    indexedItems[key] = item;
  });
  return indexedItems;
} // src/wallets/recentWalletIds.ts


var storageKey = "rk-recent";

function safeParseJsonArray(string) {
  try {
    var value = string ? JSON.parse(string) : [];
    return Array.isArray(value) ? value : [];
  } catch (err) {
    return [];
  }
}

function getRecentWalletIds() {
  return safeParseJsonArray(localStorage.getItem(storageKey));
}

function dedupe(array) {
  return _toConsumableArray(new Set(array));
}

function addRecentWalletId(walletId) {
  var newValue = dedupe([walletId].concat(_toConsumableArray(getRecentWalletIds())));
  localStorage.setItem(storageKey, JSON.stringify(newValue));
} // src/wallets/useWalletConnectors.ts


function useWalletConnectors() {
  var _useConnect3 = useConnect2(),
      _useConnect4 = _slicedToArray(_useConnect3, 2),
      connectData = _useConnect4[0].data,
      connect = _useConnect4[1];

  function connectWallet(_x, _x2) {
    return _connectWallet.apply(this, arguments);
  }

  function _connectWallet() {
    _connectWallet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(walletId, connector) {
      var result;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return connect(connector);

            case 2:
              result = _context.sent;

              if (result.data) {
                addRecentWalletId(walletId);
              }

              return _context.abrupt("return", result);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _connectWallet.apply(this, arguments);
  }

  var connectorByWalletId = indexBy(connectData.connectors, function (connector) {
    var _a;

    return (_a = connector._wallet) == null ? void 0 : _a.id;
  });
  var MAX_RECENT_WALLETS = 3;
  var recentConnectors = getRecentWalletIds().map(function (walletId) {
    return connectorByWalletId[walletId];
  }).filter(isNotNullish).slice(0, MAX_RECENT_WALLETS);
  var connectors = [].concat(_toConsumableArray(recentConnectors), _toConsumableArray(connectData.connectors.filter(function (connector) {
    return !recentConnectors.includes(connector);
  })));
  return connectors.map(function (connector) {
    var _a;

    var wallet = connector._wallet;

    if (!wallet) {
      return null;
    }

    var recent = recentConnectors.includes(connector);
    return _objectSpread(_objectSpread({}, wallet), {}, {
      connect: function connect() {
        return connectWallet(wallet.id, connector);
      },
      groupName: recent ? "Recent" : wallet.groupName,
      ready: ((_a = wallet.installed) != null ? _a : true) && connector.ready,
      recent: recent,
      showWalletConnectModal: wallet.walletConnectModalConnector ? function () {
        return connectWallet(wallet.id, wallet.walletConnectModalConnector);
      } : void 0
    });
  }).filter(isNotNullish);
} // src/components/ConnectModal/ConnectModalIntro.tsx


import React22, { useContext as useContext3 } from "react"; // src/components/Button/ActionButton.tsx

import React19 from "react";
var sizeVariants = {
  large: {
    fontSize: "16",
    paddingX: "24",
    paddingY: "10"
  },
  medium: {
    fontSize: "14",
    height: "28",
    paddingX: "12",
    paddingY: "4"
  },
  small: {
    fontSize: "14",
    paddingX: "10",
    paddingY: "4"
  }
};

function ActionButton(_ref22) {
  var href = _ref22.href,
      label = _ref22.label,
      onClick = _ref22.onClick,
      _ref22$size = _ref22.size,
      size = _ref22$size === void 0 ? "medium" : _ref22$size,
      _ref22$type = _ref22.type,
      type = _ref22$type === void 0 ? "primary" : _ref22$type;
  var isPrimary = type === "primary";
  var isNotLarge = size !== "large";
  var mobile = isMobile();
  var background = isPrimary ? "accentColor" : isNotLarge ? "actionButtonSecondaryBackground" : null;
  var _sizeVariants$size = sizeVariants[size],
      fontSize = _sizeVariants$size.fontSize,
      height = _sizeVariants$size.height,
      paddingX = _sizeVariants$size.paddingX,
      paddingY = _sizeVariants$size.paddingY;
  return /* @__PURE__ */React19.createElement(Box, _objectSpread(_objectSpread(_objectSpread({}, href ? {
    as: "a",
    href: href,
    rel: "noreferrer noopener",
    target: "_blank"
  } : {
    as: "button",
    type: "button"
  }), {}, {
    borderColor: mobile && isNotLarge ? "actionButtonBorderMobile" : "actionButtonBorder",
    borderRadius: "actionButton",
    borderStyle: "solid",
    borderWidth: "1",
    display: "block",
    onClick: onClick,
    paddingX: paddingX,
    paddingY: paddingY,
    style: {
      willChange: "transform"
    },
    transform: {
      active: "shrinkSm",
      hover: "grow"
    },
    transition: "default"
  }, background ? {
    background: background
  } : {}), height ? {
    height: height
  } : {}), /* @__PURE__ */React19.createElement(Text, {
    color: isPrimary ? "actionButtonText" : "accentColor",
    size: fontSize,
    weight: "bold"
  }, label));
} // src/components/Icons/Assets.tsx


import React20 from "react";

var AssetsIcon = function AssetsIcon() {
  return /* @__PURE__ */React20.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /* @__PURE__ */React20.createElement("path", {
    d: "M1.08993 5.46009C0 7.59921 0 10.3995 0 16V32C0 37.6005 0 40.4008 1.08993 42.5399C2.04867 44.4215 3.57847 45.9513 5.46009 46.9101C7.59921 48 10.3995 48 16 48H32C33.7523 48 35.2304 48 36.5 47.9666V36.5H47.9666C48 35.2304 48 33.7523 48 32V16C48 10.3995 48 7.59921 46.9101 5.46009C45.9513 3.57847 44.4215 2.04867 42.5399 1.08993C40.4008 0 37.6005 0 32 0H16C10.3995 0 7.59921 0 5.46009 1.08993C3.57847 2.04867 2.04867 3.57847 1.08993 5.46009Z",
    fill: "url(#paint0_linear_251_1216)"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5 35.5H46.9859C47 34.4754 47 33.3205 47 32V16C47 13.1832 46.9992 11.1308 46.8671 9.51345C46.7359 7.90777 46.4802 6.81918 46.0191 5.91408C45.1562 4.22063 43.7794 2.8438 42.0859 1.98094C41.1808 1.51977 40.0922 1.26411 38.4865 1.13292C36.8692 1.00078 34.8168 1 32 1H16C13.1832 1 11.1308 1.00078 9.51345 1.13292C7.90777 1.26411 6.81918 1.51977 5.91409 1.98094C4.22063 2.8438 2.8438 4.22063 1.98094 5.91409C1.51977 6.81918 1.26411 7.90777 1.13292 9.51345C1.00078 11.1308 1 13.1832 1 16V32C1 34.8168 1.00078 36.8692 1.13292 38.4865C1.26411 40.0922 1.51977 41.1808 1.98094 42.0859C2.8438 43.7794 4.22063 45.1562 5.91409 46.0191C6.81918 46.4802 7.90777 46.7359 9.51345 46.8671C11.1308 46.9992 13.1832 47 16 47H32C33.3205 47 34.4754 47 35.5 46.9859V35.5ZM36.5 47.9666C35.2304 48 33.7523 48 32 48H16C10.3995 48 7.59921 48 5.46009 46.9101C3.57847 45.9513 2.04867 44.4215 1.08993 42.5399C0 40.4008 0 37.6005 0 32V16C0 10.3995 0 7.59921 1.08993 5.46009C2.04867 3.57847 3.57847 2.04867 5.46009 1.08993C7.59921 0 10.3995 0 16 0H32C37.6005 0 40.4008 0 42.5399 1.08993C44.4215 2.04867 45.9513 3.57847 46.9101 5.46009C48 7.59921 48 10.3995 48 16V32C48 33.7523 48 35.2304 47.9666 36.5H36.5V47.9666Z",
    fill: "black",
    fillOpacity: "0.04"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M3 14.2C3 10.2796 3 8.31945 3.76295 6.82207C4.43407 5.50493 5.50493 4.43407 6.82207 3.76295C8.31945 3 10.2796 3 14.2 3H33.8C37.7204 3 39.6805 3 41.1779 3.76295C42.4951 4.43407 43.5659 5.50493 44.237 6.82207C45 8.31945 45 10.2796 45 14.2V33.8C45 37.7204 45 39.6805 44.237 41.1779C43.5659 42.4951 42.4951 43.5659 41.1779 44.237C39.6805 45 37.7204 45 33.8 45H14.2C10.2796 45 8.31945 45 6.82207 44.237C5.50493 43.5659 4.43407 42.4951 3.76295 41.1779C3 39.6805 3 37.7204 3 33.8V14.2Z",
    fill: "black",
    fillOpacity: "0.85"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8 3.5H14.2C12.2316 3.5 10.7853 3.50039 9.64313 3.59371C8.50679 3.68655 7.71552 3.86888 7.04906 4.20846C5.82601 4.83163 4.83163 5.82601 4.20846 7.04906C3.86888 7.71552 3.68655 8.50679 3.59371 9.64313C3.50039 10.7853 3.5 12.2316 3.5 14.2V33.8C3.5 35.7684 3.50039 37.2147 3.59371 38.3569C3.68655 39.4932 3.86888 40.2845 4.20846 40.9509C4.83163 42.174 5.82601 43.1684 7.04906 43.7915C7.71552 44.1311 8.50679 44.3134 9.64313 44.4063C10.7853 44.4996 12.2316 44.5 14.2 44.5H33.8C35.7684 44.5 37.2147 44.4996 38.3569 44.4063C39.4932 44.3134 40.2845 44.1311 40.9509 43.7915C42.174 43.1684 43.1684 42.174 43.7915 40.9509C44.1311 40.2845 44.3134 39.4932 44.4063 38.3569C44.4996 37.2147 44.5 35.7684 44.5 33.8V14.2C44.5 12.2316 44.4996 10.7853 44.4063 9.64313C44.3134 8.50679 44.1311 7.71552 43.7915 7.04906C43.1684 5.82601 42.174 4.83163 40.9509 4.20846C40.2845 3.86888 39.4932 3.68655 38.3569 3.59371C37.2147 3.50039 35.7684 3.5 33.8 3.5ZM3.76295 6.82207C3 8.31945 3 10.2796 3 14.2V33.8C3 37.7204 3 39.6805 3.76295 41.1779C4.43407 42.4951 5.50493 43.5659 6.82207 44.237C8.31945 45 10.2796 45 14.2 45H33.8C37.7204 45 39.6805 45 41.1779 44.237C42.4951 43.5659 43.5659 42.4951 44.237 41.1779C45 39.6805 45 37.7204 45 33.8V14.2C45 10.2796 45 8.31945 44.237 6.82207C43.5659 5.50493 42.4951 4.43407 41.1779 3.76295C39.6805 3 37.7204 3 33.8 3H14.2C10.2796 3 8.31945 3 6.82207 3.76295C5.50493 4.43407 4.43407 5.50493 3.76295 6.82207Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M25 13C25 10.1997 25 8.79961 25.545 7.73005C26.0243 6.78924 26.7892 6.02433 27.73 5.54497C28.7996 5 30.1997 5 33 5H35C37.8003 5 39.2004 5 40.27 5.54497C41.2108 6.02433 41.9757 6.78924 42.455 7.73005C43 8.79961 43 10.1997 43 13V15C43 17.8003 43 19.2004 42.455 20.27C41.9757 21.2108 41.2108 21.9757 40.27 22.455C39.2004 23 37.8003 23 35 23H33C30.1997 23 28.7996 23 27.73 22.455C26.7892 21.9757 26.0243 21.2108 25.545 20.27C25 19.2004 25 17.8003 25 15V13Z",
    fill: "#DFD7D5"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 16.8125H30.0625V17.375H37.9375V16.8125Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 17.375H30.0625V17.9375H37.9375V17.375Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 17.9375H30.0625V18.5H37.9375V17.9375Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 18.5H30.0625V19.0625H37.9375V18.5Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 19.0625H30.0625V19.625H31.1875V19.0625Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 19.0625H31.75V19.625H37.9375V19.0625Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 19.625H30.0625V20.1875H31.1875V19.625Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 19.625H31.75V20.1875H37.9375V19.625Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 20.1875H30.0625V20.75H31.1875V20.1875Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 20.1875H31.75V20.75H37.9375V20.1875Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 20.75H30.0625V21.3125H31.1875V20.75Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 20.75H31.75V21.3125H37.9375V20.75Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 21.3125H30.0625V21.875H31.1875V21.3125Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 21.3125H31.75V21.875H37.9375V21.3125Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 21.875H30.0625V22.4375H31.1875V21.875Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 21.875H31.75V22.4375H37.9375V21.875Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 16.8125H30.0625V17.375H37.9375V16.8125Z",
    fill: "#FF1A0B"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 17.375H30.0625V17.9375H37.9375V17.375Z",
    fill: "#FF1A0B"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 17.9375H30.0625V18.5H37.9375V17.9375Z",
    fill: "#F78A18"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 18.5H30.0625V19.0625H37.9375V18.5Z",
    fill: "#F78A18"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 19.0625H30.0625V19.625H31.1875V19.0625Z",
    fill: "#FFF449"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 19.0625H31.75V19.625H37.9375V19.0625Z",
    fill: "#FFF449"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 19.625H30.0625V20.1875H31.1875V19.625Z",
    fill: "#FFF449"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 19.625H31.75V20.1875H37.9375V19.625Z",
    fill: "#FFF449"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 20.1875H30.0625V20.75H31.1875V20.1875Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 20.1875H31.75V20.75H37.9375V20.1875Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 20.75H30.0625V21.3125H31.1875V20.75Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 20.75H31.75V21.3125H37.9375V20.75Z",
    fill: "#068940"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 21.3125H30.0625V21.875H31.1875V21.3125Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 21.3125H31.75V21.875H37.9375V21.3125Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 21.875H30.0625V22.4375H31.1875V21.875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 21.875H31.75V22.4375H37.9375V21.875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 22.9921C30.774 22.986 30.4014 22.9751 30.0625 22.9557V22.4375H31.1875V22.9921Z",
    fill: "#9F21A0"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33 23H35C36.2129 23 37.1631 23 37.9375 22.9557V22.4375H31.75V22.9977C32.1332 23 32.5484 23 33 23Z",
    fill: "#9F21A0"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34.5625 6.6875H32.3125V7.25H34.5625V6.6875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.6875 7.25H32.875V7.8125H35.6875V7.25Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 7.8125H33.4375V8.375H36.25V7.8125Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 8.375H33.4375V8.9375H36.25V8.375Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M27.25 8.9375H26.6875V9.5H27.25V8.9375Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.8125 8.9375H33.4375V9.5H36.8125V8.9375Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M27.8125 9.5H27.25V10.0625H27.8125V9.5Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M38.5 9.5H32.3125V10.0625H38.5V9.5Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M28.375 10.0625H27.25V10.625H28.375V10.0625Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.0625 10.0625H31.1875V10.625H39.0625V10.0625Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M28.9375 10.625H27.25V11.1875H28.9375V10.625Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.625 10.625H30.0625V11.1875H39.625V10.625Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M29.5 11.1875H27.8125V11.75H29.5V11.1875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M40.1875 11.1875H30.0625V11.75H40.1875V11.1875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M30.0625 11.75H27.8125V12.3125H30.0625V11.75Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M40.75 11.75H30.0625V12.3125H40.75V11.75Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M30.0625 12.3125H28.375V12.875H30.0625V12.3125Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M40.75 12.3125H30.0625V12.875H40.75V12.3125Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M30.0625 12.875H28.375V13.4375H30.0625V12.875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.0625 12.875H30.0625V13.4375H39.0625V12.875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.625 12.875H39.0625V13.4375H39.625V12.875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M40.1875 12.875H39.625V13.4375H40.1875V12.875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M30.0625 13.4375H28.375V14H30.0625V13.4375Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.0625 13.4375H30.0625V14H39.0625V13.4375Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.625 13.4375H39.0625V14H39.625V13.4375Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M40.1875 13.4375H39.625V14H40.1875V13.4375Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M29.5 14H27.8125V14.5625H29.5V14Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.625 14H30.0625V14.5625H39.625V14Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M28.9375 14.5625H27.8125V15.125H28.9375V14.5625Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.625 14.5625H30.0625V15.125H39.625V14.5625Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M28.375 15.125H27.8125V15.6875H28.375V15.125Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.75 15.125H30.0625V15.6875H31.75V15.125Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.3125 15.125H31.75V15.6875H32.3125V15.125Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.875 15.125H32.3125V15.6875H32.875V15.125Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33.4375 15.125H32.875V15.6875H33.4375V15.125Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34.5625 15.125H33.4375V15.6875H34.5625V15.125Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.6875 15.125H34.5625V15.6875H35.6875V15.125Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 15.125H35.6875V15.6875H36.25V15.125Z",
    fill: "white"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.8125 15.125H36.25V15.6875H36.8125V15.125Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.375 15.125H36.8125V15.6875H37.375V15.125Z",
    fill: "white"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 15.125H37.375V15.6875H37.9375V15.125Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M38.5 15.125H37.9375V15.6875H38.5V15.125Z",
    fill: "white"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.0625 15.125H38.5V15.6875H39.0625V15.125Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M27.8125 15.6875H27.25V16.25H27.8125V15.6875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 15.6875H30.0625V16.25H31.1875V15.6875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.75 15.6875H31.1875V16.25H31.75V15.6875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.3125 15.6875H31.75V16.25H32.3125V15.6875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.875 15.6875H32.3125V16.25H32.875V15.6875Z",
    fill: "#395ED1"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34 15.6875H32.875V16.25H34V15.6875Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.125 15.6875H34V16.25H35.125V15.6875Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.6875 15.6875H35.125V16.25H35.6875V15.6875Z",
    fill: "white"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 15.6875H35.6875V16.25H36.25V15.6875Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.8125 15.6875H36.25V16.25H36.8125V15.6875Z",
    fill: "white"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.375 15.6875H36.8125V16.25H37.375V15.6875Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 15.6875H37.375V16.25H37.9375V15.6875Z",
    fill: "white"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M39.0625 15.6875H37.9375V16.25H39.0625V15.6875Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33.4375 16.25H30.0625V16.8125H33.4375V16.25Z",
    fill: "#2B83F6"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M38.5 16.25H33.4375V16.8125H38.5V16.25Z",
    fill: "#7CC4F2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34 11.1875H30.625V11.75H34V11.1875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 11.1875H34.5625V11.75H37.9375V11.1875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 11.75H30.625V12.3125H31.1875V11.75Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.3125 11.75H31.1875V12.3125H32.3125V11.75Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33.4375 11.75H32.3125V12.3125H33.4375V11.75Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34 11.75H33.4375V12.3125H34V11.75Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.125 11.75H34.5625V12.3125H35.125V11.75Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 11.75H35.125V12.3125H36.25V11.75Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.375 11.75H36.25V12.3125H37.375V11.75Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 11.75H37.375V12.3125H37.9375V11.75Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 12.3125H28.9375V12.875H31.1875V12.3125Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.3125 12.3125H31.1875V12.875H32.3125V12.3125Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33.4375 12.3125H32.3125V12.875H33.4375V12.3125Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.125 12.3125H33.4375V12.875H35.125V12.3125Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 12.3125H35.125V12.875H36.25V12.3125Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.375 12.3125H36.25V12.875H37.375V12.3125Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 12.3125H37.375V12.875H37.9375V12.3125Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M29.5 12.875H28.9375V13.4375H29.5V12.875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 12.875H30.625V13.4375H31.1875V12.875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.3125 12.875H31.1875V13.4375H32.3125V12.875Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33.4375 12.875H32.3125V13.4375H33.4375V12.875Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34 12.875H33.4375V13.4375H34V12.875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.125 12.875H34.5625V13.4375H35.125V12.875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 12.875H35.125V13.4375H36.25V12.875Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.375 12.875H36.25V13.4375H37.375V12.875Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 12.875H37.375V13.4375H37.9375V12.875Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M29.5 13.4375H28.9375V14H29.5V13.4375Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M31.1875 13.4375H30.625V14H31.1875V13.4375Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.3125 13.4375H31.1875V14H32.3125V13.4375Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M33.4375 13.4375H32.3125V14H33.4375V13.4375Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34 13.4375H33.4375V14H34V13.4375Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M35.125 13.4375H34.5625V14H35.125V13.4375Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.25 13.4375H35.125V14H36.25V13.4375Z",
    fill: "#FDF8FF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.375 13.4375H36.25V14H37.375V13.4375Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 13.4375H37.375V14H37.9375V13.4375Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M34 14H30.625V14.5625H34V14Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M37.9375 14H34.5625V14.5625H37.9375V14Z",
    fill: "#D7D3CD"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35 5.5H33C31.5916 5.5 30.5654 5.50039 29.7567 5.56646C28.9539 5.63205 28.4096 5.75989 27.957 5.99047C27.1103 6.4219 26.4219 7.11031 25.9905 7.95704C25.7599 8.40959 25.6321 8.95389 25.5665 9.75673C25.5004 10.5654 25.5 11.5916 25.5 13V15C25.5 16.4084 25.5004 17.4346 25.5665 18.2433C25.6321 19.0461 25.7599 19.5904 25.9905 20.043C26.4219 20.8897 27.1103 21.5781 27.957 22.0095C28.4096 22.2401 28.9539 22.3679 29.7567 22.4335C30.5654 22.4996 31.5916 22.5 33 22.5H35C36.4084 22.5 37.4346 22.4996 38.2433 22.4335C39.0461 22.3679 39.5904 22.2401 40.043 22.0095C40.8897 21.5781 41.5781 20.8897 42.0095 20.043C42.2401 19.5904 42.3679 19.0461 42.4335 18.2433C42.4996 17.4346 42.5 16.4084 42.5 15V13C42.5 11.5916 42.4996 10.5654 42.4335 9.75673C42.3679 8.95389 42.2401 8.40959 42.0095 7.95704C41.5781 7.11031 40.8897 6.4219 40.043 5.99047C39.5904 5.75989 39.0461 5.63205 38.2433 5.56646C37.4346 5.50039 36.4084 5.5 35 5.5ZM25.545 7.73005C25 8.79961 25 10.1997 25 13V15C25 17.8003 25 19.2004 25.545 20.27C26.0243 21.2108 26.7892 21.9757 27.73 22.455C28.7996 23 30.1997 23 33 23H35C37.8003 23 39.2004 23 40.27 22.455C41.2108 21.9757 41.9757 21.2108 42.455 20.27C43 19.2004 43 17.8003 43 15V13C43 10.1997 43 8.79961 42.455 7.73005C41.9757 6.78924 41.2108 6.02433 40.27 5.54497C39.2004 5 37.8003 5 35 5H33C30.1997 5 28.7996 5 27.73 5.54497C26.7892 6.02433 26.0243 6.78924 25.545 7.73005Z",
    fill: "white",
    fillOpacity: "0.3"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M5 33C5 30.1997 5 28.7996 5.54497 27.73C6.02433 26.7892 6.78924 26.0243 7.73005 25.545C8.79961 25 10.1997 25 13 25H15C17.8003 25 19.2004 25 20.27 25.545C21.2108 26.0243 21.9757 26.7892 22.455 27.73C23 28.7996 23 30.1997 23 33V35C23 37.8003 23 39.2004 22.455 40.27C21.9757 41.2108 21.2108 41.9757 20.27 42.455C19.2004 43 17.8003 43 15 43H13C10.1997 43 8.79961 43 7.73005 42.455C6.78924 41.9757 6.02433 41.2108 5.54497 40.27C5 39.2004 5 37.8003 5 35V33Z",
    fill: "#564CBF"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M11.1875 26.125H11.75V28.9375H12.3125V26.125H12.875V29.5H13.4375V26.125H14V29.5H14.5625V26.125H15.125V28.9375H15.6875V26.125H16.25V28.375H16.8125V26.6875H17.375V28.9375H16.8125V29.5H16.25V30.0625H15.125V30.625H12.3125V30.0625H11.1875V29.5H10.625V28.9375H10.0625V26.6875H10.625V28.375H11.1875V26.125Z",
    fill: "#FF66B3"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M13.4375 30.625H14V31.1875H15.125V33.4375H16.25V32.875H16.8125V34H15.125V35.125H14.5625V36.25H15.125V41.875H14.5625V36.8125H14V36.25H12.3125V35.125H12.875V35.6875H14V34.5625H14.5625V31.75H13.4375V30.625Z",
    fill: "#B3FFCC"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M16.25 26.125H16.8125V28.375H16.25V26.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M10.625 26.6875H11.1875V28.375H10.625V26.6875Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M17.9375 26.6875H17.375V28.9375H16.8125V29.5H16.25V30.0625H16.8125V29.5H17.375V28.9375H17.9375V26.6875Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M11.75 26.125H12.3125V28.9375H11.75V26.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M15.6875 26.125H15.125V28.9375H15.6875V26.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M12.875 26.125H13.4375V29.5H12.875V26.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M14.5625 26.125H14V29.5H14.5625V26.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M15.125 30.0625H15.6875V30.625H15.125V30.0625Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M14.5625 30.625H14V31.1875H14.5625V30.625Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M15.125 31.1875H15.6875V33.4375H15.125V31.1875Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M17.375 32.875H16.8125V34H17.375V32.875Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M15.125 34H15.6875V35.125H15.125V34Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M15.125 36.25V35.125H14.5625V36.25H15.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M15.125 36.25V41.875H15.6875V36.25H15.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M12.875 35.125H13.4375V35.6875H12.875V35.125Z",
    fill: "black",
    fillOpacity: "0.9"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25.5H13C11.5916 25.5 10.5654 25.5004 9.75673 25.5665C8.95389 25.6321 8.40959 25.7599 7.95704 25.9905C7.11031 26.4219 6.4219 27.1103 5.99047 27.957C5.75989 28.4096 5.63205 28.9539 5.56646 29.7567C5.50039 30.5654 5.5 31.5916 5.5 33V35C5.5 36.4084 5.50039 37.4346 5.56646 38.2433C5.63205 39.0461 5.75989 39.5904 5.99047 40.043C6.4219 40.8897 7.11031 41.5781 7.95704 42.0095C8.40959 42.2401 8.95389 42.3679 9.75673 42.4335C10.5654 42.4996 11.5916 42.5 13 42.5H15C16.4084 42.5 17.4346 42.4996 18.2433 42.4335C19.0461 42.3679 19.5904 42.2401 20.043 42.0095C20.8897 41.5781 21.5781 40.8897 22.0095 40.043C22.2401 39.5904 22.3679 39.0461 22.4335 38.2433C22.4996 37.4346 22.5 36.4084 22.5 35V33C22.5 31.5916 22.4996 30.5654 22.4335 29.7567C22.3679 28.9539 22.2401 28.4096 22.0095 27.957C21.5781 27.1103 20.8897 26.4219 20.043 25.9905C19.5904 25.7599 19.0461 25.6321 18.2433 25.5665C17.4346 25.5004 16.4084 25.5 15 25.5ZM5.54497 27.73C5 28.7996 5 30.1997 5 33V35C5 37.8003 5 39.2004 5.54497 40.27C6.02433 41.2108 6.78924 41.9757 7.73005 42.455C8.79961 43 10.1997 43 13 43H15C17.8003 43 19.2004 43 20.27 42.455C21.2108 41.9757 21.9757 41.2108 22.455 40.27C23 39.2004 23 37.8003 23 35V33C23 30.1997 23 28.7996 22.455 27.73C21.9757 26.7892 21.2108 26.0243 20.27 25.545C19.2004 25 17.8003 25 15 25H13C10.1997 25 8.79961 25 7.73005 25.545C6.78924 26.0243 6.02433 26.7892 5.54497 27.73Z",
    fill: "white",
    fillOpacity: "0.12"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M5 13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5H15C17.8003 5 19.2004 5 20.27 5.54497C21.2108 6.02433 21.9757 6.78924 22.455 7.73005C23 8.79961 23 10.1997 23 13V15C23 17.8003 23 19.2004 22.455 20.27C21.9757 21.2108 21.2108 21.9757 20.27 22.455C19.2004 23 17.8003 23 15 23H13C10.1997 23 8.79961 23 7.73005 22.455C6.78924 21.9757 6.02433 21.2108 5.54497 20.27C5 19.2004 5 17.8003 5 15V13Z",
    fill: "#172D99"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 13.1H8.60001V14H11.3V13.1ZM11.3 14H13.1V14.9H14V15.8V16.7H13.1V15.8H12.2V14.9H11.3V14ZM14 16.7L14.9 16.7V19.4H14V16.7Z",
    fill: "#00A2D8"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 12.2H8.60001V13.1H11.3V12.2ZM11.3 13.1H13.1V14H11.3V13.1ZM14 14.9H13.1V14H14V14.9ZM14.9 16.7H14V14.9H14.9V16.7ZM14.9 16.7H15.8V19.4H14.9V16.7Z",
    fill: "#00DE6F"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 11.3H8.60001V12.2H11.3V11.3ZM11.3 12.2H13.1V13.1H11.3V12.2ZM14 14H13.1V13.1L14 13.1V14ZM14.9 14.9H14V14H14.9V14.9ZM15.8 16.7H14.9V14.9H15.8V16.7ZM15.8 16.7H16.7V19.4H15.8V16.7Z",
    fill: "#FFEB00"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3 10.4H8.60001V11.3H11.3V10.4ZM11.3 11.3H14V12.2H14.9V13.1H15.8V14H16.7V15.8H17.6V19.4H16.7V16.7H15.8V14.9H14.9V14H14V13.1H13.1V12.2H11.3V11.3Z",
    fill: "#FFAA00"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 9.5H8.60001V10.4H11.3V11.3H14V12.2H14.9V13.1H15.8V14H16.7V15.8H17.6L17.6 19.4H18.5V15.8H17.6V14H16.7V13.1H15.8V12.2L14.9 12.2V11.3H14V10.4H12.2V9.5Z",
    fill: "#DD3D1C"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2 8.60001H8.60001V9.50001H12.2V8.60001ZM12.2 9.5H14V10.4H12.2V9.5ZM17.6 14H16.7V13.1H15.8V12.2L14.9 12.2V11.3H14V10.4H15.8V11.3H16.7V12.2L17.6 12.2V13.1L17.6 14ZM18.5 15.8H17.6L17.6 14H18.5V15.8ZM18.5 15.8H19.4V19.4H18.5V15.8Z",
    fill: "#C03078"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5.5H13C11.5916 5.5 10.5654 5.50039 9.75673 5.56646C8.95389 5.63205 8.40959 5.75989 7.95704 5.99047C7.11031 6.4219 6.4219 7.11031 5.99047 7.95704C5.75989 8.40959 5.63205 8.95389 5.56646 9.75673C5.50039 10.5654 5.5 11.5916 5.5 13V15C5.5 16.4084 5.50039 17.4346 5.56646 18.2433C5.63205 19.0461 5.75989 19.5904 5.99047 20.043C6.4219 20.8897 7.11031 21.5781 7.95704 22.0095C8.40959 22.2401 8.95389 22.3679 9.75673 22.4335C10.5654 22.4996 11.5916 22.5 13 22.5H15C16.4084 22.5 17.4346 22.4996 18.2433 22.4335C19.0461 22.3679 19.5904 22.2401 20.043 22.0095C20.8897 21.5781 21.5781 20.8897 22.0095 20.043C22.2401 19.5904 22.3679 19.0461 22.4335 18.2433C22.4996 17.4346 22.5 16.4084 22.5 15V13C22.5 11.5916 22.4996 10.5654 22.4335 9.75673C22.3679 8.95389 22.2401 8.40959 22.0095 7.95704C21.5781 7.11031 20.8897 6.4219 20.043 5.99047C19.5904 5.75989 19.0461 5.63205 18.2433 5.56646C17.4346 5.50039 16.4084 5.5 15 5.5ZM5.54497 7.73005C5 8.79961 5 10.1997 5 13V15C5 17.8003 5 19.2004 5.54497 20.27C6.02433 21.2108 6.78924 21.9757 7.73005 22.455C8.79961 23 10.1997 23 13 23H15C17.8003 23 19.2004 23 20.27 22.455C21.2108 21.9757 21.9757 21.2108 22.455 20.27C23 19.2004 23 17.8003 23 15V13C23 10.1997 23 8.79961 22.455 7.73005C21.9757 6.78924 21.2108 6.02433 20.27 5.54497C19.2004 5 17.8003 5 15 5H13C10.1997 5 8.79961 5 7.73005 5.54497C6.78924 6.02433 6.02433 6.78924 5.54497 7.73005Z",
    fill: "white",
    fillOpacity: "0.12"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M48 36.5C48 42.8513 42.8513 48 36.5 48C30.1487 48 25 42.8513 25 36.5C25 30.1487 30.1487 25 36.5 25C42.8513 25 48 30.1487 48 36.5Z",
    fill: "#99B3FF"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 47.5C42.5751 47.5 47.5 42.5751 47.5 36.5C47.5 30.4249 42.5751 25.5 36.5 25.5C30.4249 25.5 25.5 30.4249 25.5 36.5C25.5 42.5751 30.4249 47.5 36.5 47.5ZM36.5 48C42.8513 48 48 42.8513 48 36.5C48 30.1487 42.8513 25 36.5 25C30.1487 25 25 30.1487 25 36.5C25 42.8513 30.1487 48 36.5 48Z",
    fill: "black",
    fillOpacity: "0.12"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M46 36.5C46 41.7467 41.7467 46 36.5 46C31.2533 46 27 41.7467 27 36.5C27 31.2533 31.2533 27 36.5 27C41.7467 27 46 31.2533 46 36.5Z",
    fill: "#7F91EB"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5 45.5C41.4706 45.5 45.5 41.4706 45.5 36.5C45.5 31.5294 41.4706 27.5 36.5 27.5C31.5294 27.5 27.5 31.5294 27.5 36.5C27.5 41.4706 31.5294 45.5 36.5 45.5ZM36.5 46C41.7467 46 46 41.7467 46 36.5C46 31.2533 41.7467 27 36.5 27C31.2533 27 27 31.2533 27 36.5C27 41.7467 31.2533 46 36.5 46Z",
    fill: "black",
    fillOpacity: "0.12"
  }), /* @__PURE__ */React20.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9119 37.0372C31.8155 36.9687 31.7461 36.8678 31.7169 36.7522C31.6843 36.6229 31.7047 36.4859 31.7735 36.3717L36.0705 29.2419C36.161 29.0918 36.3235 29 36.4988 29C36.674 29 36.8365 29.0918 36.927 29.2419L41.2239 36.3717C41.2928 36.4859 41.3131 36.6229 41.2805 36.7522C41.2514 36.8673 41.1826 36.9677 41.0869 37.0363C41.1154 37.0564 41.1421 37.0798 41.1664 37.1063C41.3261 37.28 41.3426 37.5418 41.206 37.7342L36.9065 43.7894C36.8127 43.9214 36.6607 43.9999 36.4987 43.9999C36.3367 43.9999 36.1848 43.9214 36.091 43.7893L31.794 37.734C31.6574 37.5416 31.674 37.2799 31.8337 37.1062C31.8577 37.0801 31.8839 37.0571 31.9119 37.0372ZM32.2017 37.4447L36.4988 39.9833L40.7983 37.4447L36.4988 43.4999L32.2017 37.4447ZM32.2017 36.6298L36.4988 29.5L40.7957 36.6298L36.4988 39.1698L32.2017 36.6298Z",
    fill: "white",
    fillOpacity: "0.2"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.4987 29.5L36.5 35L36.4987 39.1698L40.7957 36.6298L36.4987 29.5Z",
    fill: "black",
    fillOpacity: "0.55"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.4987 29.5L32.2017 36.6298L36.4987 39.1698V34.6767V29.5Z",
    fill: "black",
    fillOpacity: "0.3"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.4988 39.9833L36.5 41.5L36.4988 43.4999L40.7983 37.4447L36.4988 39.9833Z",
    fill: "black",
    fillOpacity: "0.55"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.4987 43.4999V39.9833L32.2017 37.4447L36.4987 43.4999Z",
    fill: "black",
    fillOpacity: "0.3"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M36.4988 39.1698L40.7957 36.6298L36.4988 34.6767V39.1698Z",
    fill: "black"
  }), /* @__PURE__ */React20.createElement("path", {
    d: "M32.2017 36.6298L36.4987 39.1698V34.6767L32.2017 36.6298Z",
    fill: "black",
    fillOpacity: "0.6"
  }), /* @__PURE__ */React20.createElement("defs", null, /* @__PURE__ */React20.createElement("linearGradient", {
    id: "paint0_linear_251_1216",
    x1: "24",
    y1: "0",
    x2: "24",
    y2: "48",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */React20.createElement("stop", {
    stopColor: "#DDE1EB"
  }), /* @__PURE__ */React20.createElement("stop", {
    offset: "1",
    stopColor: "#CAD0DB"
  }))));
}; // src/components/Icons/Login.tsx


import React21 from "react";

var LoginIcon = function LoginIcon() {
  return /* @__PURE__ */React21.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /* @__PURE__ */React21.createElement("rect", {
    width: "48",
    height: "48",
    rx: "10",
    fill: "url(#paint0_linear_251_1214)"
  }), /* @__PURE__ */React21.createElement("rect", {
    width: "48",
    height: "48",
    rx: "10",
    fill: "url(#paint1_linear_251_1214)"
  }), /* @__PURE__ */React21.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "47",
    height: "47",
    rx: "9.5",
    stroke: "black",
    strokeOpacity: "0.04"
  }), /* @__PURE__ */React21.createElement("rect", {
    x: "3",
    y: "3",
    width: "42",
    height: "42",
    rx: "7",
    fill: "url(#paint2_radial_251_1214)"
  }), /* @__PURE__ */React21.createElement("rect", {
    x: "3",
    y: "3",
    width: "42",
    height: "42",
    rx: "7",
    fill: "url(#paint3_radial_251_1214)",
    fillOpacity: "0.7",
    style: {
      mixBlendMode: "screen"
    }
  }), /* @__PURE__ */React21.createElement("rect", {
    x: "3.25",
    y: "3.25",
    width: "41.5",
    height: "41.5",
    rx: "6.75",
    stroke: "black",
    strokeOpacity: "0.2",
    strokeWidth: "0.5"
  }), /* @__PURE__ */React21.createElement("rect", {
    x: "4",
    y: "4",
    width: "40",
    height: "40",
    rx: "6",
    stroke: "white",
    strokeOpacity: "0.2",
    style: {
      mixBlendMode: "overlay"
    }
  }), /* @__PURE__ */React21.createElement("g", {
    filter: "url(#filter0_i_251_1214)"
  }, /* @__PURE__ */React21.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11.3473C13.2701 13.5942 10 18.4152 10 24C10 29.5848 13.2701 34.4058 18 36.6527V23.9689L18 23.908C17.9998 23.6076 17.9996 23.3426 18.0466 23.0791C18.0879 22.8473 18.1563 22.6211 18.2506 22.4053C18.3577 22.16 18.5048 21.9396 18.6716 21.6898L18.7054 21.6391L19.5763 20.3328C19.6903 20.1618 19.749 20.0729 19.7875 20.006L19.7909 20L19.7875 19.994C19.749 19.9271 19.6903 19.8382 19.5763 19.6672L18.7054 18.3609L18.6716 18.3102L18.6716 18.3102C18.5048 18.0604 18.3576 17.84 18.2506 17.5947C18.1563 17.3789 18.0879 17.1527 18.0466 16.9209C17.9996 16.6574 17.9998 16.3924 18 16.092V16.092L18 16.0311V11.3473ZM28.9999 37.0808C27.4471 37.6747 25.7615 38 24 38C22.2385 38 20.5529 37.6747 19.0001 37.0808C19 36.9913 19 36.8978 19 36.8V23.9689C19 23.6088 19 23.4287 19.031 23.2546C19.0586 23.1 19.1042 22.9493 19.167 22.8054C19.2378 22.6433 19.3377 22.4935 19.5374 22.1939L19.5374 22.1939L19.5374 22.1938L20.4083 20.8875C20.6222 20.5668 20.7291 20.4064 20.7706 20.233C20.8073 20.0798 20.8073 19.9202 20.7706 19.767C20.7291 19.5936 20.6222 19.4332 20.4083 19.1125L19.5374 17.8062C19.3377 17.5065 19.2378 17.3567 19.167 17.1946C19.1042 17.0507 19.0586 16.9 19.031 16.7454C19 16.5713 19 16.3912 19 16.0311V11.2C19 11.1022 19 11.0087 19.0001 10.9192C20.5529 10.3253 22.2385 10 24 10C25.7615 10 27.4471 10.3253 28.9999 10.9192C29 11.0087 29 11.1022 29 11.2V24.0311C29 24.3912 29 24.5713 28.969 24.7454C28.9414 24.9 28.8958 25.0507 28.833 25.1946C28.7622 25.3567 28.6623 25.5065 28.4626 25.8062L27.5917 27.1125C27.3778 27.4332 27.2709 27.5936 27.2294 27.767C27.1927 27.9202 27.1927 28.0798 27.2294 28.233C27.2709 28.4064 27.3778 28.5668 27.5917 28.8875L28.4626 30.1938C28.6623 30.4935 28.7622 30.6433 28.833 30.8054C28.8958 30.9493 28.9414 31.1 28.969 31.2546C29 31.4287 29 31.6088 29 31.9689V36.8C29 36.8978 29 36.9913 28.9999 37.0808ZM30 36.6527C34.7299 34.4058 38 29.5848 38 24C38 18.4152 34.7299 13.5942 30 11.3473V24.0311L30 24.092C30.0002 24.3924 30.0004 24.6574 29.9534 24.9209C29.9121 25.1527 29.8437 25.3789 29.7494 25.5947C29.6423 25.84 29.4952 26.0604 29.3284 26.3102L29.3284 26.3103L29.2946 26.3609L28.4237 27.6672C28.3097 27.8382 28.251 27.9271 28.2125 27.994L28.2091 28L28.2125 28.006C28.251 28.0729 28.3097 28.1618 28.4237 28.3328L29.2946 29.6391L29.3284 29.6898C29.4952 29.9396 29.6423 30.16 29.7494 30.4053C29.8437 30.6211 29.9121 30.8473 29.9534 31.0791C30.0004 31.3426 30.0002 31.6076 30 31.908L30 31.9689V36.6527Z",
    fill: "url(#paint4_linear_251_1214)"
  })), /* @__PURE__ */React21.createElement("path", {
    d: "M25.8 7.5H22.2L22.1786 7.5C21.6367 7.49999 21.1996 7.49999 20.8457 7.52891C20.4813 7.55868 20.1612 7.62159 19.865 7.77248C19.3946 8.01217 19.0122 8.39462 18.7725 8.86502C18.6216 9.16117 18.5587 9.48126 18.5289 9.84569C18.5 10.1996 18.5 10.6367 18.5 11.1786L18.5 11.2V16.0311C18.5 16.0452 18.5 16.059 18.5 16.0727C18.4999 16.393 18.4999 16.6148 18.5388 16.8332C18.5732 17.0263 18.6303 17.2148 18.7088 17.3946C18.7975 17.5979 18.9206 17.7825 19.0984 18.0489C19.1059 18.0603 19.1136 18.0718 19.1214 18.0835L19.9923 19.3898C20.2279 19.7433 20.2686 19.8176 20.2844 19.8835C20.3027 19.9601 20.3027 20.0399 20.2844 20.1165C20.2686 20.1824 20.2279 20.2567 19.9923 20.6102L19.1214 21.9165C19.1136 21.9282 19.1059 21.9397 19.0984 21.9511C18.9206 22.2175 18.7975 22.4021 18.7088 22.6054C18.6303 22.7852 18.5732 22.9737 18.5388 23.1668C18.4999 23.3852 18.4999 23.607 18.5 23.9273C18.5 23.941 18.5 23.9548 18.5 23.9689V36.8L18.5 36.8214C18.5 37.3633 18.5 37.8004 18.5289 38.1543C18.5587 38.5187 18.6216 38.8388 18.7725 39.135C19.0122 39.6054 19.3946 39.9878 19.865 40.2275C20.1612 40.3784 20.4813 40.4413 20.8457 40.4711C21.1996 40.5 21.6367 40.5 22.1786 40.5H22.2H25.8H25.8214C26.3633 40.5 26.8004 40.5 27.1543 40.4711C27.5187 40.4413 27.8388 40.3784 28.135 40.2275C28.6054 39.9878 28.9878 39.6054 29.2275 39.135C29.3784 38.8388 29.4413 38.5187 29.4711 38.1543C29.5 37.8004 29.5 37.3633 29.5 36.8214V36.8V31.9689L29.5 31.9273C29.5001 31.607 29.5001 31.3852 29.4612 31.1668C29.4268 30.9737 29.3697 30.7852 29.2912 30.6054C29.2025 30.4021 29.0794 30.2175 28.9016 29.9511L28.8786 29.9165L28.0077 28.6102C27.7721 28.2567 27.7314 28.1824 27.7156 28.1165C27.6973 28.0399 27.6973 27.9601 27.7156 27.8835C27.7314 27.8176 27.7721 27.7433 28.0077 27.3898L28.8786 26.0835L28.9016 26.0489C29.0794 25.7825 29.2025 25.5979 29.2912 25.3946C29.3697 25.2148 29.4268 25.0263 29.4612 24.8332C29.5001 24.6148 29.5001 24.393 29.5 24.0727C29.5 24.059 29.5 24.0452 29.5 24.0311V11.2V11.1786C29.5 10.6367 29.5 10.1996 29.4711 9.84569C29.4413 9.48126 29.3784 9.16117 29.2275 8.86502C28.9878 8.39462 28.6054 8.01217 28.135 7.77248C27.8388 7.62159 27.5187 7.55868 27.1543 7.52891C26.8004 7.49999 26.3633 7.49999 25.8214 7.5L25.8 7.5Z",
    stroke: "white",
    strokeOpacity: "0.2",
    style: {
      mixBlendMode: "overlay"
    }
  }), /* @__PURE__ */React21.createElement("g", {
    filter: "url(#filter1_i_251_1214)"
  }, /* @__PURE__ */React21.createElement("path", {
    d: "M19 11.2C19 10.0799 19 9.51984 19.218 9.09202C19.4097 8.71569 19.7157 8.40973 20.092 8.21799C20.5198 8 21.0799 8 22.2 8H25.8C26.9201 8 27.4802 8 27.908 8.21799C28.2843 8.40973 28.5903 8.71569 28.782 9.09202C29 9.51984 29 10.0799 29 11.2V24.0311C29 24.3912 29 24.5713 28.969 24.7454C28.9414 24.9 28.8958 25.0507 28.833 25.1946C28.7622 25.3567 28.6623 25.5065 28.4626 25.8062L27.5917 27.1125C27.3778 27.4332 27.2709 27.5936 27.2294 27.767C27.1927 27.9202 27.1927 28.0798 27.2294 28.233C27.2709 28.4064 27.3778 28.5668 27.5917 28.8875L28.4626 30.1938C28.6623 30.4935 28.7622 30.6433 28.833 30.8054C28.8958 30.9493 28.9414 31.1 28.969 31.2546C29 31.4287 29 31.6088 29 31.9689V36.8C29 37.9201 29 38.4802 28.782 38.908C28.5903 39.2843 28.2843 39.5903 27.908 39.782C27.4802 40 26.9201 40 25.8 40H22.2C21.0799 40 20.5198 40 20.092 39.782C19.7157 39.5903 19.4097 39.2843 19.218 38.908C19 38.4802 19 37.9201 19 36.8V23.9689C19 23.6088 19 23.4287 19.031 23.2546C19.0586 23.1 19.1042 22.9493 19.167 22.8054C19.2378 22.6433 19.3377 22.4935 19.5374 22.1938L20.4083 20.8875C20.6222 20.5668 20.7291 20.4064 20.7706 20.233C20.8073 20.0798 20.8073 19.9202 20.7706 19.767C20.7291 19.5936 20.6222 19.4332 20.4083 19.1125L19.5374 17.8062C19.3377 17.5065 19.2378 17.3567 19.167 17.1946C19.1042 17.0507 19.0586 16.9 19.031 16.7454C19 16.5713 19 16.3912 19 16.0311V11.2Z",
    fill: "black",
    fillOpacity: "0.6"
  })), /* @__PURE__ */React21.createElement("defs", null, /* @__PURE__ */React21.createElement("filter", {
    id: "filter0_i_251_1214",
    x: "10",
    y: "10",
    width: "28",
    height: "28",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /* @__PURE__ */React21.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /* @__PURE__ */React21.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /* @__PURE__ */React21.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /* @__PURE__ */React21.createElement("feOffset", null), /* @__PURE__ */React21.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /* @__PURE__ */React21.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: "-1",
    k3: "1"
  }), /* @__PURE__ */React21.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /* @__PURE__ */React21.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_251_1214"
  })), /* @__PURE__ */React21.createElement("filter", {
    id: "filter1_i_251_1214",
    x: "19",
    y: "8",
    width: "10",
    height: "32",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /* @__PURE__ */React21.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /* @__PURE__ */React21.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /* @__PURE__ */React21.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /* @__PURE__ */React21.createElement("feOffset", null), /* @__PURE__ */React21.createElement("feGaussianBlur", {
    stdDeviation: "2"
  }), /* @__PURE__ */React21.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: "-1",
    k3: "1"
  }), /* @__PURE__ */React21.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /* @__PURE__ */React21.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_251_1214"
  })), /* @__PURE__ */React21.createElement("linearGradient", {
    id: "paint0_linear_251_1214",
    x1: "24",
    y1: "0",
    x2: "24",
    y2: "48",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */React21.createElement("stop", {
    stopColor: "#174299"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "1",
    stopColor: "#001E59"
  })), /* @__PURE__ */React21.createElement("linearGradient", {
    id: "paint1_linear_251_1214",
    x1: "24",
    y1: "0",
    x2: "24",
    y2: "48",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */React21.createElement("stop", {
    stopColor: "#DDE1EB"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "1",
    stopColor: "#CAD0DB"
  })), /* @__PURE__ */React21.createElement("radialGradient", {
    id: "paint2_radial_251_1214",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-14.9375 56.375) rotate(-40.0766) scale(82.9048)"
  }, /* @__PURE__ */React21.createElement("stop", {
    offset: "0.276042",
    stopColor: "#20FF4D"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "0.463542",
    stopColor: "#1499FF"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "0.755208",
    stopColor: "#FF6FC6"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "1",
    stopColor: "#BC67FF"
  })), /* @__PURE__ */React21.createElement("radialGradient", {
    id: "paint3_radial_251_1214",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-3.5625 -3.5625) rotate(45) scale(68.6777)"
  }, /* @__PURE__ */React21.createElement("stop", {
    stopColor: "#FF0000"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "1",
    stopColor: "#00A3FF"
  })), /* @__PURE__ */React21.createElement("linearGradient", {
    id: "paint4_linear_251_1214",
    x1: "24",
    y1: "10",
    x2: "24",
    y2: "38",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */React21.createElement("stop", {
    stopOpacity: "0.12"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "1",
    stopOpacity: "0"
  }), /* @__PURE__ */React21.createElement("stop", {
    offset: "1",
    stopOpacity: "0.08"
  }))));
}; // src/components/ConnectModal/ConnectModalIntro.tsx


function ConnectModalIntro(_ref23) {
  var getWallet = _ref23.getWallet;
  var learnMoreUrl = useContext3(LearnMoreUrlContext);
  return /* @__PURE__ */React22.createElement(React22.Fragment, null, /* @__PURE__ */React22.createElement(Box, {
    alignItems: "center",
    color: "accentColor",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    style: {
      gap: 62
    }
  }, /* @__PURE__ */React22.createElement(Text, {
    color: "modalText",
    size: "18",
    weight: "heavy"
  }, "What is a Wallet?"), /* @__PURE__ */React22.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "32",
    height: "full",
    justifyContent: "center",
    paddingX: "36"
  }, /* @__PURE__ */React22.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "16"
  }, /* @__PURE__ */React22.createElement(Box, {
    borderRadius: "6",
    height: "48",
    minWidth: "48",
    width: "48"
  }, /* @__PURE__ */React22.createElement(AssetsIcon, null)), /* @__PURE__ */React22.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, /* @__PURE__ */React22.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, "A Home for your Digital Assets"), /* @__PURE__ */React22.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, "Wallets are used to send, receive, store, and display digital assets like Ethereum and NFTs."))), /* @__PURE__ */React22.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    gap: "16"
  }, /* @__PURE__ */React22.createElement(Box, {
    borderRadius: "6",
    height: "48",
    minWidth: "48",
    width: "48"
  }, /* @__PURE__ */React22.createElement(LoginIcon, null)), /* @__PURE__ */React22.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "4"
  }, /* @__PURE__ */React22.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, "A New Way to Log In"), /* @__PURE__ */React22.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, "Instead of creating new accounts and passwords on every website, just connect your wallet instead.")))), /* @__PURE__ */React22.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginTop: "8"
  }, /* @__PURE__ */React22.createElement(ActionButton, {
    label: "Get a Wallet",
    onClick: getWallet
  }), /* @__PURE__ */React22.createElement(Box, {
    as: "a",
    href: learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: {
      willChange: "transform"
    },
    target: "_blank",
    transform: {
      active: "shrink",
      hover: "grow"
    },
    transition: "default"
  }, /* @__PURE__ */React22.createElement(Text, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, "Learn More")))));
} // src/components/Icons/Back.tsx


import React23 from "react";

var BackIcon = function BackIcon() {
  return /* @__PURE__ */React23.createElement("svg", {
    fill: "none",
    height: "17",
    viewBox: "0 0 11 17",
    width: "11",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React23.createElement("path", {
    d: "M0.99707 8.6543C0.99707 9.08496 1.15527 9.44531 1.51562 9.79688L8.16016 16.3096C8.43262 16.5732 8.74902 16.7051 9.13574 16.7051C9.90918 16.7051 10.5508 16.0811 10.5508 15.3076C10.5508 14.9121 10.3838 14.5605 10.0938 14.2705L4.30176 8.64551L10.0938 3.0293C10.3838 2.74805 10.5508 2.3877 10.5508 2.00098C10.5508 1.23633 9.90918 0.603516 9.13574 0.603516C8.74902 0.603516 8.43262 0.735352 8.16016 0.999023L1.51562 7.51172C1.15527 7.85449 1.00586 8.21484 0.99707 8.6543Z",
    fill: "currentColor"
  }));
}; // src/components/ModalSelection/ModalSelection.tsx


import React24 from "react"; // src/components/ModalSelection/ModalSelection.css.ts

var HoverClassName = "ModalSelection__g5kl0l1 sprinkles_paddingLeft_5__ju367v6l sprinkles_paddingRight_5__ju367v74 sprinkles_paddingTop_5__ju367v7n sprinkles_paddingBottom_5__ju367v62 sprinkles_background_menuItemBackground_hover__ju367va1 sprinkles_borderRadius_menuButton__ju367v11 sprinkles_borderStyle_solid__ju367v15 sprinkles_borderWidth_1__ju367v17 sprinkles_transform_shrink_active__ju367v8 sprinkles_transition_default_base__ju367vc";
var SelectedClassName = "sprinkles_paddingLeft_5__ju367v6l sprinkles_paddingRight_5__ju367v74 sprinkles_paddingTop_5__ju367v7n sprinkles_paddingBottom_5__ju367v62 sprinkles_background_accentColor_base__ju367v8o sprinkles_borderColor_selectedOptionBorder_base__ju367vd6 sprinkles_borderRadius_menuButton__ju367v11 sprinkles_borderStyle_solid__ju367v15 sprinkles_borderWidth_1__ju367v17 sprinkles_boxShadow_selectedWallet_base__ju367vdo sprinkles_transition_default_base__ju367vc"; // src/components/ModalSelection/ModalSelection.tsx

var ModalSelection = React24.forwardRef(function (_ref24, ref) {
  var _ref24$as = _ref24.as,
      as = _ref24$as === void 0 ? "button" : _ref24$as,
      children = _ref24.children,
      _ref24$currentlySelec = _ref24.currentlySelected,
      currentlySelected = _ref24$currentlySelec === void 0 ? false : _ref24$currentlySelec,
      onClick = _ref24.onClick,
      urlProps = _objectWithoutProperties(_ref24, _excluded4);

  return /* @__PURE__ */React24.createElement(Box, _objectSpread({
    as: as,
    className: currentlySelected ? SelectedClassName : HoverClassName,
    disabled: currentlySelected,
    onClick: onClick,
    ref: ref,
    style: {
      willChange: "transform"
    }
  }, urlProps), children);
});
ModalSelection.displayName = "ModalSelection"; // src/components/ConnectOptions/ConnectDetails.tsx

import React29 from "react"; // src/components/Icons/Create.tsx

import React25 from "react";

var CreateIcon = function CreateIcon() {
  return /* @__PURE__ */React25.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /* @__PURE__ */React25.createElement("rect", {
    width: "48",
    height: "48",
    rx: "10",
    fill: "url(#paint0_radial_251_1213)"
  }), /* @__PURE__ */React25.createElement("rect", {
    width: "48",
    height: "48",
    rx: "10",
    fill: "url(#paint1_radial_251_1213)",
    fillOpacity: "0.7",
    style: {
      mixBlendMode: "screen"
    }
  }), /* @__PURE__ */React25.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "47",
    height: "47",
    rx: "9.5",
    stroke: "black",
    strokeOpacity: "0.04"
  }), /* @__PURE__ */React25.createElement("g", {
    filter: "url(#filter0_d_251_1213)"
  }, /* @__PURE__ */React25.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C23.1716 12 22.5 12.6716 22.5 13.5V21.7C22.5 21.98 22.5 22.12 22.4455 22.227C22.3976 22.3211 22.3211 22.3976 22.227 22.4455C22.12 22.5 21.98 22.5 21.7 22.5H13.5C12.6716 22.5 12 23.1716 12 24C12 24.8284 12.6716 25.5 13.5 25.5H21.7C21.98 25.5 22.12 25.5 22.227 25.5545C22.3211 25.6024 22.3976 25.6789 22.4455 25.773C22.5 25.88 22.5 26.02 22.5 26.3V34.5C22.5 35.3284 23.1716 36 24 36C24.8284 36 25.5 35.3284 25.5 34.5V26.3C25.5 26.02 25.5 25.88 25.5545 25.773C25.6024 25.6789 25.6789 25.6024 25.773 25.5545C25.88 25.5 26.02 25.5 26.3 25.5H34.5C35.3284 25.5 36 24.8284 36 24C36 23.1716 35.3284 22.5 34.5 22.5H26.3C26.02 22.5 25.88 22.5 25.773 22.4455C25.6789 22.3976 25.6024 22.3211 25.5545 22.227C25.5 22.12 25.5 21.98 25.5 21.7V13.5C25.5 12.6716 24.8284 12 24 12Z",
    fill: "white"
  })), /* @__PURE__ */React25.createElement("defs", null, /* @__PURE__ */React25.createElement("filter", {
    id: "filter0_d_251_1213",
    x: "10",
    y: "11",
    width: "28",
    height: "28",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /* @__PURE__ */React25.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /* @__PURE__ */React25.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /* @__PURE__ */React25.createElement("feOffset", {
    dy: "1"
  }), /* @__PURE__ */React25.createElement("feGaussianBlur", {
    stdDeviation: "1"
  }), /* @__PURE__ */React25.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /* @__PURE__ */React25.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /* @__PURE__ */React25.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_251_1213"
  }), /* @__PURE__ */React25.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_251_1213",
    result: "shape"
  })), /* @__PURE__ */React25.createElement("radialGradient", {
    id: "paint0_radial_251_1213",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-20.5 61) rotate(-40.0766) scale(94.7484)"
  }, /* @__PURE__ */React25.createElement("stop", {
    offset: "0.276042",
    stopColor: "#20FF4D"
  }), /* @__PURE__ */React25.createElement("stop", {
    offset: "0.463542",
    stopColor: "#1499FF"
  }), /* @__PURE__ */React25.createElement("stop", {
    offset: "0.755208",
    stopColor: "#FF6FC5"
  }), /* @__PURE__ */React25.createElement("stop", {
    offset: "1",
    stopColor: "#BC67FF"
  })), /* @__PURE__ */React25.createElement("radialGradient", {
    id: "paint1_radial_251_1213",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-7.5 -7.5) rotate(45) scale(78.4889)"
  }, /* @__PURE__ */React25.createElement("stop", {
    stopColor: "#FF0000"
  }), /* @__PURE__ */React25.createElement("stop", {
    offset: "1",
    stopColor: "#00A3FF"
  }))));
}; // src/components/Icons/Scan.tsx


import React26 from "react";

var ScanIcon = function ScanIcon() {
  return /* @__PURE__ */React26.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /* @__PURE__ */React26.createElement("rect", {
    width: "48",
    height: "48",
    rx: "10",
    fill: "url(#paint0_linear_251_1215)"
  }), /* @__PURE__ */React26.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "47",
    height: "47",
    rx: "9.5",
    stroke: "black",
    strokeOpacity: "0.08"
  }), /* @__PURE__ */React26.createElement("g", {
    filter: "url(#filter0_d_251_1215)"
  }, /* @__PURE__ */React26.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 9.5C28 8.67157 28.6716 8 29.5 8H33.4545C33.961 8 34.2143 8 34.428 8.01529C37.4043 8.22815 39.7718 10.5957 39.9847 13.572C40 13.7857 40 14.039 40 14.5455V18.5C40 19.3284 39.3284 20 38.5 20C37.6716 20 37 19.3284 37 18.5V14.375C37 14.0267 37 13.8526 36.9856 13.7059C36.8453 12.2816 35.7184 11.1547 34.2941 11.0144C34.1474 11 33.9733 11 33.625 11H29.5C28.6716 11 28 10.3284 28 9.5ZM28 38.5C28 39.3284 28.6716 40 29.5 40H33.4545C33.961 40 34.2143 40 34.428 39.9847C37.4043 39.7718 39.7718 37.4043 39.9847 34.428C40 34.2143 40 33.961 40 33.4545V29.5C40 28.6716 39.3284 28 38.5 28C37.6716 28 37 28.6716 37 29.5V33.625C37 33.9733 37 34.1474 36.9856 34.2941C36.8453 35.7184 35.7184 36.8453 34.2941 36.9856C34.1474 37 33.9733 37 33.625 37H29.5C28.6716 37 28 37.6716 28 38.5ZM18.5 40C19.3284 40 20 39.3284 20 38.5C20 37.6716 19.3284 37 18.5 37H14.375C14.0267 37 13.8526 37 13.7059 36.9856C12.2816 36.8453 11.1547 35.7184 11.0144 34.2941C11 34.1474 11 33.9733 11 33.625V29.5C11 28.6716 10.3284 28 9.5 28C8.67157 28 8 28.6716 8 29.5V33.4545C8 33.961 8 34.2143 8.01529 34.428C8.22815 37.4043 10.5957 39.7718 13.572 39.9847C13.7857 40 14.039 40 14.5455 40H18.5ZM20 9.5C20 8.67157 19.3284 8 18.5 8H14.5455C14.039 8 13.7857 8 13.572 8.01529C10.5957 8.22815 8.22815 10.5957 8.01529 13.572C8 13.7857 8 14.039 8 14.5455V18.5C8 19.3284 8.67157 20 9.5 20C10.3284 20 11 19.3284 11 18.5V14.375C11 14.0267 11 13.8526 11.0144 13.7059C11.1547 12.2816 12.2816 11.1547 13.7059 11.0144C13.8526 11 14.0267 11 14.375 11H18.5C19.3284 11 20 10.3284 20 9.5Z",
    fill: "white"
  })), /* @__PURE__ */React26.createElement("defs", null, /* @__PURE__ */React26.createElement("filter", {
    id: "filter0_d_251_1215",
    x: "6",
    y: "7",
    width: "36",
    height: "36",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /* @__PURE__ */React26.createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
  }), /* @__PURE__ */React26.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /* @__PURE__ */React26.createElement("feOffset", {
    dy: "1"
  }), /* @__PURE__ */React26.createElement("feGaussianBlur", {
    stdDeviation: "1"
  }), /* @__PURE__ */React26.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /* @__PURE__ */React26.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /* @__PURE__ */React26.createElement("feBlend", {
    mode: "overlay",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_251_1215"
  }), /* @__PURE__ */React26.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_251_1215",
    result: "shape"
  })), /* @__PURE__ */React26.createElement("linearGradient", {
    id: "paint0_linear_251_1215",
    x1: "24",
    y1: "0",
    x2: "24",
    y2: "48",
    gradientUnits: "userSpaceOnUse"
  }, /* @__PURE__ */React26.createElement("stop", {
    stopColor: "#59627A"
  }), /* @__PURE__ */React26.createElement("stop", {
    offset: "1",
    stopColor: "#4A5266"
  }))));
}; // src/components/Icons/Spinner.tsx


import React27 from "react"; // src/components/Icons/Icons.css.ts

var SpinnerIconClassName = "Icons__1luule42";
var SpinnerIconPathClassName = "Icons__1luule43"; // src/components/Icons/Spinner.tsx

var SpinnerIcon = function SpinnerIcon() {
  return /* @__PURE__ */React27.createElement("svg", {
    className: SpinnerIconClassName,
    fill: "none",
    height: "21",
    viewBox: "0 0 21 21",
    width: "21",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */React27.createElement("clipPath", {
    id: "spinnerPath"
  }, /* @__PURE__ */React27.createElement("path", {
    d: "M10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C11.3284 18 12 18.6716 12 19.5C12 20.3284 11.3284 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0C16.299 0 21 4.70101 21 10.5C21 11.3284 20.3284 12 19.5 12C18.6716 12 18 11.3284 18 10.5C18 6.35786 14.6421 3 10.5 3Z"
  })), /* @__PURE__ */React27.createElement("foreignObject", {
    clipPath: "url(#spinnerPath)",
    height: "21",
    width: "21",
    x: "0",
    y: "0"
  }, /* @__PURE__ */React27.createElement("div", {
    className: SpinnerIconPathClassName
  })));
}; // src/components/QRCode/QRCode.tsx


import QRCodeUtil from "qrcode";
import React28, { useMemo as useMemo4 } from "react"; // src/components/ConnectOptions/DesktopOptions.css.ts

var QRCodeBackgroundClassName = "DesktopOptions__1vwt0cg0";
var ScrollClassName = "DesktopOptions__1vwt0cg2 sprinkles_paddingLeft_18__ju367v6s sprinkles_paddingRight_18__ju367v7b"; // src/components/QRCode/QRCode.tsx

var generateMatrix = function generateMatrix(value, errorCorrectionLevel) {
  var arr = Array.prototype.slice.call(QRCodeUtil.create(value, {
    errorCorrectionLevel: errorCorrectionLevel
  }).modules.data, 0);
  var sqrt = Math.sqrt(arr.length);
  return arr.reduce(function (rows, key, index) {
    return (index % sqrt === 0 ? rows.push([key]) : rows[rows.length - 1].push(key)) && rows;
  }, []);
};

function QRCode(_ref25) {
  var _ref25$ecl = _ref25.ecl,
      ecl = _ref25$ecl === void 0 ? "M" : _ref25$ecl,
      _ref25$logoMargin = _ref25.logoMargin,
      logoMargin = _ref25$logoMargin === void 0 ? 10 : _ref25$logoMargin,
      _ref25$logoSize = _ref25.logoSize,
      logoSize = _ref25$logoSize === void 0 ? 50 : _ref25$logoSize,
      logoUri = _ref25.logoUri,
      _ref25$size = _ref25.size,
      sizeProp = _ref25$size === void 0 ? 200 : _ref25$size,
      uri = _ref25.uri;
  var padding = "20";
  var size = sizeProp - parseInt(padding, 10) * 2;
  var dots = useMemo4(function () {
    var dots2 = [];
    var matrix = generateMatrix(uri, ecl);
    var cellSize = size / matrix.length;
    var qrList = [{
      x: 0,
      y: 0
    }, {
      x: 1,
      y: 0
    }, {
      x: 0,
      y: 1
    }];
    qrList.forEach(function (_ref26) {
      var x = _ref26.x,
          y = _ref26.y;
      var x1 = (matrix.length - 7) * cellSize * x;
      var y1 = (matrix.length - 7) * cellSize * y;

      for (var i = 0; i < 3; i++) {
        dots2.push( /* @__PURE__ */React28.createElement("rect", {
          fill: i % 2 !== 0 ? "white" : "black",
          height: cellSize * (7 - i * 2),
          key: "".concat(i, "-").concat(x, "-").concat(y),
          rx: (i - 2) * -5 + (i === 0 ? 2 : 0),
          ry: (i - 2) * -5 + (i === 0 ? 2 : 0),
          width: cellSize * (7 - i * 2),
          x: x1 + cellSize * i,
          y: y1 + cellSize * i
        }));
      }
    });
    var clearArenaSize = Math.floor((logoSize + 25) / cellSize);
    var matrixMiddleStart = matrix.length / 2 - clearArenaSize / 2;
    var matrixMiddleEnd = matrix.length / 2 + clearArenaSize / 2 - 1;
    matrix.forEach(function (row, i) {
      row.forEach(function (_, j) {
        if (matrix[i][j]) {
          if (!(i < 7 && j < 7 || i > matrix.length - 8 && j < 7 || i < 7 && j > matrix.length - 8)) {
            if (!(i > matrixMiddleStart && i < matrixMiddleEnd && j > matrixMiddleStart && j < matrixMiddleEnd)) {
              dots2.push( /* @__PURE__ */React28.createElement("circle", {
                cx: i * cellSize + cellSize / 2,
                cy: j * cellSize + cellSize / 2,
                fill: "black",
                key: "circle-".concat(i, "-").concat(j),
                r: cellSize / 3
              }));
            }
          }
        }
      });
    });
    return dots2;
  }, [ecl, logoSize, size, uri]);
  var logoPosition = size / 2 - logoSize / 2;
  var logoWrapperSize = logoSize + logoMargin * 2;
  return /* @__PURE__ */React28.createElement(Box, {
    borderColor: "generalBorder",
    borderRadius: "menuButton",
    borderStyle: "solid",
    borderWidth: "1",
    className: QRCodeBackgroundClassName,
    padding: padding,
    width: "max"
  }, /* @__PURE__ */React28.createElement(Box, {
    style: {
      height: size,
      userSelect: "none",
      width: size
    },
    userSelect: "none"
  }, /* @__PURE__ */React28.createElement("div", {
    style: {
      height: 0,
      position: "relative",
      textAlign: "center",
      top: logoPosition,
      width: size
    }
  }, /* @__PURE__ */React28.createElement("img", {
    alt: "",
    height: logoSize,
    src: logoUri,
    style: {
      all: "revert",
      borderRadius: "25%",
      height: logoSize,
      width: logoSize
    },
    width: logoSize
  })), /* @__PURE__ */React28.createElement("svg", {
    height: size,
    style: {
      all: "revert"
    },
    width: size
  }, /* @__PURE__ */React28.createElement("defs", null, /* @__PURE__ */React28.createElement("clipPath", {
    id: "clip-wrapper"
  }, /* @__PURE__ */React28.createElement("rect", {
    height: logoWrapperSize,
    width: logoWrapperSize
  })), /* @__PURE__ */React28.createElement("clipPath", {
    id: "clip-logo"
  }, /* @__PURE__ */React28.createElement("rect", {
    height: logoSize,
    width: logoSize
  }))), /* @__PURE__ */React28.createElement("rect", {
    fill: "transparent",
    height: size,
    width: size
  }), dots)));
} // src/components/ConnectOptions/ConnectDetails.tsx


function GetDetail(_ref27) {
  var getMobileWallet = _ref27.getMobileWallet;
  var wallets = useWalletConnectors();
  var shownWallets = wallets.splice(0, 5);

  var linkProps = function linkProps(link) {
    return {
      as: "a",
      href: link,
      rel: "noreferrer",
      target: "_blank"
    };
  };

  return /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    height: "full",
    marginTop: "18",
    width: "full"
  }, /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    width: "full"
  }, shownWallets == null ? void 0 : shownWallets.filter(function (wallet) {
    var _a, _b;

    return ((_a = wallet.downloadUrls) == null ? void 0 : _a.browserExtension) || wallet.qrCode && ((_b = wallet.downloadUrls) == null ? void 0 : _b.qrCode);
  }).map(function (wallet) {
    var downloadUrls = wallet.downloadUrls,
        iconUrl = wallet.iconUrl,
        id = wallet.id,
        name = wallet.name,
        qrCode = wallet.qrCode;
    var hasMobileCompanionApp = (downloadUrls == null ? void 0 : downloadUrls.qrCode) && qrCode;
    return /* @__PURE__ */React29.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "16",
      justifyContent: "space-between",
      key: wallet.id,
      width: "full"
    }, /* @__PURE__ */React29.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16"
    }, /* @__PURE__ */React29.createElement(Box, {
      borderRadius: "10",
      height: "48",
      src: iconUrl,
      style: {
        background: "url(".concat(iconUrl, ")"),
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        touchCallout: "none",
        userSelect: "none"
      },
      width: "48"
    }, /* @__PURE__ */React29.createElement(Box, {
      borderColor: "actionButtonBorder",
      borderRadius: "10",
      borderStyle: "solid",
      borderWidth: "1",
      height: "full",
      width: "full"
    })), /* @__PURE__ */React29.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "2"
    }, /* @__PURE__ */React29.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, name), /* @__PURE__ */React29.createElement(Text, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, hasMobileCompanionApp ? "Mobile Wallet" : (downloadUrls == null ? void 0 : downloadUrls.browserExtension) ? "Browser Extension" : null))), /* @__PURE__ */React29.createElement(Box, _objectSpread({
      display: "flex",
      flexDirection: "column",
      gap: "4",
      onClick: function onClick() {
        return hasMobileCompanionApp && getMobileWallet(id);
      }
    }, !hasMobileCompanionApp && (downloadUrls == null ? void 0 : downloadUrls.browserExtension) ? linkProps(downloadUrls.browserExtension) : {}), /* @__PURE__ */React29.createElement(ActionButton, {
      label: "GET",
      onClick: function onClick() {},
      type: "secondary"
    })));
  })), /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "column",
    gap: "8",
    justifyContent: "space-between",
    marginBottom: "4",
    paddingY: "8",
    style: {
      maxWidth: 275,
      textAlign: "center"
    }
  }, /* @__PURE__ */React29.createElement(Text, {
    color: "modalText",
    size: "14",
    weight: "bold"
  }, "Not what you\u2019re looking for?"), /* @__PURE__ */React29.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, "Select a wallet on the left to get started with a different wallet provider.")));
}

var LOGO_SIZE = "60";

function ConnectDetail(_ref28) {
  var connectionError = _ref28.connectionError,
      reconnect = _ref28.reconnect,
      setWalletStep = _ref28.setWalletStep,
      wallet = _ref28.wallet;

  var _a;

  var downloadUrls = wallet.downloadUrls,
      iconUrl = wallet.iconUrl,
      name = wallet.name,
      qrCode = wallet.qrCode,
      ready = wallet.ready,
      showWalletConnectModal = wallet.showWalletConnectModal;
  var readyMsg;

  if (ready) {
    readyMsg = "Waiting for connection";
  } else if (downloadUrls == null ? void 0 : downloadUrls.browserExtension) {
    readyMsg = "The ".concat(name, " extension is not installed in your browser");
  } else {
    readyMsg = "".concat(name, " is not available on this device");
  }

  var secondaryAction = showWalletConnectModal ? {
    description: "Need the official WalletConnect modal?",
    label: "OPEN",
    onClick: showWalletConnectModal
  } : qrCode ? {
    description: "Don\u2019t have the ".concat(name, " App?"),
    label: "GET",
    onClick: function onClick() {
      return setWalletStep("DOWNLOAD"
      /* Download */
      );
    }
  } : {
    description: "Confirm the connection in ".concat(name),
    label: "RETRY",
    onClick: function onClick() {
      return reconnect(wallet);
    }
  };
  return /* @__PURE__ */React29.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, qrCode ? /* @__PURE__ */React29.createElement(Box, {
    height: "full"
  }, /* @__PURE__ */React29.createElement(QRCode, {
    logoSize: 72,
    logoUri: (_a = qrCode.iconUrl) != null ? _a : iconUrl,
    size: 382,
    uri: qrCode.getUri()
  })) : /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    style: {
      flexGrow: 1
    }
  }, /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "20"
  }, /* @__PURE__ */React29.createElement(Box, {
    borderRadius: "10",
    height: LOGO_SIZE,
    overflow: "hidden"
  }, /* @__PURE__ */React29.createElement("img", {
    alt: name,
    height: LOGO_SIZE,
    src: iconUrl,
    width: LOGO_SIZE
  })), /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "10",
    paddingX: "32",
    style: {
      textAlign: "center"
    }
  }, /* @__PURE__ */React29.createElement(Text, {
    color: "modalText",
    size: "20",
    weight: "bold"
  }, ready ? "Opening ".concat(name) : (downloadUrls == null ? void 0 : downloadUrls.browserExtension) ? "".concat(name, " is not installed") : "".concat(name, " is not available")), /* @__PURE__ */React29.createElement(Box, {
    color: "modalTextSecondary",
    display: "flex",
    flexDirection: "row",
    gap: "6",
    height: "24",
    paddingX: "28"
  }, connectionError ? /* @__PURE__ */React29.createElement(Text, {
    color: "error",
    size: "16",
    weight: "bold"
  }, "Error connecting, please retry!") : /* @__PURE__ */React29.createElement(React29.Fragment, null, ready ? /* @__PURE__ */React29.createElement(SpinnerIcon, null) : null, /* @__PURE__ */React29.createElement(Text, {
    color: "modalTextSecondary",
    size: "16",
    weight: "bold"
  }, readyMsg))), !ready && (downloadUrls == null ? void 0 : downloadUrls.browserExtension) ? /* @__PURE__ */React29.createElement(Box, {
    paddingTop: "8"
  }, /* @__PURE__ */React29.createElement(ActionButton, {
    href: downloadUrls.browserExtension,
    label: "Install",
    type: "secondary"
  })) : null))), /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "row",
    gap: "8",
    height: "28",
    justifyContent: "space-between",
    marginTop: "6"
  }, !ready ? null : /* @__PURE__ */React29.createElement(React29.Fragment, null, /* @__PURE__ */React29.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "medium"
  }, secondaryAction.description), /* @__PURE__ */React29.createElement(ActionButton, {
    label: secondaryAction.label,
    onClick: secondaryAction.onClick,
    type: "secondary"
  }))));
}

function DownloadDetail(_ref29) {
  var setWalletStep = _ref29.setWalletStep,
      wallet = _ref29.wallet;
  var downloadUrls = wallet.downloadUrls,
      qrCode = wallet.qrCode;
  return /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "24",
    height: "full",
    width: "full"
  }, /* @__PURE__ */React29.createElement(Box, {
    style: {
      maxWidth: 220,
      textAlign: "center"
    }
  }, /* @__PURE__ */React29.createElement(Text, {
    color: "modalTextSecondary",
    size: "14",
    weight: "semibold"
  }, "Scan with your phone to download on iOS or Android")), /* @__PURE__ */React29.createElement(Box, {
    height: "full"
  }, (downloadUrls == null ? void 0 : downloadUrls.qrCode) ? /* @__PURE__ */React29.createElement(QRCode, {
    logoSize: 0,
    size: 268,
    uri: downloadUrls.qrCode
  }) : null), /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    borderRadius: "10",
    display: "flex",
    flexDirection: "row",
    gap: "8",
    height: "34",
    justifyContent: "space-between",
    marginBottom: "12",
    paddingY: "8"
  }, /* @__PURE__ */React29.createElement(ActionButton, {
    label: "Continue",
    onClick: function onClick() {
      return setWalletStep((qrCode == null ? void 0 : qrCode.instructions) ? "INSTRUCTIONS"
      /* Instructions */
      : "CONNECT"
      /* Connect */
      );
    }
  })));
}

var stepIcons = {
  create: function create() {
    return /* @__PURE__ */React29.createElement(CreateIcon, null);
  },
  install: function install(wallet) {
    return /* @__PURE__ */React29.createElement(Box, {
      alt: wallet.name,
      as: "img",
      height: "48",
      src: wallet.iconUrl,
      width: "48"
    });
  },
  scan: function scan() {
    return /* @__PURE__ */React29.createElement(ScanIcon, null);
  }
};

function InstructionDetail(_ref30) {
  var setWalletStep = _ref30.setWalletStep,
      wallet = _ref30.wallet;

  var _a, _b, _c, _d;

  return /* @__PURE__ */React29.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    height: "full",
    width: "full"
  }, /* @__PURE__ */React29.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "28",
    height: "full",
    justifyContent: "center",
    padding: "32"
  }, (_b = (_a = wallet == null ? void 0 : wallet.qrCode) == null ? void 0 : _a.instructions) == null ? void 0 : _b.steps.map(function (d, idx) {
    var _a2;

    return /* @__PURE__ */React29.createElement(Box, {
      alignItems: "center",
      display: "flex",
      flexDirection: "row",
      gap: "16",
      key: idx
    }, /* @__PURE__ */React29.createElement(Box, {
      borderRadius: "10",
      height: "48",
      minWidth: "48",
      overflow: "hidden",
      width: "48"
    }, (_a2 = stepIcons[d.step]) == null ? void 0 : _a2.call(stepIcons, wallet)), /* @__PURE__ */React29.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, /* @__PURE__ */React29.createElement(Text, {
      color: "modalText",
      size: "14",
      weight: "bold"
    }, d.title), /* @__PURE__ */React29.createElement(Text, {
      color: "modalTextSecondary",
      size: "14",
      weight: "medium"
    }, d.description)));
  })), /* @__PURE__ */React29.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "12",
    justifyContent: "center",
    marginBottom: "16"
  }, /* @__PURE__ */React29.createElement(ActionButton, {
    label: "Connect",
    onClick: function onClick() {
      return setWalletStep("CONNECT"
      /* Connect */
      );
    }
  }), /* @__PURE__ */React29.createElement(Box, {
    as: "a",
    href: (_d = (_c = wallet == null ? void 0 : wallet.qrCode) == null ? void 0 : _c.instructions) == null ? void 0 : _d.learnMoreUrl,
    paddingX: "12",
    paddingY: "4",
    rel: "noreferrer",
    style: {
      willChange: "transform"
    },
    target: "_blank",
    transform: {
      active: "shrink",
      hover: "grow"
    },
    transition: "default"
  }, /* @__PURE__ */React29.createElement(Text, {
    color: "accentColor",
    size: "14",
    weight: "bold"
  }, "Learn More"))));
} // src/components/ConnectOptions/DesktopOptions.tsx


function DesktopOptions(_ref31) {
  var onClose = _ref31.onClose;
  var titleId = "rk_connect_title";

  var _useState7 = useState4(),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedOptionId = _useState8[0],
      setSelectedOptionId = _useState8[1];

  var _useState9 = useState4(),
      _useState10 = _slicedToArray(_useState9, 2),
      selectedWallet = _useState10[0],
      setSelectedWallet = _useState10[1];

  var hasQrCode = !!(selectedWallet == null ? void 0 : selectedWallet.qrCode);

  var _useState11 = useState4(false),
      _useState12 = _slicedToArray(_useState11, 2),
      connectionError = _useState12[0],
      setConnectionError = _useState12[1];

  var wallets = useWalletConnectors().filter(function (wallet) {
    var _a;

    return wallet.ready || ((_a = wallet.downloadUrls) == null ? void 0 : _a.browserExtension);
  });
  var groupedWallets = groupBy(wallets, function (wallet) {
    return wallet.groupName;
  });

  var connectToWallet = function connectToWallet(wallet) {
    var _a;

    setConnectionError(false);

    if (wallet.ready) {
      (_a = wallet == null ? void 0 : wallet.connect) == null ? void 0 : _a.call(wallet).then(function (x) {
        if (x.error) {
          setConnectionError(true);
        }
      });
    }
  };

  var onSelectWallet = function onSelectWallet(wallet) {
    connectToWallet(wallet);
    setTimeout(function () {
      setSelectedOptionId(wallet.id);
      var sWallet = wallets.find(function (w) {
        return wallet.id === w.id;
      });
      setSelectedWallet(sWallet);
      setWalletStep("CONNECT"
      /* Connect */
      );
    }, 0);
  };

  var getMobileWallet = function getMobileWallet(id) {
    setSelectedOptionId(id);
    var sWallet = wallets.find(function (w) {
      return id === w.id;
    });
    setSelectedWallet(sWallet);
    setWalletStep("DOWNLOAD"
    /* Download */
    );
  };

  var _useState13 = useState4("NONE"
  /* None */
  ),
      _useState14 = _slicedToArray(_useState13, 2),
      walletStep = _useState14[0],
      setWalletStep = _useState14[1];

  var walletContent = null;
  var headerLabel = null;
  var headerBackButtonLink = null;
  useEffect6(function () {
    setConnectionError(false);
  }, [walletStep, selectedWallet]);

  switch (walletStep) {
    case "NONE"
    /* None */
    :
      walletContent = /* @__PURE__ */React30.createElement(ConnectModalIntro, {
        getWallet: function getWallet() {
          return setWalletStep("GET"
          /* Get */
          );
        }
      });
      break;

    case "GET"
    /* Get */
    :
      walletContent = /* @__PURE__ */React30.createElement(GetDetail, {
        getMobileWallet: getMobileWallet
      });
      headerLabel = "Get a Wallet";
      headerBackButtonLink = "NONE"
      /* None */
      ;
      break;

    case "CONNECT"
    /* Connect */
    :
      walletContent = selectedWallet && /* @__PURE__ */React30.createElement(ConnectDetail, {
        connectionError: connectionError,
        reconnect: connectToWallet,
        setWalletStep: setWalletStep,
        wallet: selectedWallet
      });
      headerLabel = hasQrCode && "Scan with ".concat(selectedWallet.name);
      break;

    case "DOWNLOAD"
    /* Download */
    :
      walletContent = selectedWallet && /* @__PURE__ */React30.createElement(DownloadDetail, {
        setWalletStep: setWalletStep,
        wallet: selectedWallet
      });
      headerLabel = hasQrCode && "Install ".concat(selectedWallet.name);
      headerBackButtonLink = "CONNECT"
      /* Connect */
      ;
      break;

    case "INSTRUCTIONS"
    /* Instructions */
    :
      walletContent = selectedWallet && /* @__PURE__ */React30.createElement(InstructionDetail, {
        setWalletStep: setWalletStep,
        wallet: selectedWallet
      });
      headerLabel = hasQrCode && "Get started with ".concat(selectedWallet.name);
      headerBackButtonLink = "DOWNLOAD"
      /* Download */
      ;
      break;

    default:
      break;
  }

  return /* @__PURE__ */React30.createElement(Box, {
    display: "flex",
    flexDirection: "row"
  }, /* @__PURE__ */React30.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    marginTop: "18",
    style: {
      minWidth: isMobile() ? "full" : "287px"
    }
  }, /* @__PURE__ */React30.createElement(Box, {
    marginLeft: "6",
    paddingBottom: "10",
    paddingX: "18"
  }, /* @__PURE__ */React30.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: "18",
    weight: "heavy"
  }, "Connect a Wallet")), /* @__PURE__ */React30.createElement(Box, {
    className: ScrollClassName,
    paddingBottom: "18"
  }, Object.entries(groupedWallets).map(function (_ref32, index) {
    var _ref33 = _slicedToArray(_ref32, 2),
        groupName = _ref33[0],
        wallets2 = _ref33[1];

    return wallets2.length > 0 && /* @__PURE__ */React30.createElement(Fragment2, {
      key: index
    }, groupName ? /* @__PURE__ */React30.createElement(Box, {
      marginBottom: "8",
      marginTop: "16",
      marginX: "6"
    }, /* @__PURE__ */React30.createElement(Text, {
      color: "modalTextSecondary",
      size: "14",
      weight: "bold"
    }, groupName)) : null, /* @__PURE__ */React30.createElement(Box, {
      display: "flex",
      flexDirection: "column",
      gap: "4"
    }, wallets2.map(function (wallet) {
      return /* @__PURE__ */React30.createElement(ModalSelection, {
        currentlySelected: wallet.id === selectedOptionId,
        key: wallet.id,
        onClick: function onClick() {
          return onSelectWallet(wallet);
        }
      }, /* @__PURE__ */React30.createElement(Box, {
        color: wallet.id === selectedOptionId ? "actionButtonText" : "modalText",
        disabled: !wallet.ready,
        fontFamily: "body",
        fontSize: "16",
        fontWeight: "bold",
        transition: "default"
      }, /* @__PURE__ */React30.createElement(Box, {
        alignItems: "center",
        display: "flex",
        flexDirection: "row",
        gap: "12"
      }, /* @__PURE__ */React30.createElement(Box, {
        borderRadius: "6",
        height: "28",
        style: {
          background: "url(".concat(wallet.iconUrl, ")"),
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover"
        },
        width: "28"
      }, /* @__PURE__ */React30.createElement(Box, {
        borderColor: "actionButtonBorder",
        borderRadius: "6",
        borderStyle: "solid",
        borderWidth: "1",
        height: "full",
        width: "full"
      })), /* @__PURE__ */React30.createElement("div", null, wallet.name))));
    })));
  }))), !isMobile() && /* @__PURE__ */React30.createElement(React30.Fragment, null, /* @__PURE__ */React30.createElement(Box, {
    background: "generalBorder",
    minWidth: "1",
    width: "1"
  }), /* @__PURE__ */React30.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    margin: "16",
    style: {
      flexGrow: 1
    }
  }, /* @__PURE__ */React30.createElement(Box, {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "12"
  }, /* @__PURE__ */React30.createElement(Box, {
    width: "28"
  }, headerBackButtonLink && /* @__PURE__ */React30.createElement(Box, {
    as: "button",
    color: "accentColor",
    onClick: function onClick() {
      return headerBackButtonLink && setWalletStep(headerBackButtonLink);
    },
    paddingX: "8",
    paddingY: "4",
    style: {
      boxSizing: "content-box",
      height: 17,
      willChange: "transform"
    },
    transform: {
      active: "shrinkSm",
      hover: "growLg"
    },
    transition: "default"
  }, /* @__PURE__ */React30.createElement(BackIcon, null))), /* @__PURE__ */React30.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    style: {
      flexGrow: 1
    }
  }, headerLabel && /* @__PURE__ */React30.createElement(Text, {
    color: "modalText",
    size: "18",
    weight: "heavy"
  }, headerLabel)), /* @__PURE__ */React30.createElement(CloseButton, {
    onClose: onClose
  })), /* @__PURE__ */React30.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    style: {
      minHeight: 432
    }
  }, /* @__PURE__ */React30.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: "6",
    height: "full",
    justifyContent: "center",
    marginTop: "6",
    marginX: "8"
  }, walletContent)))));
} // src/components/ConnectOptions/MobileOptions.tsx


import React31, { useCallback as useCallback4, useContext as useContext4, useState as useState5 } from "react"; // src/components/ConnectOptions/MobileOptions.css.ts

var scroll = "MobileOptions__1am14410"; // src/components/ConnectOptions/MobileOptions.tsx

function WalletButton(_ref34) {
  var wallet = _ref34.wallet;
  var connect = wallet.connect,
      iconUrl = wallet.iconUrl,
      id = wallet.id,
      mobile = wallet.mobile,
      name = wallet.name,
      ready = wallet.ready,
      shortName = wallet.shortName;
  var getMobileUri = mobile == null ? void 0 : mobile.getUri;
  return /* @__PURE__ */React31.createElement(Box, {
    as: "button",
    color: ready ? "modalText" : "modalTextSecondary",
    disabled: !ready,
    fontFamily: "body",
    key: id,
    onClick: useCallback4(function () {
      connect == null ? void 0 : connect();

      if (getMobileUri) {
        setTimeout(function () {
          window.location.href = getMobileUri();
        }, 0);
      }
    }, [connect, getMobileUri]),
    style: {
      overflow: "visible",
      textAlign: "center"
    },
    type: "button",
    width: "full"
  }, /* @__PURE__ */React31.createElement(Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  }, /* @__PURE__ */React31.createElement(Box, {
    borderRadius: "13",
    display: "block",
    height: "60",
    marginBottom: "8",
    style: {
      background: "url(".concat(iconUrl, ")"),
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      touchCallout: "none",
      userSelect: "none"
    },
    width: "60"
  }, /* @__PURE__ */React31.createElement(Box, {
    borderColor: "actionButtonBorder",
    borderRadius: "13",
    borderStyle: "solid",
    borderWidth: "1",
    height: "full",
    width: "full"
  })), /* @__PURE__ */React31.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    gap: "1"
  }, /* @__PURE__ */React31.createElement(Text, {
    as: "h2",
    color: wallet.ready ? "modalText" : "modalTextSecondary",
    size: "13",
    weight: "medium"
  }, /* @__PURE__ */React31.createElement(Box, {
    as: "span",
    position: "relative"
  }, shortName != null ? shortName : name, !wallet.ready && " (unsupported)")), wallet.recent && /* @__PURE__ */React31.createElement(Text, {
    color: "accentColor",
    size: "12",
    weight: "medium"
  }, "Recent"))));
}

function MobileOptions(_ref35) {
  var onClose = _ref35.onClose;

  var _a;

  var titleId = "rk_connect_title";
  var wallets = useWalletConnectors();
  var learnMoreUrl = useContext4(LearnMoreUrlContext);
  var headerLabel = null;
  var walletContent = null;
  var headerBackgroundContrast = false;
  var headerBackButtonLink = null;

  var _useState15 = useState5("CONNECT"
  /* Connect */
  ),
      _useState16 = _slicedToArray(_useState15, 2),
      walletStep = _useState16[0],
      setWalletStep = _useState16[1];

  var ios = isIOS();

  switch (walletStep) {
    case "CONNECT"
    /* Connect */
    :
      {
        headerLabel = "Connect a Wallet";
        headerBackgroundContrast = true;
        walletContent = /* @__PURE__ */React31.createElement(React31.Fragment, null, /* @__PURE__ */React31.createElement(Box, {
          background: "profileForeground",
          className: scroll,
          display: "flex",
          paddingBottom: "20",
          paddingTop: "6"
        }, /* @__PURE__ */React31.createElement(Box, {
          display: "flex",
          style: {
            margin: "0 auto"
          }
        }, wallets.filter(function (wallet) {
          return wallet.ready;
        }).map(function (wallet) {
          return /* @__PURE__ */React31.createElement(Box, {
            key: wallet.id,
            paddingX: "20"
          }, /* @__PURE__ */React31.createElement(Box, {
            width: "60"
          }, /* @__PURE__ */React31.createElement(WalletButton, {
            wallet: wallet
          })));
        }))), /* @__PURE__ */React31.createElement(Box, {
          background: "generalBorder",
          height: "1",
          marginBottom: "32"
        }), /* @__PURE__ */React31.createElement(Box, {
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "32",
          paddingX: "32",
          style: {
            textAlign: "center"
          }
        }, /* @__PURE__ */React31.createElement(Box, {
          display: "flex",
          flexDirection: "column",
          gap: "8"
        }, /* @__PURE__ */React31.createElement(Text, {
          color: "modalText",
          size: "16",
          weight: "bold"
        }, "What is a Wallet?"), /* @__PURE__ */React31.createElement(Text, {
          color: "modalTextSecondary",
          size: "16"
        }, "A wallet is used to send, receive, store, and display digital assets. It\u2019s also a new way to log in, without needing to create new accounts and passwords on\xA0every\xA0website.")), /* @__PURE__ */React31.createElement(Box, {
          display: "flex",
          gap: "14",
          justifyContent: "center"
        }, /* @__PURE__ */React31.createElement(ActionButton, {
          label: "Get a Wallet",
          onClick: function onClick() {
            return setWalletStep("GET"
            /* Get */
            );
          },
          size: "large",
          type: "secondary"
        }), /* @__PURE__ */React31.createElement(ActionButton, {
          href: learnMoreUrl,
          label: "Learn More",
          size: "large",
          type: "secondary"
        }))));
        break;
      }

    case "GET"
    /* Get */
    :
      {
        headerLabel = "Get a Wallet";
        headerBackButtonLink = "CONNECT"
        /* Connect */
        ;
        var mobileWallets = (_a = wallets == null ? void 0 : wallets.filter(function (wallet) {
          var _a2, _b;

          return ((_a2 = wallet.downloadUrls) == null ? void 0 : _a2.ios) || ((_b = wallet.downloadUrls) == null ? void 0 : _b.android);
        })) == null ? void 0 : _a.splice(0, 3);
        walletContent = /* @__PURE__ */React31.createElement(React31.Fragment, null, /* @__PURE__ */React31.createElement(Box, {
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          height: "full",
          marginBottom: "36",
          marginTop: "5",
          paddingTop: "2",
          width: "full"
        }, mobileWallets.map(function (wallet, index) {
          var downloadUrls = wallet.downloadUrls,
              iconUrl = wallet.iconUrl,
              name = wallet.name;

          if (!(downloadUrls == null ? void 0 : downloadUrls.ios) && !(downloadUrls == null ? void 0 : downloadUrls.android)) {
            return null;
          }

          return /* @__PURE__ */React31.createElement(Box, {
            display: "flex",
            gap: "16",
            key: wallet.id,
            paddingX: "20",
            width: "full"
          }, /* @__PURE__ */React31.createElement(Box, {
            borderRadius: "10",
            height: "48",
            minWidth: "48",
            style: {
              background: "url(".concat(iconUrl, ")"),
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              touchCallout: "none",
              userSelect: "none"
            },
            width: "48"
          }, /* @__PURE__ */React31.createElement(Box, {
            borderColor: "actionButtonBorder",
            borderRadius: "10",
            borderStyle: "solid",
            borderWidth: "1",
            height: "full",
            width: "full"
          })), /* @__PURE__ */React31.createElement(Box, {
            display: "flex",
            flexDirection: "column",
            width: "full"
          }, /* @__PURE__ */React31.createElement(Box, {
            alignItems: "center",
            display: "flex",
            height: "48"
          }, /* @__PURE__ */React31.createElement(Box, {
            width: "full"
          }, /* @__PURE__ */React31.createElement(Text, {
            color: "modalText",
            size: "18",
            weight: "bold"
          }, name)), /* @__PURE__ */React31.createElement(ActionButton, {
            href: ios ? downloadUrls == null ? void 0 : downloadUrls.ios : downloadUrls == null ? void 0 : downloadUrls.android,
            label: "GET",
            size: "small",
            type: "secondary"
          })), index < mobileWallets.length - 1 && /* @__PURE__ */React31.createElement(Box, {
            background: "generalBorderDim",
            height: "1",
            marginY: "10",
            width: "full"
          })));
        })), /* @__PURE__ */React31.createElement(Box, {
          style: {
            marginBottom: "42px"
          }
        }), /* @__PURE__ */React31.createElement(Box, {
          alignItems: "center",
          display: "flex",
          flexDirection: "column",
          gap: "36",
          paddingX: "36",
          style: {
            textAlign: "center"
          }
        }, /* @__PURE__ */React31.createElement(Box, {
          display: "flex",
          flexDirection: "column",
          gap: "12"
        }, /* @__PURE__ */React31.createElement(Text, {
          color: "modalText",
          size: "16",
          weight: "bold"
        }, "Not what you\u2019re looking for?"), /* @__PURE__ */React31.createElement(Text, {
          color: "modalTextSecondary",
          size: "16"
        }, "Select a wallet on the main screen to get started with a different wallet provider."))));
        break;
      }
  }

  return /* @__PURE__ */React31.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    paddingBottom: "36"
  }, /* @__PURE__ */React31.createElement(Box, {
    background: headerBackgroundContrast ? "profileForeground" : "modalBackground",
    display: "flex",
    flexDirection: "column",
    paddingBottom: "14",
    paddingTop: "14"
  }, /* @__PURE__ */React31.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    paddingBottom: "6",
    paddingX: "20",
    position: "relative"
  }, headerBackButtonLink && /* @__PURE__ */React31.createElement(Box, {
    display: "flex",
    position: "absolute",
    style: {
      left: 0,
      marginBottom: -20,
      marginTop: -20
    }
  }, /* @__PURE__ */React31.createElement(Box, {
    alignItems: "center",
    as: "button",
    color: "accentColor",
    display: "flex",
    marginLeft: "4",
    marginTop: "20",
    onClick: function onClick() {
      return setWalletStep(headerBackButtonLink);
    },
    padding: "16",
    style: {
      height: 17,
      willChange: "transform"
    },
    transform: {
      active: "shrinkSm",
      hover: "growLg"
    },
    transition: "default"
  }, /* @__PURE__ */React31.createElement(BackIcon, null))), /* @__PURE__ */React31.createElement(Box, {
    marginTop: "4",
    style: {
      textAlign: "center"
    },
    width: "full"
  }, /* @__PURE__ */React31.createElement(Text, {
    as: "h1",
    color: "modalText",
    id: titleId,
    size: "20",
    weight: "bold"
  }, headerLabel)), /* @__PURE__ */React31.createElement(Box, {
    alignItems: "center",
    display: "flex",
    height: "32",
    paddingRight: "14",
    position: "absolute",
    right: "0"
  }, /* @__PURE__ */React31.createElement(Box, {
    style: {
      marginBottom: -20,
      marginTop: -20
    }
  }, /* @__PURE__ */React31.createElement(CloseButton, {
    onClose: onClose
  }))))), /* @__PURE__ */React31.createElement(Box, {
    display: "flex",
    flexDirection: "column"
  }, walletContent));
} // src/components/ConnectOptions/ConnectOptions.tsx


function ConnectOptions(_ref36) {
  var onClose = _ref36.onClose;
  return isMobile() ? /* @__PURE__ */React32.createElement(MobileOptions, {
    onClose: onClose
  }) : /* @__PURE__ */React32.createElement(DesktopOptions, {
    onClose: onClose
  });
} // src/components/ConnectModal/ConnectModal.tsx


function ConnectModal(_ref37) {
  var onClose = _ref37.onClose,
      open = _ref37.open;
  var titleId = "rk_connect_title";

  var _useAccount = useAccount(),
      _useAccount2 = _slicedToArray(_useAccount, 1),
      connectData = _useAccount2[0].data;

  return !connectData ? /* @__PURE__ */React33.createElement(Dialog, {
    onClose: onClose,
    open: open,
    titleId: titleId
  }, /* @__PURE__ */React33.createElement(DialogContent, {
    bottomSheetOnMobile: true,
    padding: "0",
    wide: true
  }, /* @__PURE__ */React33.createElement(ConnectOptions, {
    onClose: onClose
  }))) : null;
} // src/components/ConnectButton/ConnectButtonRenderer.tsx


var useBooleanState = function useBooleanState(initialValue) {
  var _useState17 = useState6(initialValue),
      _useState18 = _slicedToArray(_useState17, 2),
      value = _useState18[0],
      setValue = _useState18[1];

  var setTrue = useCallback5(function () {
    return setValue(true);
  }, []);
  var setFalse = useCallback5(function () {
    return setValue(false);
  }, []);
  return {
    setFalse: setFalse,
    setTrue: setTrue,
    value: value
  };
};

function ConnectButtonRenderer(_ref38) {
  var children = _ref38.children;

  var _a, _b, _c, _d, _e, _f, _g;

  var isMounted = useIsMounted();

  var _useAccount3 = useAccount2({
    fetchEns: true
  }),
      _useAccount4 = _slicedToArray(_useAccount3, 2),
      accountData = _useAccount4[0].data,
      disconnect = _useAccount4[1];

  var _useBalance = useBalance({
    addressOrName: accountData == null ? void 0 : accountData.address
  }),
      _useBalance2 = _slicedToArray(_useBalance, 1),
      balanceData = _useBalance2[0].data;

  var _useNetwork = useNetwork2(),
      _useNetwork2 = _slicedToArray(_useNetwork, 2),
      networkData = _useNetwork2[0].data,
      switchNetwork = _useNetwork2[1];

  var rainbowkitChainsById = useRainbowKitChainsById();
  var chainIconUrl = networkData.chain ? (_b = (_a = rainbowkitChainsById[networkData.chain.id]) == null ? void 0 : _a.iconUrl) != null ? _b : void 0 : void 0;

  var _useBooleanState = useBooleanState(false),
      closeConnectModal = _useBooleanState.setFalse,
      openConnectModal = _useBooleanState.setTrue,
      connectModalOpen = _useBooleanState.value;

  var _useBooleanState2 = useBooleanState(false),
      closeAccountModal = _useBooleanState2.setFalse,
      openAccountModal = _useBooleanState2.setTrue,
      accountModalOpen = _useBooleanState2.value;

  var _useBooleanState3 = useBooleanState(false),
      closeChainModal = _useBooleanState3.setFalse,
      openChainModal = _useBooleanState3.setTrue,
      chainModalOpen = _useBooleanState3.value;

  var hasAccountData = Boolean(accountData);
  useEffect7(function () {
    closeConnectModal();
    closeAccountModal();
    closeChainModal();
  }, [hasAccountData, closeConnectModal, closeAccountModal, closeChainModal]);

  if (!isMounted) {
    return null;
  }

  var displayBalance = balanceData ? "".concat(Number(balanceData.formatted).toPrecision(3), " ").concat(balanceData.symbol) : void 0;
  return /* @__PURE__ */React34.createElement(React34.Fragment, null, children({
    account: accountData ? {
      address: accountData.address,
      balanceDecimals: balanceData == null ? void 0 : balanceData.decimals,
      balanceFormatted: balanceData == null ? void 0 : balanceData.formatted,
      balanceSymbol: balanceData == null ? void 0 : balanceData.symbol,
      displayBalance: displayBalance,
      displayName: (_d = (_c = accountData.ens) == null ? void 0 : _c.name) != null ? _d : formatAddress(accountData.address),
      ensAvatar: (_f = (_e = accountData.ens) == null ? void 0 : _e.avatar) != null ? _f : void 0,
      ensName: (_g = accountData.ens) == null ? void 0 : _g.name
    } : void 0,
    accountModalOpen: accountModalOpen,
    chain: (networkData == null ? void 0 : networkData.chain) ? {
      iconUrl: chainIconUrl,
      id: networkData.chain.id,
      name: networkData.chain.name,
      unsupported: networkData.chain.unsupported
    } : void 0,
    chainModalOpen: chainModalOpen,
    connectModalOpen: connectModalOpen,
    openAccountModal: openAccountModal,
    openChainModal: openChainModal,
    openConnectModal: openConnectModal
  }), /* @__PURE__ */React34.createElement(ConnectModal, {
    onClose: closeConnectModal,
    open: connectModalOpen
  }), /* @__PURE__ */React34.createElement(AccountModal, {
    accountData: accountData,
    balanceData: balanceData,
    onClose: closeAccountModal,
    onDisconnect: disconnect,
    open: accountModalOpen
  }), /* @__PURE__ */React34.createElement(ChainModal, {
    networkData: networkData,
    onClose: closeChainModal,
    onSwitchNetwork: switchNetwork,
    open: chainModalOpen
  }));
}

ConnectButtonRenderer.displayName = "ConnectButton.Custom"; // src/components/ConnectButton/ConnectButton.tsx

var defaultProps = {
  accountStatus: "full",
  chainStatus: {
    largeScreen: "full",
    smallScreen: "icon"
  },
  showBalance: {
    largeScreen: true,
    smallScreen: false
  }
};

function ConnectButton(_ref39) {
  var _ref39$accountStatus = _ref39.accountStatus,
      accountStatus = _ref39$accountStatus === void 0 ? defaultProps.accountStatus : _ref39$accountStatus,
      _ref39$chainStatus = _ref39.chainStatus,
      chainStatus = _ref39$chainStatus === void 0 ? defaultProps.chainStatus : _ref39$chainStatus,
      _ref39$showBalance = _ref39.showBalance,
      showBalance = _ref39$showBalance === void 0 ? defaultProps.showBalance : _ref39$showBalance;
  return /* @__PURE__ */React35.createElement(ConnectButtonRenderer, null, function (_ref40) {
    var account = _ref40.account,
        chain = _ref40.chain,
        connectModalOpen = _ref40.connectModalOpen,
        openAccountModal = _ref40.openAccountModal,
        openChainModal = _ref40.openChainModal,
        openConnectModal = _ref40.openConnectModal;

    var _a, _b;

    return account ? /* @__PURE__ */React35.createElement(Box, {
      display: "flex",
      gap: "12"
    }, chain && /* @__PURE__ */React35.createElement(Box, {
      alignItems: "center",
      as: "button",
      background: chain.unsupported ? "connectButtonBackgroundError" : "connectButtonBackground",
      borderRadius: "connectButton",
      boxShadow: "connectButton",
      color: chain.unsupported ? "connectButtonTextError" : "connectButtonText",
      display: mapResponsiveValue(chainStatus, function (value) {
        return value === "none" ? "none" : "flex";
      }),
      fontFamily: "body",
      fontWeight: "bold",
      gap: "6",
      onClick: openChainModal,
      paddingX: "10",
      paddingY: "8",
      transform: {
        active: "shrink",
        hover: "grow"
      },
      transition: "default",
      type: "button"
    }, chain.unsupported ? /* @__PURE__ */React35.createElement(Box, null, "Invalid network") : /* @__PURE__ */React35.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "6"
    }, chain.iconUrl ? /* @__PURE__ */React35.createElement(Box, {
      alt: (_a = chain.name) != null ? _a : "Chain icon",
      as: "img",
      display: mapResponsiveValue(chainStatus, function (value) {
        return value === "full" || value === "icon" ? "block" : "none";
      }),
      height: "24",
      src: chain.iconUrl,
      width: "24"
    }) : null, /* @__PURE__ */React35.createElement(Box, {
      display: mapResponsiveValue(chainStatus, function (value) {
        if (value === "icon" && !chain.iconUrl) {
          return "block";
        }

        return value === "full" || value === "name" ? "block" : "none";
      })
    }, (_b = chain.name) != null ? _b : chain.id)), /* @__PURE__ */React35.createElement(DropdownIcon, null)), /* @__PURE__ */React35.createElement(Box, {
      alignItems: "center",
      as: "button",
      background: "connectButtonBackground",
      borderRadius: "connectButton",
      boxShadow: "connectButton",
      color: "connectButtonText",
      display: "flex",
      fontFamily: "body",
      fontWeight: "bold",
      onClick: openAccountModal,
      transform: {
        active: "shrink",
        hover: "grow"
      },
      transition: "default",
      type: "button"
    }, account.displayBalance && /* @__PURE__ */React35.createElement(Box, {
      display: mapResponsiveValue(showBalance, function (value) {
        return value ? "block" : "none";
      }),
      padding: "8",
      paddingLeft: "12"
    }, account.displayBalance), /* @__PURE__ */React35.createElement(Box, {
      background: "connectButtonInnerBackground",
      borderColor: "connectButtonBackground",
      borderRadius: "connectButton",
      borderStyle: "solid",
      borderWidth: "2",
      color: "connectButtonText",
      fontFamily: "body",
      fontWeight: "bold",
      paddingX: "8",
      paddingY: "6",
      transition: "default"
    }, /* @__PURE__ */React35.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "6",
      height: "24"
    }, /* @__PURE__ */React35.createElement(Box, {
      display: mapResponsiveValue(accountStatus, function (value) {
        return value === "full" || value === "avatar" ? "block" : "none";
      })
    }, /* @__PURE__ */React35.createElement(Avatar, {
      address: account.address,
      imageUrl: account.ensAvatar,
      size: 24
    })), /* @__PURE__ */React35.createElement(Box, {
      alignItems: "center",
      display: "flex",
      gap: "6"
    }, /* @__PURE__ */React35.createElement(Box, {
      display: mapResponsiveValue(accountStatus, function (value) {
        return value === "full" || value === "address" ? "block" : "none";
      })
    }, account.displayName), /* @__PURE__ */React35.createElement(DropdownIcon, null)))))) : /* @__PURE__ */React35.createElement(Box, {
      background: "connectButtonBackground",
      borderRadius: "connectButton",
      transform: {
        active: "shrink",
        hover: "grow"
      },
      transition: "default"
    }, /* @__PURE__ */React35.createElement(Box, {
      as: "button",
      background: "connectButtonInnerBackground",
      borderColor: connectModalOpen ? "accentColor" : "connectButtonBackground",
      borderRadius: "connectButton",
      borderStyle: "solid",
      borderWidth: "2",
      boxShadow: "connectButton",
      color: "connectButtonText",
      fontFamily: "body",
      fontWeight: "bold",
      onClick: openConnectModal,
      padding: "8",
      type: "button"
    }, "Connect Wallet"));
  });
}

ConnectButton.__defaultProps = defaultProps;
ConnectButton.Custom = ConnectButtonRenderer;
export { cssObjectFromTheme, cssStringFromTheme, RainbowKitProvider, isAndroid, isIOS, isMobile, ConnectButton };